{
  "meta": {
    "title": "BuddyPro Launchpad"
  },
  "common": {
    "brandAlt": "BuddyPro",
    "loading": "Loading...",
    "error": "Something got stuck. Please try again.",
    "actionError": {
      "questionnaire_locked": "This step has not opened yet. Finish the step before it and the questionnaire unlocks on its own.",
      "profile_confirmation_required": "Review your profile and confirm it first. The questionnaire opens right after.",
      "too_many_accounts": "Six accounts is the limit, so this one cannot be added. Write to your partner about which account to swap.",
      "capacity_reached": "There are no free seats left for colleagues. Cancel a pending invite, or write to your partner.",
      "state_conflict": "This step moved in the meantime. Reload the page to see where it stands now.",
      "salespage_approval_required": "The sales page has to be approved first. Open the Sales page step and go through it.",
      "trial_not_ready": "Your trial Buddy is not ready yet. We are preparing it and will let you know.",
      "tester_before_transfer": "You can send it as a tester note once the bot is yours. Send it as your own for now.",
      "duns_required": "Confirm the D-U-N-S number first. Apple will not take the registration without it.",
      "invalid_request": "Something in the form does not fit. Check the fields and send it again.",
      "forbidden": "This action is not yours to make. Write to your partner and they will do it for you.",
      "not_found": "This is no longer here. Reload the page.",
      "rate_limited": "Too many attempts in a row. Wait a moment and try again.",
      "server": "The server gave no answer. Please try again in a moment.",
      "offline": "This looks like a connection drop. Check your internet and try again.",
      "generic": "Something got stuck. Please try again.",
      "owner_role_pending": "We are still setting your owner role. We will let you know as soon as it is done, and then you can finish step 3.",
      "ownership_transferred": "The instance has been handed over. We can no longer configure it, you look after it yourself now."
    },
    "retry": "Try Again",
    "logout": "Log out",
    "backHome": "Back to overview",
    "languageLabel": "Interface language",
    "languageCs": "Čeština",
    "languageEn": "English",
    "close": "Close",
    "cancel": "Cancel"
  },
  "login": {
    "eyebrow": "Your done-for-you Buddy",
    "title": "Your Buddy starts here",
    "description": "Enter your email and we'll send you a secure sign-in link.",
    "emailLabel": "Email",
    "emailPlaceholder": "you@example.com",
    "submit": "Send a login link",
    "submitting": "Sending the link...",
    "accepted": "Within a minute you get an e-mail: either your sign-in link, or a note that this address has no account. Nothing came? Check the address is spelled right.",
    "privacy": "For your safety, we will not reveal whether the email is in the system.",
    "tryAnother": "Use another e-mail"
  },
  "landing": {
    "loginEyebrow": "Your Launchpad",
    "loginTitle": "Keep building your Buddy",
    "loginDescription": "Open Launchpad and see what comes next.",
    "loginSubmit": "Open Launchpad",
    "inviteEyebrow": "Team invitation",
    "inviteTitle": "Join the Launchpad",
    "inviteDescription": "After accepting, you can represent the client while their Buddy is built. The owner still manages invites, price approval, and handover.",
    "inviteSubmit": "Accept invitation",
    "clientLabel": "Choose a client",
    "signingIn": "Signing you in...",
    "invalid": "This link is not valid.",
    "unavailable": "This link can no longer be used. Request a new one.",
    "clientUnavailable": "This link is no longer valid. It may have expired, been used, or been revoked. Ask your partner to send you a new one.",
    "clientLinkExpiredStep": "This email link is no longer valid. Sign in with your address and we will take you to the exact place it led to.",
    "errorEyebrow": "Sign in failed",
    "supersededEyebrow": "Sign in",
    "supersededTitle": "A newer email replaced this link",
    "supersededCopy": "We sent you a newer sign-in email, and that retired the older link. Open the newest message from us in your inbox and sign in with the link inside it.",
    "errorTitle": "We could not open this link",
    "errorSecurity": "We could not verify the form. Open the original link and try again.",
    "errorRateLimited": "There have been too many attempts. Try again in a moment.",
    "errorGeneric": "Sign in failed. Open the original link and try again.",
    "errorBack": "Back to sign in"
  },
  "unlock": {
    "eyebrow": "Unlocking the next step",
    "title": "Your code is ready",
    "description": "Sign in to Launchpad first. After signing in we bring you back here and you confirm the code with one click.",
    "open": "Open Launchpad",
    "confirmTitle": "Confirm the call code",
    "confirmDescription": "The code unlocks the next step for this account:",
    "confirmSubmit": "Unlock the next step",
    "backHome": "Back to Launchpad",
    "staffTitle": "You are signed in as a team member",
    "staffDescription": "Only the client can confirm a call code. Open the console and use Open as client, or sign in with the client account.",
    "unavailableTitle": "This code is no longer valid",
    "unavailableDescription": "The code was revoked or expired. Ask the team for a new one.",
    "errorTitle": "The code could not be used",
    "errorUnauthorized": "Your session expired in the meantime. Open Launchpad, sign in, and enter the code again.",
    "errorConflict": "This code cannot be used right now. You can find your current step in Launchpad.",
    "errorImpersonation": "A code cannot be confirmed in the client preview. Return to the console and sign in with the client account.",
    "openingTitle": "Your next step is opening",
    "openingDescription": "You'll see what's next and exactly what you need to do.",
    "kind": {
      "onboarding": "Intro video",
      "marketing": "Marketing video"
    },
    "globalStaffTitle": "This used to be the unlock link from the call",
    "globalStaffDescription": "It no longer opens the step for clients: both video steps unlock by watching the video inside Launchpad.",
    "globalAdminHint": "You change the password in the link in Servis, under Link to the call step.",
    "globalAheadTitle": "This call is already behind you",
    "globalAheadDescription": "The step this link opens is already open for you. Launchpad shows what is on your plate now.",
    "globalEarlyTitle": "This link belongs to a later call",
    "globalEarlyDescription": "The link opens a step you have not reached yet. Open Launchpad to see what comes next.",
    "videoGateTitle": "This step opens by video",
    "videoGateDescription": "Group calls are gone. The step opens right in Launchpad once you watch the video to the unlock moment.",
    "videoGateOpen": "Open the video in Launchpad"
  },
  "dashboard": {
    "eyebrow": "BuddyPro Launchpad",
    "title": "Your process is ready",
    "description": "The next steps will show what needs your attention and what the team is working on.",
    "signedInAs": "Signed in account",
    "processLabel": "Progress",
    "accessStep": "Access",
    "accessDone": "Done",
    "processStep": "Process",
    "processNext": "Ready",
    "deliveryStep": "Handover",
    "deliveryLocked": "Later",
    "mainLabel": "Current status",
    "mainTitle": "You have access. We can begin.",
    "mainCopy": "More content will open as the shared process moves forward. You do not need to do anything else right now.",
    "workingTitle": "The team is preparing the next step",
    "workingCopy": "When it is ready, you will see it here and receive an email.",
    "contextLabel": "Context",
    "switchLabel": "Switch client",
    "switchSubmit": "Switch",
    "switching": "Switching...",
    "sessionLabel": "Security",
    "skipLabel": "Skip links",
    "skipToContent": "Skip to content",
    "skipToAccount": "Skip to notifications and account"
  },
  "closedStep": {
    "continue": "Open your next step",
    "nextLead": "Up next:",
    "journeyComplete": "You have every step behind you.",
    "steps": {
      "onboarding_call": {
        "title": "The intro is behind you.",
        "benefit": "We share the same context and know what your Buddy needs to achieve."
      },
      "profile": {
        "title": "Your profile is ready.",
        "benefit": "Buddy now starts from a verified picture of you and your work."
      },
      "apple": {
        "title": "The first app steps are done.",
        "benefit": "We can prepare the app for an account that belongs to you."
      },
      "q1": {
        "title": "The Buddy preparation questionnaire is filled in.",
        "benefit": "Your answers are saved and we can start building your Buddy from them."
      },
      "knowhow": {
        "title": "Your know-how is complete.",
        "benefit": "The source material is ready for the first training."
      },
      "training": {
        "title": "Buddy's training is done.",
        "benefit": "The first version of your Buddy is ready to try."
      },
      "beta": {
        "title": "Your testers are invited.",
        "benefit": "The tester link and the chat with your Buddy stay open, so you can invite more."
      },
      "feedback": {
        "title": "The first feedback round is behind you.",
        "benefit": "We have applied what you learned during testing.",
        "ownershipBenefit": "The instance has been handed over, you look after it yourself now."
      },
      "marketing_call": {
        "title": "The marketing preparation is behind you.",
        "benefit": "The offer and the path to your first customers are clear."
      },
      "q2": {
        "title": "The sales questionnaire is filled in.",
        "benefit": "The source material for your sales assets is saved."
      },
      "strategy": {
        "title": "Your sales strategy is approved.",
        "benefit": "The remaining assets can now follow the direction you approved."
      },
      "salespage": {
        "title": "Your sales page is finished.",
        "benefit": "Approved, with order links in it, and published. You can still come back to it."
      },
      "payments": {
        "title": "Payments are set up.",
        "benefit": "Customer subscriptions go straight to your Stripe."
      },
      "emails": {
        "title": "Your email marketing is ready.",
        "benefit": "Your campaign has the messages it needs for your audience."
      },
      "webinar": {
        "title": "Your webinar structure is ready.",
        "benefit": "You have a clear outline for delivering your webinar."
      },
      "stripe": {
        "title": "Stripe is connected.",
        "benefit": "Payments for Buddy can now go directly to you."
      },
      "app_questionnaire": {
        "title": "The app questionnaire is filled in.",
        "benefit": "We have everything needed to prepare the app."
      },
      "salespage_publish": {
        "title": "Your sales page is live.",
        "benefit": "Customers can now open your offer."
      },
      "handover": {
        "title": "Buddy is officially yours.",
        "benefit": "The access and source material are under your control."
      },
      "app_release": {
        "title": "Your app is live.",
        "benefit": "Links to both stores are ready to share."
      }
    }
  },
  "home": {
    "eyebrow": "Your progress",
    "title": "Let's build a Buddy that sells",
    "overviewLabel": "Process overview",
    "primaryEyebrow": "Your next step",
    "currentStep": "Current step",
    "waiting": "The team is working now",
    "waitingCopy": "When we need something from you, one clear next step will appear here.",
    "openHome": "Open overview",
    "unlockedTitle": "On to the next one!",
    "unlockedQ1": "The code works. The questionnaire about you and your business is unlocked, you can start right away.",
    "unlockedQ2": "The code works. The marketing questionnaire is unlocked, you can start right away.",
    "unlockedAlready": "You already used this code. Your current step is below.",
    "welcomeTitle": "Here's how we'll build your Buddy",
    "welcomeIntro": "Two chapters lie ahead: first we build your Buddy together, then its sale. Each next step opens once the previous one is done.",
    "welcomeIntroCollaborator": "Two chapters lie ahead: building the Buddy and preparing the sale. Each next step opens once the previous one is done. You are helping with the build; at the end the Buddy is ready to sell.",
    "welcomeCta": "Let's do this",
    "returningTitle": "Welcome back",
    "returningIntro": "Your work so far is saved. You can continue where you left off: {step}.",
    "returningIntroCollaborator": "The work so far is saved. You can continue where you left off: {step}.",
    "returningCta": "Continue",
    "workingEyebrow": "Work in progress",
    "working": {
      "q1": {
        "title": "Building your Buddy foundation",
        "copy": "We are reviewing your answers and turning them into the brief we will use to build your Buddy."
      },
      "training": {
        "title": "Training your Buddy",
        "copy": "We are teaching Buddy your expertise, fine tuning its voice and behavior, and will then prepare it for your first test."
      },
      "beta": {
        "title": "Applying your feedback",
        "copy": "We are reviewing your test results, improving Buddy based on your feedback, and will then verify that everything works as intended."
      },
      "q2": {
        "title": "Reviewing your sales brief",
        "copy": "We are reviewing your sales brief, identifying the strongest angles, and preparing the foundation for your complete sales package."
      },
      "sales": {
        "title": "Creating your sales package",
        "copy": "We are creating your audit, sales strategy, page, emails and avatar, then we will bring everything together into one complete system."
      },
      "handover": {
        "title": "Finalizing your handover",
        "copy": "We are setting your owner role, preparing access, and checking the final details so everything is ready for a smooth handover."
      },
      "knowhow": {
        "title": "The team is working now",
        "copy": "When we need something from you, one clear next step will appear here."
      },
      "onboarding_call": {
        "title": "The team is working now",
        "copy": "When we need something from you, one clear next step will appear here."
      },
      "marketing_call": {
        "title": "The team is working now",
        "copy": "When we need something from you, one clear next step will appear here."
      },
      "stripe": {
        "title": "Connecting payments",
        "copy": "We are setting up Stripe so customer subscriptions land directly in your account."
      }
    },
    "guide": {
      "step2Title": "Your Progress, Step by Step",
      "step2Copy": "Your full progress is on the left. New steps will unlock as we complete the previous ones together.",
      "step3Title": "Your Guide Is Always Here",
      "step3Copy": "Your personal guide is on the right. Reach out whenever you're unsure what to do next.",
      "step4Title": "Start Today",
      "step4Copy": "Your first tasks are waiting below. Each one brings your Buddy closer to launch.",
      "next": "Next",
      "back": "Back",
      "skip": "Skip",
      "step2CopyMobile": "Your whole journey lives in the expandable menu at the top. Next steps unlock as we finish the previous ones together.",
      "step3CopyMobile": "Your partner's card sits below the page content. Reach out whenever you are not sure what to do next.",
      "step4CopyMobile": "Your current task is right in the main area. Each one you finish moves your Buddy closer to launch."
    },
    "phaseTitles": {
      "onboarding_call": "First we get to know you and your business",
      "q1": "Give Buddy a clear brief",
      "knowhow": "Upload everything Buddy should know",
      "training": "Now we teach Buddy to speak for you",
      "beta": "Test Buddy in a real chat",
      "marketing_call": "Let's plan how Buddy brings customers",
      "q2": "Show us how you sell today",
      "sales": "Building everything Buddy will sell with",
      "handover": "Buddy is ready to go out into the world",
      "stripe": "Connect payments to your account"
    },
    "finished": {
      "eyebrow": "Done",
      "title": "You have it! Buddy is yours and selling",
      "copy": "The whole package is handed over: the bot is yours, the sales materials are live and payments go straight to you. Everything stays here whenever you want to come back.",
      "action": "Open the sales materials",
      "returnsTitle": "Where you can go back",
      "returnsLabel": "Finished steps",
      "pageTitle": "Buddy sells for you",
      "titleSalesOnly": "Done. The sales package is yours",
      "copySalesOnly": "The strategy, sales page, emails and webinar are finished and they are yours to use. Everything stays here whenever you want to come back to it.",
      "pageTitleSalesOnly": "Your sales package is ready"
    },
    "review": {
      "eyebrow": "For review",
      "action": "Open for review",
      "strategy": {
        "title": "The sales strategy proposal is waiting for your review",
        "copy": "The proposal, including pricing and plans, is ready. Go through it, add comments, or approve it right away."
      },
      "salespage": {
        "title": "The sales page is waiting for your review",
        "copy": "The page is ready. Go through the content and the design, add comments, or approve it right away."
      },
      "emails": {
        "title": "The sales emails are waiting for your review",
        "copy": "The email series is ready. Go through it, add comments, or approve it right away."
      },
      "webinar": {
        "title": "The webinar structure is waiting for your review",
        "copy": "The structure is ready. Go through it, add comments, or approve it right away."
      }
    }
  },
  "states": {
    "locked": "Locked",
    "next": "Up next",
    "working": "In progress",
    "workingBeta": "You are testing",
    "workingKnowhow": "Your move",
    "done": "Done"
  },
  "sections": {
    "home": {
      "title": "Home",
      "unlockCondition": "Home is always available.",
      "action": "Open overview",
      "actionCopy": "See the current state."
    },
    "onboarding_call": {
      "title": "Intro video",
      "unlockCondition": "Available from the start.",
      "action": "Play the video",
      "actionCopy": "Watch the intro video. We will show you the whole process and explain what we will need from you.",
      "unlocksNote": "At the right moment the video opens your next step: the Buddy preparation questionnaire.",
      "videoActionCopy": "Watch the intro video. It walks you through the whole process and what we will need from you.",
      "existingVideoActionCopy": "Your Buddy already lives. Watch the intro video: it shows how we will tune it together and what we will need from you.",
      "existingUnlocksNote": "At the right moment the video opens your next step: the questionnaire that gives your Buddy your voice, your boundaries and your know-how."
    },
    "q1": {
      "title": "Questionnaire for preparing your Buddy",
      "unlockCondition": "Opens once you play the intro video and confirm your profile.",
      "action": "Answer the questions",
      "actionCopy": "Your answers show us how your Buddy should speak, help people, and use your expertise."
    },
    "knowhow": {
      "title": "Know-how",
      "unlockCondition": "Unlocks after the brief is complete.",
      "action": "Open source folder",
      "actionCopy": "Upload your sources to the prepared folder."
    },
    "training": {
      "title": "Training",
      "unlockCondition": "Starts after you confirm your know-how.",
      "action": "View status",
      "actionCopy": "See how the team is processing your sources."
    },
    "beta": {
      "title": "Beta testing",
      "unlockCondition": "Unlocks after training is complete.",
      "action": "Try your Buddy",
      "actionCopy": "Test your finished Buddy in real situations."
    },
    "marketing_call": {
      "title": "Marketing video",
      "unlockCondition": "Unlocks after training is complete.",
      "action": "Play the video",
      "actionCopy": "Watch the video about selling your Buddy. We will show you how to think about sales, and the sales questionnaire opens at the right moment.",
      "unlocksNote": "At the right moment the video opens your next step: the sales questionnaire.",
      "videoActionCopy": "Watch the video about selling your Buddy. It shows you how to think about the launch, and the sales questionnaire opens at the end."
    },
    "q2": {
      "title": "Questionnaire for selling your Buddy",
      "unlockCondition": "Opens once you play the marketing video.",
      "action": "Complete your sales brief",
      "actionCopy": "Tell us about your offer, customers, and sales process. We'll use your answers to build the sales package for your Buddy."
    },
    "sales": {
      "title": "Sales materials",
      "unlockCondition": "The team starts after the sales brief is submitted.",
      "action": "Review the outputs",
      "actionCopy": "Go through the prepared sales package."
    },
    "handover": {
      "title": "Handover",
      "unlockCondition": "Starts after the sales brief is submitted.",
      "action": "Take ownership",
      "actionCopy": "Finish the handover and sign in to your Owner Dashboard."
    },
    "app": {
      "title": "Mobile app",
      "unlockCondition": "The process depends on your package.",
      "action": "Complete Apple account",
      "actionCopy": "Finish the steps required to publish the app."
    },
    "stripe": {
      "title": "Stripe connection",
      "unlockCondition": "Opens together with the sales materials.",
      "action": "Connect payments",
      "actionCopy": "Set up payments so customer subscriptions go straight to you."
    },
    "feedback": {
      "title": "Feedback"
    }
  },
  "call": {
    "eyebrow": "Your next shared call",
    "title": "Next session",
    "kind": {
      "onboarding": "Onboarding call",
      "marketing": "Marketing call"
    },
    "status": {
      "enrolled": "Enrolled",
      "attended": "Attendance confirmed",
      "watched_recording": "Recording watched"
    },
    "enroll": "Reserve a spot",
    "enrolling": "Reserving...",
    "openZoom": "Open Zoom",
    "zoomLater": "We will add the link here and let you know.",
    "cannotAttend": "Choose another option",
    "moveNextTerm": "Move my sign-up to the next date",
    "watchRecording": "Watch the recording",
    "bookPartner": "Book an extra call with your launch partner",
    "codeTitle": "Do you have a call code?",
    "codePlaceholder": "Enter the code and continue",
    "codeSubmit": "Unlock",
    "codeRequired": "Enter the code from the call.",
    "empty": "No suitable time is listed yet. Book a time directly with your partner.",
    "afterLinkNote": "The link from the call will take you straight to the next step.",
    "missedLead": "No problem. Watch the recording once it is ready, or book a one on one with your partner. You continue the same way.",
    "missedAfter": "Choose another option"
  },
  "video": {
    "gateNote": "At the right moment the next step opens right inside the video.",
    "gateNoteDone": "You have watched the video. The next step is open.",
    "firstWatchNote": "No skipping ahead on the first viewing. You can go back anytime.",
    "seekLocked": "Skipping ahead unlocks after the first full viewing.",
    "resumeNote": "The video picks up where it left off.",
    "completedBadge": "Watched",
    "continue": "Continue to the next step",
    "play": "Play",
    "pause": "Pause",
    "mute": "Mute",
    "unmute": "Unmute",
    "volume": "Volume",
    "fullscreen": "Fullscreen",
    "exitFullscreen": "Exit fullscreen",
    "progressLabel": "Video progress",
    "unlockOpenedTitle": "Your next step just opened.",
    "unlockOpenedCopy": "Finish the video, or continue right away.",
    "freeSeekNote": "You can now seek freely.",
    "preparingTitle": "The video is being prepared",
    "preparingCopy": "As soon as the team uploads it, this step opens here. Nothing to do right now.",
    "mediaErrorTitle": "The video did not load",
    "mediaErrorCopy": "This is on us, not on you. Try loading it again. If that does not help, write to your partner, the contact sits in the Your partner card.",
    "mediaErrorRetry": "Load the video again",
    "progressBlockedTitle": "Video progress is not being saved"
  },
  "partner": {
    "eyebrow": "Your partner",
    "role": "BuddyPro partner",
    "roleCopy": "Your partner keeps track of the whole process and helps you with every step. Reach out whenever you are not sure what to do next.",
    "book": "Book an extra call with your launch partner",
    "telegram": "Message on Telegram",
    "contactCopy": "You can email your partner or book time for a call.",
    "bookingCopy": "Book time for a call whenever you want to talk something through.",
    "assigningTitle": "We are matching you with a partner",
    "assigningCopy": "Your partner walks you through the whole process, and we are picking the right one for you right now. It usually takes one working day. As soon as they are here, you can write to them or book a call whenever you need one.",
    "fallbackName": "BuddyPro team",
    "write": "Email your launch partner",
    "messageLabel": "Message for your partner",
    "messagePlaceholder": "Tell your partner what you need help with. They will reply to your e-mail.",
    "messageSend": "Send to your partner",
    "messageSending": "Sending…",
    "messageSentTitle": "Sent",
    "messageSent": "Your partner has your message and will reply to {email}.",
    "messageAnother": "Write another message",
    "messageFailed": "We could not send your message. Please try again; your text is kept here.",
    "messageMailApp": "Or open your mail app",
    "messageAddress": "Your partner's address: {email}"
  },
  "profile": {
    "eyebrow": "Your profile",
    "title": "Help us get to know you better",
    "updated": "Last updated:",
    "previewTitle": "What we already know about you",
    "open": "Open full profile",
    "viewTitle": "What We Know About You",
    "viewCopy": "We built this profile about you from public sources online. We take nothing as given: confirm what fits, fix what does not, and add what is missing. Voice works best.",
    "version": "Dossier version",
    "loadError": "We couldn't load this right now. Nothing was lost, so just try again.",
    "original": "Original wording:",
    "irrelevant": "Excluded from outputs",
    "actionsLabel": "Fact actions",
    "confirm": "Correct",
    "correct": "Edit",
    "markIrrelevant": "Not relevant",
    "saveCorrection": "Save correction",
    "saving": "Saving...",
    "saveError": "The change could not be saved.",
    "history": {
      "show": "Show recording history",
      "hide": "Hide recording history"
    },
    "playCorrection": "Play voice correction",
    "action": {
      "confirm": "Confirmed",
      "correct": "Corrected",
      "irrelevant": "Marked as not relevant"
    },
    "explain": "We created your profile using publicly available information online. Help us refine what is accurate, what is missing, and what you'd rather leave out.",
    "audioCta": "Record a voice message and tell us what's accurate, what we should add, and what we should leave out.",
    "audioSoon": "Voice recording will be available here soon.",
    "fromInternet": "Found online",
    "verifiedByYou": "Verified by you",
    "source": "Source",
    "lead2": "We created your profile using publicly available information.",
    "confirmed": {
      "eyebrow": "Confirmed profile",
      "title": "The profile we work from",
      "copy": "We use this map while preparing your Buddy. If anything has changed, ask your partner to update it.",
      "requestEdit": "Request an update",
      "requestEditUnavailable": "Your partner can help arrange an update."
    },
    "voiceInstruction": "Review the entire profile and send us a voice message. Tell us what is accurate, what is outdated, what is missing, what you would say differently, and what should not be included in your Buddy. Feel free to tell us more about yourself, your business, and your brand.",
    "voiceSent": "Thank you, our team will review your comments and update the profile accordingly.",
    "voiceSubmit": "Send the comment",
    "voiceError": "We could not send the comment. Please try again.",
    "walk": {
      "title": "Walk me through your map",
      "explain": "Click the microphone, walk through your map below, and tell me what you want to change in it.",
      "start": "Start recording",
      "cta": "Start recording and comment on your profile",
      "recording": "Recording",
      "stop": "Finish and send",
      "cancel": "Cancel",
      "sent": "Our team will review the recording and cursor trail, then update your profile.",
      "error": "We could not send the recording. Please try again.",
      "point1": "Remove a fact right away with the cross.",
      "point2": "Everything else, just say out loud.",
      "recTitle": "Listening and recording",
      "recInstruction": "Walk through your map below and say what you want to add or remove and what is or is not relevant. Feel free to describe how to change the whole profile. When you are done, stop the recording.",
      "sendingNote": "One moment, turning your recording into text.",
      "sentTitle": "Your recording is in"
    },
    "recordings": {
      "title": "Your recordings",
      "delete": "Delete",
      "apply": "Add to map",
      "applying": "Processing your recording",
      "applied": "Added ✓",
      "etaFallback": "Usually within 5 minutes",
      "completedBanner": "We added your recordings to the map. Review it below and confirm your profile.",
      "notificationTitle": "Your recordings are in the map",
      "notificationBody": "Your recordings are now in the map. Review your profile and confirm it.",
      "another": "Add recording",
      "review": "Waiting for team review"
    },
    "factRemove": "Remove from map",
    "map": {
      "navigationLabel": "Profile map categories",
      "position": "Category {current} of {total}",
      "previous": "Previous category",
      "next": "Next category"
    },
    "confirmation": {
      "button": "I confirm that this profile is correct",
      "sending": "Confirming...",
      "done": "Your profile is confirmed.",
      "locked": "The profile stays visible, but comments are locked. Your partner can reopen them.",
      "error": "We could not confirm your profile. Please try again."
    },
    "mapReset": {
      "tip": "Deleting makes sense only when the map is built on someone else or is inaccurate as a whole. You will then build a new one from scratch through your recordings.",
      "deleteButton": "Delete the map",
      "dialogTitle": "Do you really want to delete the whole map?",
      "dialogBody": "Have you gone through the whole map and are you convinced it is inaccurate and not worth building on? Once you confirm, we delete it for good. This cannot be undone and you will build a new map from scratch through your recordings.",
      "confirm": "Yes, delete for good",
      "cancel": "No, let me review it",
      "error": "The map could not be deleted right now. Please try again."
    },
    "research": {
      "runningLead": "We are putting your profile together from public sources right now.",
      "runningTitle": "Your first source material is taking shape",
      "runningCopy": "We are gathering your first source material. Specific facts will appear here after the team verifies them.",
      "runningRecord": "No need to wait, the microphone above works right now. Whatever you record flows into your map.",
      "delayedLead": "Putting your profile together is running late. We know about it.",
      "delayedTitle": "This is taking longer than it should",
      "delayedCopy": "The public source research is stuck. We are taking it over and we will write as soon as we have the first facts.",
      "delayedRecord": "Do not wait for us. Start the recording above and tell us the basics, that moves us forward right now.",
      "emptyLead": "We found nothing about you in public sources.",
      "emptyTitle": "Introduce yourself to us",
      "emptyCopy": "Start the recording and tell us who you are, what you do, what you specialize in and what your Buddy needs to handle. We will build your profile from that.",
      "emptyRecord": "Speak normally, the way you would in a conversation. Whatever you record flows straight into your map.",
      "noneLead": "We do not have your profile yet. It grows out of what you tell us about yourself.",
      "noneTitle": "Tell us the basics about you",
      "noneCopy": "Start the recording and tell us who you are, what you do and what you specialize in. We will build your profile from that.",
      "noneRecord": "Whatever you record flows straight into your map."
    },
    "questionnaireGate": {
      "eyebrow": "Confirm your profile first",
      "title": "We create the questions from a profile you have verified",
      "copy": "The questionnaire is tailored to your profile. Before we generate its questions, we need to know the information about you is accurate.",
      "review": "Open your profile with the button below.",
      "correct": "Correct anything inaccurate or add context with a voice message.",
      "confirm": "Finally, confirm the profile is accurate. The questions will then become available.",
      "openProfile": "Review and confirm my profile"
    },
    "walkBasics": {
      "title": "Record the basics",
      "explain": "Click the microphone and tell us who you are, what you do, and what your Buddy will be about."
    }
  },
  "resources": {
    "loadError": "We couldn't load this right now. Nothing was lost, so just try again."
  },
  "knowhow": {
    "closed": "Know-how uploads for the initial training are closed.",
    "closedRecap": "Your materials are saved and the team is using them to prepare your Buddy. You can keep updating its knowledge later.",
    "closedCount": "Tracked materials:",
    "closedRecapCount": {
      "zero": "There are no tracked materials yet. The team is preparing the source folders so you can add know-how later.",
      "one": "We have saved {count} material and the team is using it to prepare your Buddy. You can keep updating its knowledge later.",
      "few": "We have saved {count} materials and the team is using them to prepare your Buddy. You can keep updating its knowledge later.",
      "other": "We have saved {count} materials and the team is using them to prepare your Buddy. You can keep updating its knowledge later."
    },
    "closedNext": "View training status",
    "dialogTitle": "Is this enough for the initial training?",
    "dialogCopy": "Confirm that Buddy has enough material for the initial training. You can add more know-how later.",
    "dialogAgree": "I agree",
    "dialogDisagree": "I disagree",
    "eyebrow": "Your sources",
    "title": "Give Your Buddy Your Best Work",
    "copy": "Upload your best files to the prepared folder and add links to your own videos or podcasts. We'll use them to build a Buddy that knows your methods, experience, and way of working.",
    "driveTitle": "Your Knowledge Folder",
    "urlsTitle": "Video and Podcast Links",
    "preparingDrive": "The team is preparing your Drive folder.",
    "preparingUrls": "The team is preparing your public source document.",
    "complete": "Submit for training",
    "submitting": "Confirming...",
    "guard": "The button becomes available when both links are ready.",
    "guardStep": "Both links are ready. We will open this step as soon as the team checks them, then you can submit your know-how.",
    "done": "Done. The team has started processing your sources.",
    "error": "Confirmation failed. Check both resources and try again.",
    "confirmTitle": "Have you uploaded everything?",
    "confirmCopy": "Once you confirm everything is in the folder, our team can start training your Buddy.",
    "confirmCheckbox": "Everything is uploaded",
    "confirmWarning": "Once confirmed, we will lock your materials, send them for processing and use them to create the first version of your Buddy. You can update its knowledge later at any time.",
    "confirmYes": "Yes, send for processing",
    "confirmNo": "Not yet",
    "googleLabel": "Google account for sharing the folder",
    "googleButton": "Share the folder",
    "belongsTitle": "What belongs here",
    "belongs1": "Your best courses and e-books",
    "belongs2": "Transcripts and recordings of talks or consultations",
    "belongs3": "Your own articles, methods, and processes",
    "belongs4": "Videos, podcasts, and interviews where you are the main speaker and your know-how is the topic",
    "belongs5": "Only content you hold the rights to",
    "avoidTitle": "What does not belong",
    "avoid1": "Podcasts where you are the guest, or where your guests' know-how is the topic",
    "avoid2": "Contracts, invoices, and internal documents",
    "avoid3": "Personal data of your clients",
    "avoid4": "Average content that teaches Buddy nothing",
    "googleDone": "We will prepare the folder and document, share them with this account, and let you know.",
    "avoid5": "Recordings where several people talk over each other",
    "partnerTitle": "Materials from your partner",
    "partnerHint": "Your partner uploaded these sources for you. We count on them when training your buddy.",
    "partnerBy": "added by your partner",
    "openFolder": "Open the folder",
    "openDoc": "Open the document",
    "folderHint": "Put the files with your know-how directly into this Google Drive folder, without subfolders.",
    "docHint": "Paste full links to your videos, podcasts, and articles into this Google Doc. One link per line.",
    "step1Title": "Read what belongs in Buddy",
    "step2Title": "Upload files to the folder and links to the document",
    "step3Title": "Confirm everything is uploaded",
    "accountsIntro": "The folder and the document are shared with these Google accounts. Open them signed in with one of them.",
    "accountShared": "Shared",
    "accountPending": "Sharing in progress",
    "accountDelayed": "Taking longer",
    "activeTitle": "We are working on it",
    "activeEta": "Access is usually ready in 3-5 minutes.",
    "activeDelayed": "This is taking longer than usual. We know about it, we are on it and we will come back to you.",
    "activeNotify": "We will notify you as soon as access is ready.",
    "addAccount": "Add another account",
    "addAccountHint": "Useful when a colleague or your team helps with the upload.",
    "addAccountButton": "Add account",
    "googlePlaceholder": "name@gmail.com",
    "rulesTitle": "How to upload so nothing gets lost",
    "rulesFolderTitle": "Put files directly into the folder",
    "rulesFolderBody": "Don't create folders inside it. Anything in a subfolder is left out of your Buddy's training.",
    "rulesLinksTitle": "Links go into the link document",
    "rulesLinksBody": "Paste full links (starting with https://), one per line. A list of video titles or a PDF with links is not enough, the videos' content won't reach your Buddy from it.",
    "rulesVoiceTitle": "Add a sample of your voice",
    "rulesVoiceBody": "Upload one recording to the folder where only you speak: at least 2 minutes, no music, no other people and no background noise. Put the word \"voice\" in its file name. We'll clone your Buddy's voice from it.",
    "precheckTitle": "Before you confirm, check that:",
    "precheck1": "All files are directly in the folder, none in a subfolder.",
    "precheck2": "Links to videos and podcasts are in the document, each on its own line.",
    "precheck3": "The folder has a recording of your voice with \"voice\" in its file name."
  },
  "training": {
    "eyebrow": "Training status",
    "title": "Your Buddy is learning from verified sources",
    "copy": "Your expertise is turning into your Buddy right now: we load the sources, teach it the knowledge, and tune its voice and behavior.",
    "revealTitle": "It’s time to meet your Buddy",
    "revealCopy": "Training is complete, so put your Buddy through its paces and tell us what still needs tuning.",
    "openTrial": "Open the trial",
    "calm": "There is nothing you need to monitor, and we do not need anything else from you.",
    "eta": "It usually takes 2-3 business days. We will let you know by email as soon as your Buddy is ready."
  },
  "beta": {
    "eyebrow": "Beta testing",
    "title": "Test Buddy With Real Questions",
    "copy": "Now it is your turn: start by talking to your Buddy yourself.",
    "copyTransferred": "The bot is yours. Now invite testers and collect the first reactions from outside.",
    "invites": {
      "one": "You have {count} invite with 200 messages for your testers.",
      "few": "You have {count} invites, each with 200 messages for your testers.",
      "other": "You have {count} invites, each with 200 messages for your testers."
    },
    "feedbackTitle": "Send Us Specific Feedback",
    "feedbackCopy": "Tell us what happened, what answer you expected, and include a specific example. Our team will review it and refine Buddy.",
    "sourceLabel": "Whose observation is this",
    "sourceSelf": "My observation",
    "sourceTester": "From a tester",
    "testerNamePlaceholder": "Tester's name (optional)",
    "fromTester": "From a tester",
    "fromTesterNamed": "From tester {name}",
    "screenshot": "Add a screenshot",
    "selected": "Selected file:",
    "submit": "Send feedback",
    "submitting": "Sending...",
    "upload": {
      "converted_photo": "We cannot process this screenshot format yet (HEIC from an iPhone, TIFF or RAW). Save it as PNG or JPEG and add it again. The file remains with you and nothing was submitted.",
      "unsupported_type": "We do not accept this file format. Add the screenshot as PNG, JPG or WebP. The file remains with you and nothing was submitted.",
      "too_large": "The screenshot is too large. The limit is 60 MB, so shrink it and add it again. The file remains with you and nothing was submitted.",
      "quota": "You have run out of upload space. The daily limit clears itself within 24 hours; otherwise message your partner. Your text stays here.",
      "storage": "Storage is not responding right now. Send the feedback again in a moment; your text and recording stay here.",
      "offline": "You look offline. Reconnect and send the feedback again. Nothing was lost.",
      "not_an_image": "This file is not an image inside, even though its name says so. Open it, save it as PNG or JPEG and add it again.",
      "generic": "The screenshot could not be uploaded right now. Try again, or send the feedback without it. The file remains with you and nothing was submitted."
    },
    "submitIssue": {
      "trial_not_ready": "Your trial Buddy is not ready yet, so there is nothing to comment on. We are preparing it and will let you know. Your text and recording stay here.",
      "tester_before_transfer": "The From a tester option opens once the bot is yours. Switch to My own and the feedback goes out right away.",
      "ownership_transferred": "The instance has been handed over, so we cannot configure it any more and you look after it yourself. Feedback is no longer sent from here. Your text and recording stay here.",
      "state_conflict": "The beta step has moved on. Copy your text, reload the page and you will see where we are now.",
      "forbidden": "You cannot submit this. Message your partner and they will look at it.",
      "not_found": "We no longer have that attachment. Add it again, or send the feedback without it.",
      "invalid_request": "Something in the form does not fit. Check the text and the attachments and send the feedback again.",
      "rate_limited": "Too many attempts in a row. Wait a moment and send the feedback again. Your text and recording stay here.",
      "server": "The server did not answer. That is on us and we are looking at it. Try again shortly; your text and recording stay here.",
      "offline": "This looks like a connection drop. Reconnect and send the feedback again. Your text and recording stay here.",
      "generic": "The feedback could not be sent right now. That is on us and we are looking at it. Please try again shortly; your text and recording stay here."
    },
    "historyTitle": "Your feedback",
    "historyEmpty": "Nothing here yet. Start with one of the tests above.",
    "historyEmptyClosed": "There is no feedback here.",
    "historyProcessed": "Processed ({count})",
    "openScreenshot": "Open screenshot",
    "playAudio": "Play voice note",
    "status": {
      "new": "New",
      "processed": "Processed"
    },
    "readyTitle": "Your Buddy’s first version is ready",
    "openChat": "Open the trial",
    "openChatOwned": "Open your Buddy",
    "screenshotHint": "A screenshot is the best way to show us what went wrong. Ask your testers to send you screenshots too, add them here, and describe what happened.",
    "step1Title": "Talk to your Buddy",
    "step1Copy": "Grill Buddy on the questions you hear from clients and tune the basics with us until you are happy.",
    "step2Title": "Telegram bot ownership transfer",
    "step2Copy": "To make the Buddy truly yours, we transfer the bot to your personal Telegram account. Telegram only allows the transfer once you have chatted with the bot.",
    "step3Title": "Invite testers",
    "step3Copy": "Pick colleagues, friends or a few customers and send them the tester link. Fresh eyes catch what you no longer see.",
    "tipTitle": "Tip: trade testing for testimonials",
    "tipCopy": "Each invite gives a tester 200 free messages. Ask for feedback and a reference in return. A reference can be a short video, a few sentences, or a screenshot of an excited message. Ask questions so they write that message themselves, and get permission to use it. Each one will serve your sales page at launch.",
    "linkPlaceholder": "Your Buddy link will appear here.",
    "inviteLinkPlaceholder": "The link for your testers will appear here.",
    "inviteLinkLabel": "Tester link",
    "copyInvite": "Copy link",
    "copied": "Copied",
    "step4Title": "Feedback",
    "step4Copy": "Ask for specific feedback: what delighted your testers, what was missing, and where Buddy got lost. Your own impressions count too.",
    "lockTesters": "The Telegram bot needs to change hands first. Then you get your tester invites.",
    "feedbackBeforeTransfer": "You can send your own observation now. The From a tester option opens after the bot transfer.",
    "feedbackClosedLead": "This step is closed.",
    "feedbackOwnershipClosed": "The instance has been handed over. It is yours from this moment on, we cannot configure it any more and you look after it yourself. Feedback is no longer sent from here. Your earlier feedback stays below.",
    "transfer": {
      "accountKicker": "We will transfer to the account",
      "accountKickerDone": "Bot owner",
      "state": {
        "preparing": "Sent",
        "awaiting_client": "Waiting for ownership",
        "client_confirmed": "Ownership confirmed",
        "transferred": "Transferred",
        "fix_needed": "Waiting for your fix"
      },
      "responsible": {
        "team": "Owned by the BuddyPro team",
        "client": "Owned by you"
      },
      "autoWorking": "We are working on the bot transfer. We will let you know once it is done.",
      "fix": {
        "recipient_not_started": "The account @{username} has not messaged your bot yet. Telegram only allows a transfer to an account that chats with the bot. Open the bot, send it a message and submit the name again.",
        "recipient_not_found": "We could not find the account @{username} on Telegram. Check the name and submit it again.",
        "recipient_bot_limit": "The account @{username} already holds the maximum number of bots Telegram allows. Free a slot on it (in @BotFather delete or pass on one of the unused bots) and submit the name again.",
        "recipient_invalid_target": "The name @{username} belongs to a bot or a channel, not to a personal account. Telegram only allows a transfer to a person's own account. Check the name and submit it again.",
        "staff_returned": "Your partner sent the transfer back for a fix: {note}"
      },
      "accept": "Confirm bot ownership",
      "accepting": "Confirming...",
      "confirmedNote": "Thanks for confirming. We are verifying that Telegram completed the transfer.",
      "doneNote": "The bot is transferred. From now on only you own it."
    }
  },
  "botTransfer": {
    "reason": {
      "recipient_not_started": "the recipient has not written to the bot yet",
      "recipient_not_found": "Telegram found no account with that username",
      "floodwait": "Telegram temporarily rate-limited us (FloodWait)",
      "twofa_too_fresh": "the account's two-step verification is younger than 7 days",
      "gate_mismatch": "BotFather's confirmation message did not match the bot or the recipient",
      "bot_not_found": "the bot was not found in /mybots",
      "session_unavailable": "the Telegram session was unavailable",
      "unknown": "we cannot name this error yet",
      "staff_returned": "the partner sent the transfer back to the client for a fix",
      "recipient_invalid_target": "the name given is a bot or a channel, not a personal account",
      "recipient_bot_limit": "the recipient's account already holds the maximum number of bots and has to free a slot",
      "verification_unavailable": "the confirmation went out, but we could not verify whether the bot really changed hands. Check our account's /mybots by hand before running it again"
    }
  },
  "ownerRole": {
    "reason": {
      "owner_not_member": "the account with this ID is not a user of the instance yet",
      "invalid_owner_id": "the stored number does not look like a Telegram ID",
      "not_our_instance": "the instance refused the command: our account is not its owner",
      "id_format_rejected": "the instance refused the ID format we sent",
      "platform_error": "the instance reported an error without naming a cause",
      "session_unavailable": "we have no verified account that controls this instance",
      "verification_unavailable": "the instance's answer could not be read, so we do not treat the role as set",
      "unknown": "we cannot name this failure yet"
    }
  },
  "transfer": {
    "warning": "Careful: a typo would hand the bot to a stranger. The transfer is permanent, which is why you type the username twice.",
    "usernameLabel": "Your Telegram username",
    "usernameRepeatLabel": "Your Telegram username again, to double-check",
    "usernamePlaceholder": "@your_username",
    "usernameMismatch": "The usernames do not match. Check for typos and fix them.",
    "usernameIsBot": "{bot} is your bot's name, not your account. Fill in the username of your personal Telegram account.",
    "usernameMatch": "The usernames match.",
    "noUsernameNote": "No username yet? Create one in Telegram under Settings, Username. The transfer cannot happen without it.",
    "idLabel": "Telegram ID (from the /myid command)",
    "idHint": "Open the chat with your bot, send /myid and copy the reply. The number alone is enough.",
    "idPlaceholder": "123456789#{bot}",
    "idPlaceholderPlain": "123456789#bot_username",
    "idGuideTitle": "How to get the correct Telegram ID",
    "idGuideStep1": "Open the chat with your bot in Telegram.",
    "idGuideStep2": "Send the /myid command to the bot.",
    "idGuideStep3": "Copy the complete reply and paste it into the field below.",
    "idNormalized": "We will store it as {value}.",
    "idWrongBot": "This number looks like it came from a different bot. Send /myid to your own bot @{bot}.",
    "startedCheckbox": "I opened my bot in Telegram and sent it a message",
    "submit": "Send to the team",
    "submitting": "Sending...",
    "ownerOnly": "The transfer account is entered by the owner.",
    "ownershipIntro": "You already own the Telegram bot. Only your numeric Telegram ID is needed here.",
    "ownershipStored": "We will use the account saved during the bot transfer:",
    "idGuideStep1Link": "Open the chat with your bot {bot} in Telegram.",
    "saved": "Sent to the team. We have it saved."
  },
  "sales": {
    "eyebrow": "Sales package",
    "title": "Your sales assets in one place",
    "copy": "We publish each asset separately. You can review completed pieces while the team continues working on the rest.",
    "deliverablesLabel": "Sales assets",
    "overview": {
      "eyebrow": "Sales preparation",
      "title": "Your sales work, step by step",
      "copy": "Each step has its own page. Open the exact asset or task you want to work on.",
      "listLabel": "Sales preparation steps",
      "unavailable": "Status unavailable",
      "updated": "Updated {date}",
      "step": {
        "marketing_call": "Together we set the campaign goal, offer and flow.",
        "profile": "Check what we know about you, add what is missing and confirm it.",
        "q2": "Your answers complete the inputs for the sales package.",
        "strategy": "All sales assets follow after your review and approval.",
        "salespage": "Review the copy and design, then leave your comments.",
        "payments": "We set up the payments in your Stripe; you only give us access.",
        "emails": "Get the finished sequence ready to copy.",
        "webinar": "Get the outline, transitions and sales close.",
        "stripe": "Connect your own account so payments go directly to you.",
        "app_questionnaire": "Complete the inputs needed for the mobile app.",
        "publish": "Choose a ZIP or Netlify, where you can connect your own subdomain.",
        "handover": "Take ownership of the instance and its access.",
        "release": "See the build and store review status."
      }
    },
    "pages": {
      "unavailable": "We could not load the current status and assets. Try opening this page again in a moment.",
      "strategy": {
        "eyebrow": "Step 11",
        "title": "Sales strategy proposal",
        "copy": "This is where you review the campaign proposal, prices and plans. Add comments, then approve the proposal.",
        "doneCopy": "Your approved campaign proposal, including pricing and plans, remains available here to download.",
        "locked": "This step unlocks after you submit the sales questionnaire. The proposal will appear here once it is ready.",
        "processTitle": "How it works",
        "processCopy": "Read the full proposal first. If something needs changing, write or record a note directly on the document. Approval starts the next set of assets.",
        "backfillReview": "We added this proposal to a project already in progress. The questionnaire therefore stays locked, but you can review, comment on, and approve the strategy now.",
        "pricingIncluded": "Prices and plans are included in the proposal. Your approval covers them too.",
        "cardEyebrow": "Sales strategy",
        "cardTitle": "Campaign, pricing and plan proposal",
        "recap": "The strategy, pricing and plans are delivered in one approved document."
      },
      "salespage": {
        "eyebrow": "Step 12",
        "title": "Sales page",
        "copy": "The step has three phases: page approval, order links, and publication. Review the content and the look; comments and the approval belong to the first phase.",
        "locked": "The sales page unlocks after you approve the sales strategy proposal.",
        "approvedNext": "The page is approved. Download and publishing are available in the Publish sales page step.",
        "openPublish": "Open publishing",
        "recap": "The approved page is ready for publishing and remains available for review."
      },
      "emails": {
        "eyebrow": "Step 13",
        "title": "Email marketing",
        "copy": "Read the finished sequence one email at a time. Copy each message or the full sequence inside the document.",
        "locked": "The email sequence unlocks after you approve the sales strategy proposal.",
        "recap": "The finished email sequence is delivered as individual messages and as one complete set."
      },
      "webinar": {
        "eyebrow": "Step 14",
        "title": "Webinar structure",
        "copy": "The outline, section flow and sales close for your webinar are all here.",
        "locked": "The webinar structure unlocks after you approve the sales strategy proposal.",
        "recap": "The webinar structure is delivered with its section flow and sales close."
      },
      "publish": {
        "eyebrow": "Step 17",
        "title": "Publish your sales page",
        "copy": "Download the finished ZIP, or publish through Netlify and connect your own subdomain if needed."
      }
    },
    "kind": {
      "audit": "Audit",
      "plan": "Sales strategy",
      "salespage": "Sales page",
      "emails": "Emails",
      "webinar": "Webinar",
      "avatar": "Avatar",
      "price_proposal": "Price proposal"
    },
    "preparingTitle": "In preparation",
    "avatarTitle": "Your AI avatar",
    "avatarReady": "Ready",
    "avatarView": "View full size",
    "avatarDownload": "Download",
    "preparing": {
      "audit": "We are still completing the audit.",
      "plan": "The sales strategy proposal is being generated. It usually takes 2-3 business days. We will let you know by email.",
      "salespage": "We are still completing the sales page.",
      "emails": "We are still completing the email sequence.",
      "webinar": "We are still completing the webinar structure.",
      "avatar": "We are creating your AI avatar from your photo."
    },
    "preparingWait": {
      "strategy": {
        "title": "We are preparing your sales strategy proposal",
        "copy": "We are working with your answers and preparing the sales strategy proposal, including prices and plans. As soon as the material is ready for you, you will see it here.",
        "eta": "We usually prepare the proposal within 2-3 business days. We will send you a notification when your feedback is needed."
      },
      "salespage": {
        "title": "We are preparing your sales page",
        "copy": "We are turning the approved strategy into the copy, structure and final shape of your page. As soon as the material is ready for you, you will see it here.",
        "eta": "We usually prepare the page within 2-3 business days. We will send you a notification when your feedback is needed."
      },
      "emails": {
        "title": "We are preparing your email sequence",
        "copy": "We are writing the emails that follow your strategy and guide readers through the campaign. As soon as the material is ready for you, you will see it here.",
        "eta": "We usually prepare the sequence within 2-3 business days. We will send you a notification when your feedback is needed."
      },
      "webinar": {
        "title": "We are preparing your webinar structure",
        "copy": "We are shaping the outline, argument and offer for your sales webinar. As soon as the material is ready for you, you will see it here.",
        "eta": "We usually prepare the structure within 2-3 business days. We will send you a notification when your feedback is needed."
      }
    },
    "status": {
      "draft": "In progress",
      "review": "Ready for review",
      "approved": "Approved"
    },
    "tileBlurb": {
      "audit": "What we understood from your answers and what your sales campaign will be built on.",
      "plan": "The proposed sales campaign and the reasons behind this exact shape.",
      "emails": "Ready-to-send emails for your audience. Copy each one with a single button.",
      "webinar": "The structure and script of your sales webinar."
    },
    "previewUnavailable": "This preview could not be displayed. Your other assets remain available.",
    "previewLoading": "Loading the real page preview",
    "previewChip": "Real preview",
    "previewReady": "Real preview loaded",
    "previewAlt": "Sales page preview",
    "previewError": "The preview could not be loaded. You can still open the full output separately.",
    "pageError": {
      "title": "The page could not be loaded",
      "copy": "Check your connection and try again."
    },
    "previewRetry": "Load again",
    "openPreview": "Open full asset",
    "version": "Version {version}",
    "lockedPreview": {
      "title": "What appears in this step",
      "owner": "Who unlocks it",
      "when": "When it unlocks"
    },
    "doneRecap": {
      "eyebrow": "Delivered",
      "open": "Open output"
    },
    "loadError": "We couldn't load this right now. Nothing was lost, so just try again.",
    "flowTitle": "How this will go",
    "flow1": "Review the sales strategy, including prices and plans. Add comments or approve it.",
    "flow2": "After approval we prepare the page, emails and webinar, and open the Stripe connection.",
    "flow3": "Approve the sales page, connect Stripe, then choose how to publish the page.",
    "reviewLoop": {
      "intro": "How do you want to move {document} forward",
      "commentsTitle": "I want a change",
      "commentsCopy": "Add comments in writing or with Talk and point. We will prepare a new version.",
      "approveTitle": "This is right",
      "approveCopy": "Reach the end of the material and approve it. Approval locks the comments.",
      "material": {
        "strategy": "the sales strategy",
        "salespage": "the sales page",
        "emails": "the emails",
        "webinar": "the webinar"
      },
      "unlocks": "Approving unlocks work on the sales page, the e-mails and the webinar structure. Prices and plans are part of the proposal, so approval covers them too."
    },
    "feedbackSummary": {
      "waiting": "Comments: {total}. Waiting to be applied: {waiting}.",
      "partial": "Comments: {total}. Applied: {implemented}. Waiting: {waiting}.",
      "implemented": "All {total} comments have been applied.",
      "error": "The comment status could not be loaded right now.",
      "totalLabel": "Total",
      "implementedLabel": "Applied",
      "waitingLabel": "Waiting"
    },
    "strategy": {
      "title": "Sales strategy proposal",
      "approvalHint": "Approval covers the full proposal, including prices and plans. Add comments below with Talk and point before approving it.",
      "reviewDownload": "Review and download",
      "next": {
        "title": "Your next materials are being created",
        "action": "Go to the next step"
      },
      "preparingWait": {
        "title": "We are preparing your sales strategy proposal",
        "copy": "We are working with your answers and preparing the sales strategy proposal, including prices and plans. As soon as the material is ready for you, you will see it here.",
        "eta": "We usually prepare the proposal within 2-3 business days. We will send you a notification when your feedback is needed."
      },
      "approvedWait": {
        "title": "Strategy approved",
        "calm": "You do not need to do anything now. We are preparing your sales materials.",
        "eta": "Usually 2-3 business days. We will let you know by email."
      },
      "reviewGuide": {
        "eyebrow": "Once you open the document",
        "title": "How the strategy moves forward",
        "approveTitle": "If the proposal is right",
        "approveCopy": "Approve it at the end. This starts work on your sales page, emails and webinar.",
        "feedbackTitle": "If you want a change",
        "feedbackCopy": "Add a comment in the document or use Talk and point. We will prepare a new version."
      }
    },
    "pageApprovalHint": "Approval covers the content and design of the sales page. Add comments with Talk and point before approving it.",
    "gate": {
      "approve": "Approve document",
      "approving": "Approving...",
      "approvedNote": "The document is approved.",
      "readFirst": "Read the proposal. Approval is at the end.",
      "readProgress": "{progress}% read",
      "endTitle": "You can approve the document now",
      "hint": "Add comments below with Talk and point. They lock after approval.",
      "feedbackLabel": "Comments on the document",
      "feedbackPlaceholder": "Tell us what to change, add or fix…",
      "send": "Send comments",
      "sending": "Sending…",
      "feedbackSent": "We received your comments and will follow up with a new version.",
      "approvedStrategyNote": "The strategy is approved. We are starting work on the rest of the marketing materials.",
      "staffReturned": "Your partner returned this for rework: {reason}",
      "staffApprovedNote": "The approval was confirmed by your partner after your call."
    },
    "doc": {
      "read": "Open the document",
      "close": "Close",
      "actionHint": "In the document, you can approve the proposal or record your comments.",
      "review": "Review and comment",
      "panelLabel": "Comments",
      "meta": "Version {version} · {date} · Prepared by the BuddyPro team"
    },
    "walk": {
      "title": "Talk and point",
      "explain": "Start recording, point with your cursor (or finger on a phone) at places in the document and say your notes out loud. We keep the voice and what you pointed at.",
      "start": "Start recording",
      "stop": "Stop and save",
      "cancel": "Cancel",
      "recInstruction": "Point at what you talk about. The mic saves.",
      "sendingNote": "Transcribing the recording and saving your notes.",
      "sentTitle": "Sent",
      "sent": "The note is saved in the list below. Your partner will see it; nothing else to send.",
      "another": "Record another",
      "error": "Recording could not start. Please check microphone access.",
      "empty": "We could not hear any speech in the recording. Please try again.",
      "status": {
        "uploading": "Uploading...",
        "transcribing": "Transcribing...",
        "done": "Done."
      }
    },
    "notes": {
      "title": "Saved notes",
      "walkBadge": "Talk and point",
      "delete": "Delete note",
      "writeToggle": "Write a note as text",
      "saveNote": "Save note",
      "workedIn": "The new version worked in the earlier notes.",
      "voiceOnly": "Voice note",
      "voiceTranscribing": "Voice note, transcribing it to text...",
      "voiceNoSpeech": "We did not recognize any speech in the recording. Listen to it.",
      "voiceFailed": "The transcription failed. Listen to the recording.",
      "voicePlay": "Play the recording",
      "anchorHint": "Show the spot in the document (hover highlights, click scrolls)",
      "anchorCount": "Places in the document ({count})",
      "state": {
        "saved": "Saved",
        "sent": "Sent for processing",
        "working": "Being worked in",
        "handled": "Worked in",
        "dismissed": "Not relevant"
      },
      "hint": {
        "saved": "Your partner sees it. The state changes here once we work it into a new version.",
        "sent": "Your partner sent it for processing. It is waiting to start.",
        "working": "We are working it into a new version right now. It will appear here by itself.",
        "handled": "Worked into a new version of the material.",
        "dismissed": "The partner closed it as not relevant. It stays here for reference."
      },
      "workingBanner": "We are working your notes into a new version. You can see the state of each one below.",
      "flowHint": "Your partner sees your notes the moment you save them. There is nothing else to send.",
      "resolvedAt": "Worked in {time}"
    },
    "emails": {
      "copyAll": "Copy all e-mails",
      "copyOne": "Copy text",
      "copied": "Copied",
      "copyFailed": "Copying failed. Select the text by hand.",
      "copySubject": "Copy subject",
      "copyFailedShort": "Copy failed",
      "headHint": "Copy any e-mail straight from the timeline. Open one when you want to read it in full.",
      "phaseFallback": "Campaign e-mails",
      "phaseCount": "{count} e-mails",
      "strategyTitle": "How the campaign works",
      "strategyLead": "The sending strategy: segments, calendar and the reasons the e-mails go out in this order.",
      "facts": {
        "emails": "e-mails in total",
        "phases": "campaign phases",
        "span": "sending window"
      },
      "card": {
        "open": "Open e-mail",
        "close": "Close e-mail",
        "position": "{index} of {total}",
        "untitled": "E-mail {order}"
      },
      "detail": {
        "subject": "Subject",
        "day": "When it goes out",
        "segment": "Who receives it",
        "task": "What this e-mail must do",
        "note": "Note",
        "altSubjects": "Alternative subjects to test",
        "previous": "Previous e-mail",
        "next": "Next e-mail",
        "navLabel": "Moving between e-mails"
      }
    },
    "publish": {
      "eyebrow": "Publishing the page",
      "title": "Publishing options",
      "waiting_page": "Waiting for the page",
      "locked_page": "Waiting for approval",
      "locked_stripe": "Waiting for Stripe",
      "ready": "Ready to publish",
      "update": "New version waiting",
      "published": "Published",
      "waitingPage": "We prepare the sales page first. The publishing options appear here automatically.",
      "lockedPage": "Review and approve the sales page first. The publishing options then unlock.",
      "lockedStripe": "Connect Stripe. Download and publishing unlock after we verify that payments reach your account and the page contains payment links.",
      "timeline": {
        "title": "Path to publishing",
        "page": "Page approval",
        "stripe": "Stripe receives payments",
        "delivery": "Download or publishing",
        "preparing": "Preparing",
        "awaiting_approval": "Waiting for approval",
        "awaiting_client": "Waiting for you",
        "done": "Done",
        "locked": "Follows next",
        "next": "The next step opens automatically after the current item is complete."
      }
    },
    "delivery": {
      "title": "Where you get the page",
      "lockedCopy": "We will hand the page over once the order links are placed in it (the Order links phase above).",
      "download": "Download ZIP",
      "downloadNote": "The ZIP contains index.html. Give it to your web person, or upload it to your hosting.",
      "netlify": "Netlify and your subdomain",
      "netlifyNote": "Free hosting under your account. We publish the page and show you the exact DNS record.",
      "netlifyExplain": "Netlify is free hosting. We publish the page there for you, but the account and the site are yours from the start.",
      "netlifyAccountLink": "Create a Netlify account",
      "netlifyAccountStep": "Open the link and complete the free registration.",
      "netlifyTokenLink": "Open personal access tokens",
      "netlifyTokenStep": "Click New access token, name it Launchpad, and copy the token.",
      "netlifyPasteStep": "Paste the token into the field below. It will not be displayed after saving.",
      "netlifyPublishStep": "Click Publish the page and wait for confirmation that the site is live.",
      "netlifyTokenPlaceholder": "Paste your Netlify access token",
      "netlifyPublish": "Publish the page",
      "netlifyPublishing": "Publishing...",
      "netlifyUpdate": "Publish the new version",
      "netlifyYours": "The site runs under your Netlify account. You manage it yourself.",
      "netlifyDone": "Done. The page is live on your site.",
      "netlifyAuthError": "Netlify did not accept the token. Check that you copied all of it and that it is still valid.",
      "netlifyTokenError": "We need your Netlify access token. Please paste it into the field.",
      "netlifyDeployError": "Netlify rejected the publish. Try again. If the error remains, book an extra call with your launch partner.",
      "netlifyArtifactError": "The sales page does not have a publishable HTML file yet. Your launch partner must publish a new page version first.",
      "netlifyPendingError": "Netlify is still processing the page. Wait a moment, then click Publish the page again.",
      "dnsEyebrow": "Your address",
      "dnsTitle": "Connect your own subdomain",
      "dnsExplain": "Enter the full address, for example offer.yourdomain.com. Launchpad configures it on Netlify. You then add one CNAME record manually at your domain provider.",
      "dnsDomainLabel": "Full sales page address",
      "dnsDomainPlaceholder": "offer.yourdomain.com",
      "dnsConfigure": "Set the address on Netlify",
      "dnsConfiguring": "Setting the address...",
      "dnsConfigured": "Netlify configured",
      "dnsAuthError": "The stored Netlify token is no longer valid. Paste a new token and publish the page again.",
      "dnsConfigureError": "Netlify did not accept the address. Check it and try again.",
      "dnsStep": {
        "provider": "Sign in to your domain provider and open the DNS records.",
        "record": "Add a CNAME with the name and target shown below.",
        "wait": "Save the change. It usually takes a few minutes to propagate, but can take up to an hour."
      },
      "dnsType": "Type",
      "dnsRecordType": "CNAME",
      "dnsName": "Name",
      "dnsHost": "offer",
      "dnsValue": "Target",
      "dnsTtl": "TTL",
      "dnsPending": "The exact CNAME target appears after the first successful Netlify publish.",
      "dnsPartnerCall": "Book an extra call with your launch partner"
    },
    "phases": {
      "listLabel": "Step phases",
      "approve": "Sales page approval",
      "links": "Order links",
      "publish": "Sales page publication",
      "publishLocked": "Publication unlocks once the order links are placed in the page. Until then you would be downloading a page nobody can order from.",
      "publishedVia": {
        "download": "Done {when}, you downloaded the page. Nothing closes here: download it again any time, or publish it through us.",
        "netlify": "Done {when}, the page is live on your Netlify. Nothing closes here: publish a new version any time, or download the page."
      }
    },
    "orderLinks": {
      "lockedCopy": "You will add the order links after the sales page is approved.",
      "ownerOnly": "The account owner fills in the order links.",
      "intro": "Your plans come from your approved sales page. Add the order link to each one. A Stripe payment link, a FAPI form or an order page on your own web all work.",
      "introCustom": "The plans could not be read from the page. Write them exactly as your sales page offers them and add the order link to each one.",
      "manualNote": "This mode showed up only because the plans could not be read from the page. Normally we print them for you.",
      "missingTitle": "The plans could not be read from the page",
      "missingCopy": "We could not read the list of plans from your approved sales page. Write the plans by hand exactly as the page offers them and add the order link to each one.",
      "manualEnable": "Write the plans by hand",
      "manualEnabling": "Getting ready…",
      "nameLabel": "Plan name",
      "namePlaceholder": "E.g. Annual membership",
      "urlLabel": "Order link for the plan",
      "urlPlaceholder": "https://…",
      "add": "Add a plan",
      "remove": "Remove",
      "confirm": "I confirm the links are correct",
      "confirming": "Saving…",
      "confirmedNote": "The links are confirmed. We can place them into your page now.",
      "integrate": "Place the links into the page",
      "integrating": "Sending…",
      "fillHint": "Still missing an order link for: {list}.",
      "rowLabel": "row",
      "sentTitle": "Sent for processing",
      "workingTitle": "Working on your order links",
      "workingCopy": "We are placing the links into your sales page. We will let you know when it is done.",
      "integratedCopy": "The links are in the page. The download and the publication below are unlocked.",
      "saveError": "The links could not be saved right now. Please try again.",
      "confirmError": "The confirmation could not be saved. Check that every link is filled in and try again.",
      "integrateError": "The request could not be sent right now. Please try again."
    }
  },
  "doc": {
    "copy": {
      "action": "Copy",
      "done": "Copied",
      "failed": "Not copied"
    },
    "timeline": {
      "aria": "Campaign timeline",
      "jump": "Go to the e-mail"
    },
    "email": {
      "subject": "Subject",
      "altSubject": "Alternate subject",
      "preheader": "Inbox preview",
      "preheaderTip": "The short line inboxes show next to the subject. It is not a second subject.",
      "body": "E-mail text",
      "auto": "sends itself"
    },
    "map": {
      "aria": "Campaign map"
    },
    "funnel": {
      "aria": "Webinar funnel",
      "goal": "Goal",
      "jump": "Go to the detail"
    },
    "wf": {
      "aria": "Page wireframe",
      "form": "Form",
      "button": "Button"
    },
    "evening": {
      "aria": "Evening timeline",
      "jump": "Go to the phase",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "step1": "step",
      "step2": "steps",
      "step5": "steps"
    },
    "seam": {
      "before": "Follows",
      "after": "Sets up"
    },
    "mi": {
      "example": "Example"
    },
    "arc": {
      "aria": "Story arc of the evening"
    },
    "scope": {
      "covers": "Covers",
      "offer": "Offer promise"
    },
    "calc": {
      "aria": "Webinar yield calculator",
      "reset": "Back to the preset numbers",
      "audienceLegend": "Who are you broadcasting to",
      "modeLegend": "What are you working out",
      "modeForward": "From people to money",
      "modeGoal": "From a goal to people needed",
      "driver": "You enter",
      "answer": "You get",
      "visits": "Visits of the registration page",
      "visitsNeeded": "People to bring to the registration page",
      "registrations": "Registrations",
      "attended": "People on the broadcast",
      "orders": "Orders",
      "rateReg": "Register",
      "rateShow": "Show up",
      "rateBuy": "Buy",
      "baseVisits": "of the people who opened the registration page",
      "baseRegistrations": "of the registered",
      "baseAttended": "of the people who showed up",
      "from": "from",
      "to": "to",
      "rangeSep": "to",
      "decimalSep": ".",
      "midHint": "plan with",
      "needsRate": "enter a conversion above zero",
      "goalUnits": "How much you want to sell",
      "goalMoney": "How much you want to earn",
      "tariffLegend": "Which plan are you counting",
      "tariffSingle": "Counting the plan",
      "recommended": "recommended",
      "revenue": "Revenue",
      "cpv": "Cost per visit",
      "budget": "Ad budget",
      "net": "You keep",
      "times": "The ads return",
      "timesUnit": "times",
      "currency": "CZK",
      "formula": "Formula: visits × registration × attendance × purchase = orders, orders × plan price = revenue."
    }
  },
  "handover": {
    "eyebrow": "Step 18",
    "copy": "You have owned the Telegram bot since beta testing. Two final steps remain: we make you the owner of the whole instance, and you open your Owner Dashboard.",
    "lockedCopy": "Handover opens once every sales material is approved. We do not need anything else from you until then.",
    "lockedEyebrow": "What follows",
    "lockedTitle": "Handover has three clear parts",
    "lockedWaiting": "Waiting for you",
    "lockedLater": "Follows next",
    "lockedSteps": {
      "materials": "Approve every sales material",
      "ownership": "Set your instance owner role",
      "dashboard": "Hand over the Owner Dashboard and access"
    },
    "lockedNext": "Finish approving your sales materials. Handover opens automatically once they are all approved.",
    "sellingCopy": "Done: Buddy is fully yours and you manage it in your Owner Dashboard.",
    "sellingDate": "Handover completed {date}",
    "licenseEyebrow": "License",
    "licenseTitle": "What you can use",
    "licenseValid": "Valid from {date}",
    "accessEyebrow": "Access",
    "accessTitle": "Transferred tools",
    "proof": {
      "bot_transferred": "Bot ownership is transferred",
      "stripe_receiving": "Stripe receives payments",
      "assets_handed": "Sales assets are handed over",
      "first_campaign_or_trial": "First campaign or trial is running",
      "telegram_launch": "The bot is live on Telegram",
      "app_live": "The mobile app is live",
      "order_links_integrated": "Order links are in the sales page",
      "salespage_published": "The sales page is published"
    },
    "whatOwnershipTitle": "Instance ownership",
    "whatOwnershipCopy": "We set your role to owner in the instance. You get full control: statistics, users and settings.",
    "telegramCopy": "Tell us your personal Telegram account. We use it to set your owner role.",
    "telegramStored": "We will set the owner role for the account:",
    "telegramOwnerOnly": "The owner submits the account for the transfer.",
    "sellingDashboard": "The handover is complete. Sign in to your Owner Dashboard any time at dashboard.buddypro.ai.",
    "openDashboard": "Open Owner Dashboard",
    "step2Title": "Create your Owner Dashboard access",
    "step2Copy": "The Owner Dashboard is where you will manage Buddy: statistics, users, subscriptions and settings. Everything in one place, and yours alone.",
    "step2Lock": "Opens right after step 1. We need your Telegram ID: it sets your owner role, and without the role the bot will not issue the dashboard connection.",
    "licenseKeyEyebrow": "License key",
    "licenseKeyLabel": "Your license key",
    "licenseKeyCopy": "Copy",
    "licenseKeyCopied": "Copied",
    "licenseKeyOwn": "This key is your license: it proves Buddy belongs to you. You enter it during sign-up and once more when you connect your expert.",
    "licenseKeyPreparing": "We are preparing your license key. As soon as it arrives, you will see it here with a copy button.",
    "licenseKeyDelayed": "This is taking longer than usual. We know about it, we are on it and we will come back to you.",
    "licenseKeyUsed": "Your license key is already used in your Owner Dashboard account.",
    "flow": {
      "signupTitle": "Create your account at dashboard.buddypro.ai",
      "signupCopy": "On the sign-up page fill in your e-mail, a password, and paste the key from the field above into the License key field. Then click Sign Up.",
      "signupOpen": "Open sign-up",
      "syncTitle": "The Please Synchronize Your BuddyPro First screen",
      "syncCopy": "After sign-up the dashboard takes you straight here. Under How to prepare your expert it lists three steps:",
      "syncOpenTelegramKnown": "Open Telegram: go to the chat with your bot",
      "syncOpenTelegram": "Open Telegram: go to your BuddyPro expert chat in Telegram.",
      "syncUpdate": "Run the update command: send your bot",
      "syncCheck": "Come back here: once the update finishes, click Check Status.",
      "connectTitle": "The Connect Your Existing Expert screen",
      "connectCopy": "The dashboard recognizes your expert on its own and offers to connect it. It asks you for two things:",
      "connectLicense": "License Key Required: paste the key from the field above into the License Key field. You can also get it by sending /myLicense to your bot.",
      "connectCode": "Linking Code: send the /connectWeb command to your bot and it replies with a 12-character code. Paste it into the Linking Code field and click Connect Expert. Your dashboard opens and you will see your instance.",
      "openBotChat": "Open the chat with {bot}",
      "codeRoleReady": "Your owner role is set. If the bot does not answer /connectWeb with a code, wait a few minutes and try again.",
      "codeRoleWaiting": "This step works once the owner role is set. We set it automatically, usually within a few minutes, and we will let you know."
    },
    "confirmDashboard": "My dashboard opened and I can see my instance",
    "confirmSending": "Sending...",
    "confirmedNote": "Confirmed, your dashboard is running. The team now completes the handover; you will see the finished step here and in your journey.",
    "confirmOwnerOnly": "The account owner confirms the dashboard opened.",
    "docsLink": "You will find the detailed walkthrough with screenshots in the documentation.",
    "step1DoneReady": "Your owner role is set. You can continue with step 2.",
    "step1DoneWaiting": "We are setting your owner role for this ID automatically, it usually takes a few minutes. We will let you know once it is done. Until then you can create your account and copy the license key in step 2.",
    "ownerRolePill": "Setting the role",
    "confirmOwnerRoleWait": "The confirmation opens once we set your owner role. That happens automatically, usually within a few minutes. Without the role the bot will not give you a linking code, so there would be nothing to confirm.",
    "ownerRoleFix": {
      "owner_not_member": "The account with this Telegram ID is not a user of your Buddy yet, and the instance can only give the owner role to its own user. Open the chat with your bot, send it anything, then submit the ID here again.",
      "invalid_owner_id": "The stored number does not look like a Telegram ID. Send /myid to your bot and submit the number it replies with."
    }
  },
  "app": {
    "eyebrow": "Mobile app",
    "title": "Your app moves on its own timeline",
    "copy": "The Apple account, build, and store review have a separate workflow. Sales handover does not wait for them.",
    "checklistTitle": "Apple Developer account",
    "checklistCopy": "Confirm where your Apple Developer account stands. Fill in what you already have, so we know where you are and can start preparing your app. Only tick what is really behind you.",
    "apple": {
      "eyebrow": "Step 3",
      "lead": "For the app to appear in the stores under your company name, Apple requires your own developer account at 99 USD a year. You set it up once. We handle publishing and updates from then on.",
      "confirmPrompt": "As far as we can tell, the Apple enrollment is behind you. Confirm it and this step closes.",
      "haveAccount": {
        "question": "Do you already have an Apple Developer account?",
        "copy": "Based on your answer we only show you what you really need.",
        "yes": "Yes, I already have one",
        "no": "No, I still need to create it",
        "change": "Change my answer"
      },
      "existing": {
        "heading": "Connect your Apple Developer account",
        "lead": "You already have an account, so there is nothing to set up. We just need a few details to connect the app to your account.",
        "title": "Your account details",
        "copy": "Fill in the account type, your Team ID and the email you use in App Store Connect.",
        "active": "My Apple Developer Program membership is active (the yearly fee is paid).",
        "activeShort": "active membership",
        "submit": "Save account details"
      }
    },
    "appleGuide": {
      "eyebrow": "Prepare your account first",
      "title": "Apple Developer account, step by step",
      "intro": "The future account holder must complete the enrollment. Set aside about 20 minutes for the application. Apple then verifies the company, usually within 1 to 2 working days.",
      "approvalNote": "Watch for email from Apple after submitting. You can keep filling in the app package while the application is under review.",
      "needsTitle": "What you need",
      "needs": {
        "appleId": "An Apple ID with two-factor authentication enabled.",
        "identity": "Legal age and your full legal name. Do not use a nickname or alias.",
        "contact": "Email, phone number, and a physical address. Apple does not accept a P.O. box.",
        "company": "For a company, also prepare a D-U-N-S Number, legal entity name, work email on its domain, and a functional public website."
      },
      "pathTitle": "Choose the right account type",
      "path": {
        "recommended": "Recommended",
        "individualTitle": "Individual",
        "individualCopy": "Choose this only if you have no company and your legal name can appear as the seller on the App Store. You do not need a D-U-N-S Number, but your own name stays the seller.",
        "organizationTitle": "Organization",
        "organizationCopy": "This is the route we take with clients who buy their own app: the stores then show your company as the seller. The company must be a legal entity, it needs a D-U-N-S Number, and the account holder must have authority to sign for it."
      },
      "step": {
        "chooseTitle": "Register as an organization",
        "chooseCopy": "Register on developer.apple.com as an organization so the app ships under your company name. You can create the Apple ID along the way. Choose Individual only if you have no company.",
        "secureTitle": "Check your Apple ID and two-factor authentication",
        "secureCopy": "Sign in to your Apple ID and confirm that two-factor authentication is enabled. You cannot submit the enrollment without it.",
        "legalDetailsTitle": "Prepare exact personal details",
        "legalDetailsCopy": "Use your full legal name, email, phone number, and a home or business address without a P.O. box. You must be of legal age in your country.",
        "enrollTitle": "Open enrollment",
        "enrollCopy": "Start on the Apple Developer Program website or in the Apple Developer app. Sign in with the same Apple ID that will own the account.",
        "companyTitle": "If enrolling a company, verify its details",
        "companyCopy": "You need a valid D-U-N-S Number from Dun & Bradstreet, the exact legal entity name, a work email on the company domain, a functional public website on the same domain, and authority to sign for the company. D-U-N-S is free and government entities are exempt. It usually takes about 5 days. Contact Dun & Bradstreet if it takes more than 2 weeks.",
        "reviewTitle": "Submit and wait for the company check",
        "reviewCopy": "Apple verifies the company, usually within 1 to 2 working days. Sometimes it checks the details by phone, so stay reachable. Follow the instructions in Apple's email exactly.",
        "finishTitle": "Finish the membership and confirm the account",
        "finishCopy": "Agree to the license agreement and pay 99 USD for each membership year. Apple shows the fee in local currency. You then get access to App Store Connect, and you fill in the Team ID and confirm the account below."
      },
      "webLink": "Open Apple enrollment on the web",
      "appLink": "Open the Apple Developer app",
      "blockersTitle": "What most often blocks enrollment",
      "blockers": {
        "nickname": "A nickname or alias instead of the legal name.",
        "address": "A P.O. box instead of a physical address.",
        "twoFactor": "Two-factor authentication is not enabled for the Apple ID.",
        "duns": "An invalid or mismatched D-U-N-S Number for an organization.",
        "website": "The company website does not work, has minimal content, or does not match the work email domain."
      }
    },
    "duns": {
      "title": "What a D-U-N-S is and how to get one",
      "whatIs": "A D-U-N-S is a nine digit company number. Dun & Bradstreet assigns it, and it works as an international ID for businesses.",
      "whyApple": "Apple uses it to check that your company really exists. That is why it asks everyone opening a company account for one.",
      "free": "It is free, and plenty of companies already have one without knowing it.",
      "lookupLink": "Check your D-U-N-S with Apple",
      "lookupCopy": "Apple has its own page for this. Enter your company and you will see right away whether it has a number. If the list does not find it, you request one in the same place.",
      "prepareTitle": "What to have ready",
      "prepare": {
        "legalName": "The exact legal name of the company from the business register, not a trade name or an abbreviation.",
        "address": "The registered address of the headquarters, exactly as filed.",
        "contact": "The name, work email and phone number of the person who acts for the company."
      },
      "timingTitle": "How much time to allow",
      "timingCopy": "Dun & Bradstreet issues the number in about 5 business days and Apple learns about it within another two. So count on roughly a week, and that is before you even start the Apple enrollment.",
      "mismatchTitle": "When the details do not match",
      "mismatchCopy": "The number alone is not enough. If the name or the address differs from the register, Apple turns the application down. Dun & Bradstreet fixes it at support.dnb.com and it reaches Apple in about two days.",
      "individualNote": "Are you a sole trader with no company as a legal entity? Then skip the D-U-N-S and enroll as an individual. Your own name will be the seller in the stores."
    },
    "check": {
      "twoFactor": "Two factor authentication is enabled",
      "accountType": "Account type",
      "dunsRequired": "An organization account requires a valid D-U-N-S Number.",
      "dunsConfirmed": "I have a valid D-U-N-S Number and the details match the company",
      "fee": "I understand the 99 USD fee for each membership year",
      "registration": "Registration status",
      "teamId": "Apple Team ID",
      "teamIdHelp": "A 10 character code, found on developer.apple.com under Membership. We use it to attach the app to your account. You can add it later.",
      "connectEmail": "App Store Connect email",
      "connectEmailHelp": "The email you sign in to App Store Connect with. We send our team's invitation to it.",
      "twoFactorHelp": "Turn it on at appleid.apple.com under Sign In and Security. Apple will not accept the application without it.",
      "accountTypeHelp": "Organization means your company shows as the seller in the stores. Individual means your own name does.",
      "dunsConfirmedHelp": "The number, the name and the address all have to match the business register. Not sure whether your company has one?",
      "feeHelp": "Apple charges it once the account is approved and then once every year. Without it the app does not stay in the store.",
      "registrationHelp": "Pick where you are right now: not started, submitted and waiting on Apple, or active with the account running.",
      "registrationMissing": "A submitted or active enrollment",
      "ownerOnly": "The account owner opens and confirms the Apple account. You can see how far along it is.",
      "stepNotOpen": "This step is opening right now. Reload the page in a moment and the form will accept your answers.",
      "submitNeeds": "Still waiting on: "
    },
    "account": {
      "individual": "Individual",
      "organization": "Organization"
    },
    "registration": {
      "notStarted": "Not started",
      "submitted": "Submitted to Apple",
      "active": "Account is active"
    },
    "submit": "Confirm account setup",
    "submitting": "Confirming...",
    "confirmAccount": "I confirm that my developer account is set up",
    "confirmingAccount": "Confirming...",
    "accountConfirmed": "Your Apple Developer account is confirmed.",
    "confirmAccountError": "We could not confirm the account. Please try again.",
    "questionnaire": {
      "eyebrow": "Step 16",
      "title": "Mobile app questionnaire",
      "locked": "This opens after the sales page is approved.",
      "working": "Prefilling",
      "prefilling": "We are prefilling the questionnaire from your materials. You can wait a moment or start with an empty version now.",
      "prefillDelayed": "This is taking longer than it should. We know about it and we will finish it. Feel free to start now, you lose nothing.",
      "prefilledCopy": "We prefilled some answers from your materials. Read them through, change whatever reads differently, and fill in the rest.",
      "useEmpty": "Start with an empty questionnaire",
      "appleIndependent": "Apple Developer account setup runs separately and does not wait for page approval.",
      "focusCopy": "Fill in the mobile app package. Every step saves automatically."
    },
    "release": {
      "eyebrow": "Step 19",
      "focusCopy": "This is where you see how far your mobile app has got on its way to the stores. Getting it into the App Store and Google Play is our job.",
      "googlePlayPublisher": "We publish the app on Google Play, so you do not need to create an account.",
      "openAppStore": "Open in the App Store",
      "openGooglePlay": "Open on Google Play",
      "status": {
        "draft": {
          "title": "Waiting for your questionnaire",
          "copy": "We start preparing the app as soon as you send us the filled-in questionnaire. Until then there is nothing to report here."
        },
        "submitted_for_publishing": {
          "title": "Submitted for publishing",
          "copy": "We are preparing your app for the stores. If we need anything from you, we will reach out."
        },
        "in_publishing": {
          "title": "Publishing in progress",
          "copy": "Your app is being pushed to the App Store and Google Play."
        },
        "live": {
          "title": "Your app is in the stores",
          "copy": "The app is published and people can download it. The store links are right here."
        },
        "rejected": {
          "title": "A few changes needed",
          "copy": "The store review asked for changes. Update your app questionnaire and send it again, and we take care of the rest."
        },
        "archived": {
          "title": "The app is no longer in the stores",
          "copy": "We pulled the app from the stores. If you want it back, write to your partner."
        }
      }
    },
    "upsellTitle": "You can add a mobile app later",
    "upsellCopy": "Your current package does not include an app. Buddy and the complete sales workflow work without it.",
    "upsellCardTitle": "Your own icon and App Store distribution",
    "upsellCardCopy": "If you decide to add the app, we will agree on scope, price, and timing separately.",
    "upsellAction": "Request the app",
    "interestRecorded": "We recorded your interest in the app. We will get back to you with scope, price and timing.",
    "interestSending": "Recording your interest...",
    "upsellLearnMore": "Learn more about the app",
    "submittedLead": "We have your app package. Now it is on us and the stores.",
    "submittedTitle": "Package submitted",
    "submittedCopy": "Waiting for store approval, which usually takes 1-2 days. We will let you know the moment something moves."
  },
  "invites": {
    "eyebrow": "Your working group",
    "title": "Team invitations",
    "description": "Invited people can represent you during preparation. You still approve the price and handover."
  },
  "staff": {
    "eyebrow": "Operations access",
    "title": "You are signed in to the Launchpad",
    "description": "Client operations are available through the secured staff endpoints."
  },
  "questionnaire": {
    "loadError": "We couldn't load this right now. Nothing was lost, so just try again.",
    "loadingTitle": "Loading your questionnaire",
    "loadingSavedAnswers": "Restoring your saved answers and preparing the first question.",
    "clientCopy": {
      "q1TwinMode": "Should Buddy be your AI twin that speaks like you and for you? Or an independent AI expert with its own name and personality, based on your know-how?"
    },
    "mobile": {
      "navigationLabel": "Questionnaire questions",
      "position": "Question {current} of {total}",
      "previous": "Previous question",
      "next": "Next question"
    },
    "close": "Back to overview",
    "required": "Required question",
    "optional": "Optional question",
    "waitingTitle": "We are processing your recordings",
    "waitingCopy": "Your answers are safely stored. We will finish the brief automatically when the transcripts are ready.",
    "submittedWaiting": "The questionnaire has been submitted and closed. We are still finishing the recording transcripts.",
    "submittedClosed": "The questionnaire has been submitted and closed. The answers can no longer be changed.",
    "revealEyebrow": "Your brief is complete",
    "reveal": {
      "q1": {
        "title": "Your Buddy has your fingerprints",
        "copy": "We’re turning your answers into a Buddy you’ll recognize as yourself within the first two sentences."
      },
      "q2": {
        "title": "Your sales package starts here",
        "copy": "We’re turning your brief into a sales package your Buddy can take to its first customers."
      }
    },
    "backHome": "Back to overview",
    "submitError": "Submission failed. Check the required answers and try again.",
    "submitTechnicalError": "Submission failed because of a technical error on our side. Try again; if that does not help, write to your partner.",
    "loadNewerAnswer": "Load newer version",
    "voiceRecommendationTitle": "Recommendation: answer by voice",
    "voiceRecommendationCopy": "Record your answers as voice messages. It is faster and the answers tend to be richer. The transcript is saved automatically, and small typos do not matter at all. You do not need to correct anything; we can work with the transcript.",
    "navigation": "Questionnaire navigation",
    "back": "Back",
    "next": "Continue",
    "submit": "Continue to the next step",
    "submitAndContinue": "Submit questionnaire and continue to the next step",
    "submitting": "Submitting...",
    "save": {
      "idle": "This answer has not been saved yet",
      "dirty": "Saving shortly...",
      "saving": "Saving...",
      "saved": "Saved",
      "offline": "You are offline. This answer remains stored on this device.",
      "conflict": "This answer changed in another window.",
      "error": "The answer could not be saved. Try again."
    },
    "factCategory": {
      "identity": "Identity",
      "business": "Business",
      "audience": "Audience",
      "offer": "Offer",
      "voice": "Voice and style",
      "proof": "Results",
      "other": "Other information"
    },
    "fact": {
      "confirm": "Correct",
      "correct": "Edit",
      "irrelevant": "Not relevant"
    },
    "sourceUnknown": "Source from initial research",
    "permissionConfirmed": "I confirm these stories, results, and testimonials may be used in your sales materials.",
    "fields": {
      "buddyName": "Buddy name",
      "username": "Telegram username",
      "voice": "Voice",
      "meditation": "Should your Buddy be able to create meditations or motivational speeches on demand?",
      "email_range": "Email database size",
      "audience_range": "Social audience size",
      "mode": "Option",
      "model": "Sales model",
      "priceMin": "Minimum price in CZK",
      "priceMax": "Maximum price in CZK",
      "has_stripe": "Do you have a Stripe account?",
      "googleAccount": "Google account",
      "lexicon": "Your terms and names",
      "lexiconPlaceholder": "NoCzenglish Method\nspaced repetition\nGrowth Mindset",
      "selected": "Choose an answer",
      "community_where": "Write where.",
      "campaign_type": "Which campaign type do you run most often?",
      "payment_method": "How do you accept payments today?",
      "other_gateway": "Write which one.",
      "order_form_url": "If something is already running, add the order form link.",
      "materials": "Add links or describe what you have. Say what we should keep and what we can replace.",
      "channels": "How will new people find you? Choose what is realistic:",
      "budget": "How much can you spend in total on marketing your Buddy?",
      "style_source": "A link to your website or design we should use for colors and style.",
      "design_feel": "Describe in your own words how your Buddy's website should feel.",
      "inspiration": "Examples of websites you like, even from another field.",
      "real_vs_estimate": "Experience type",
      "list_engagement": "How often do you write to your list, and when was the last time? How do people respond?",
      "marketing_time_weekly": "How much time per week can you give to marketing your Buddy?",
      "own_links": "Add a link to your website or design we should use for colors and style.",
      "example_links": "Examples of websites you like, even from another field."
    },
    "usernameManual": "The team will check username availability while processing the brief.",
    "choose": "Choose an option",
    "yes": "Yes",
    "no": "No",
    "options": {
      "clone": "My clone",
      "knowledge_expert": "AI expert based on my know-how",
      "other": "Another voice",
      "under_1000": "Fewer than 1,000",
      "1000_4999": "1,000 to 4,999",
      "5000_19999": "5,000 to 19,999",
      "20000_plus": "20,000 or more",
      "two_day_trial": "Two-day trial",
      "webinar": "Webinar",
      "email_campaign": "Email campaign",
      "inside_program": "Inside my program",
      "recommend": "Recommend an option",
      "range": "I have a price range",
      "both": "Both",
      "none": "Not yet",
      "no_database": "I don't have one",
      "database_under_1000": "Up to 1,000",
      "database_1000_5000": "1,000 to 5,000",
      "database_5000_20000": "5,000 to 20,000",
      "database_more": "More",
      "has_stripe": "I have one",
      "no_stripe": "I don't have one",
      "1000_5000": "1,000 to 5,000",
      "5000_20000": "5,000 to 20,000",
      "more": "More than 20,000",
      "inactive": "Not active anywhere",
      "profiles_only": "I have profiles but do not post",
      "active": "I post actively",
      "community": "I have an active community",
      "unknown": "I do not know",
      "fapi": "FAPI",
      "other_gateway": "Another gateway",
      "owner": "Under my name",
      "standalone": "A standalone brand",
      "brand_recommend": "Recommend one",
      "paid_ads": "Paid advertising",
      "own_audience": "Reach my own network and community",
      "build_socials": "Start building social channels actively",
      "acquisition_recommend": "I do not know, recommend one",
      "real": "Real experience",
      "estimate": "My estimate",
      "yes": "Yes",
      "no": "No"
    },
    "repeat": {
      "item": "Item {number}",
      "add": "Add another item",
      "remove": "Remove",
      "minimum": "Add at least {count} complete items."
    },
    "items": {
      "q1_01_business_essence_and_value": "Tell us about your work as if you were explaining it to a friend who does not know you yet. What do you do, who do you help, and how are you different from others in your field? What should someone take away after five minutes with your Buddy? Where should Buddy be most useful to them?",
      "q1_02_twin_mode": "Should Buddy be your digital twin that speaks like you and for you? Or a standalone AI expert with its own name and personality, built on your know how?",
      "q1_03_target_client": "Describe your ideal customer in your own words. What do they usually come to you with? What do they write to you when they are at their lowest?",
      "q1_04_voice_and_impression": "How should Buddy come across? A strict trainer, a caring companion, a smart strategist, or something else entirely? The best way to show us is an example. Think of a moment when you truly helped a client and record how you talked to them back then.",
      "q1_11_addressing_and_lexicon": "Do you address your clients formally or informally? And what words, catchphrases, or favorite expressions do people hear from you all the time? Your Buddy will inherit them.",
      "q1_05_method_or_framework": "Do you have your own process, rules, or terms you use when advising people? A method name of your own, or steps you recommend to everyone? Tell us about them.",
      "q1_17_lexicon": "Do you use your own names, abbreviations, or unusual words in your work? For example, the name of a method or program, an acronym, a foreign term, or a name with a specific spelling. List them here, one per line, exactly as they should be written. You do not need to explain them.",
      "q1_06_boundaries": "What should Buddy not do? Are there topics it should avoid? And when should it refer people to you or to a professional?",
      "q1_12_never_advise": "What should your Buddy never say or advise? Advice you disagree with, myths you debunk. Also add brands or people it should never criticize.",
      "q1_07_buddy_name": "What will your Buddy be called? We will also try to find a free Telegram username right away.",
      "q1_08_voice_and_meditation": "Which voice should your Buddy speak with? And should it also create meditations?",
      "q1_09_first_message": "Imagine a client texts you in the morning with just 'Hi'. What do you reply? Write or record it exactly the way you would send it. We will then prepare a draft for you to edit.",
      "q2_01_origin_story": "How did you get to what you do today? Tell your story: where you started, the turning point, and what the journey taught you. The more personal you are, the stronger the marketing we can build for you.",
      "q2_02_intent_and_success": "Why are you launching your Buddy now and what should it bring you? Extra income, more free time, a bigger reach for your work? And how will you know in a year that it worked?",
      "q2_03_enemy_and_beliefs": "What have your clients usually tried before they found you, and why did it fail them? And what do you push back against in your field: what is the common advice you disagree with?",
      "q2_04_client_stories": "Tell two or three real client stories: who they were, what they came with, what changed, and the numbers behind it. For each one, say whether we may show it with their name or only anonymously.",
      "q2_05_objections": "What do people say when they end up not buying? Which objections do you hear over and over: price, time, distrust? And what tipped the scales for those who did buy?",
      "q2_06_proof": "Testimonials, reviews, and results we may show in marketing. Write or record what you have and paste links to where we can find them.",
      "q2_07_authority_numbers": "Your numbers as they stand today: how many years in the field, how many clients you have helped, how many talks, courses, or books you have behind you. We will only use what you tell us here, no guessing.",
      "q2_08_products_prices": "Your products and prices as we know them. Is this right? Correct anything that is off and add what is missing.",
      "q2_09_one_on_one_value": "What does an hour with you cost today: a consultation, mentoring, one-on-one work? And what would a person have to buy to get everything you can pass on: not just your own products, but also the books, courses or tools they would otherwise have to buy elsewhere?",
      "q2_10_price": "The price of your Buddy subscription: I have a range in mind (from, to), or recommend it in the strategy.",
      "q2_11_first_audience": "Who do you want to sell Buddy to first, and where do you already have these people? E-mail list, Instagram, YouTube, community, corporate clients? Where do your customers come from today? And roughly what is their age and gender makeup?",
      "q2_12_audience_size": "Size of your email list and audience (ranges).",
      "q2_13_launch_experience": "What sales campaigns have you run before? Webinars, email campaigns, paid ads, course launches? What worked best and what numbers do you remember?",
      "q2_14_involvement": "What are you personally willing to do for the launch? Host a live webinar, record short videos, send an email series to your people? How much time can you give it and when do you want to launch?",
      "q2_15_sales_model": "The sales model you prefer: two day trial / webinar / email campaign / inside my program / up to you.",
      "q2_16_stripe": "Stripe account: I have one / I don't (we will set it up together in the next step).",
      "q1_13_profile_photo": "Upload your profile photo: the one we should turn into the AI version of you and use as your Buddy's preview image. Ideally a portrait with your face clearly visible. You can also add a link to a full-resolution version.",
      "q1_10_google_account": "Which Google account should we share your know-how folder with?",
      "q2_17_big_idea": "If the market could remember just one idea from you, what would it be? Say it as if you were saying it from a stage. And add what makes your approach so different that it cannot be compared to anything people already know.",
      "q2_19_sales_photos": "Now more photos for your sales page: shots from events, client work, or filming, plus any additional portraits. Real photos make the page trustworthy. Add a link to a site or folder with full-resolution photos.",
      "q2_18_ai_value": "What do you see as the main benefit of people using your Buddy? Where will its biggest value be, and what is the key argument for your audience to buy it?",
      "q2_20_moment_of_need": "At what moments do your clients message you, or would need help, when you are not available? Think of two or three concrete situations where your Buddy would help them the most.",
      "q2_21_owner_usage": "Do you use your own Buddy yourself? If yes, describe a concrete situation where it truly helped: what you solved with it, what it brought you and where it saved you work. The more concrete you are, the stronger the argument you give your clients.",
      "q2_22_beta_group": "Do you have five to twenty fans or clients you would give Buddy to for a few weeks for free in exchange for honest feedback and stories? Write yes or no and exactly who you would approach.",
      "q1_16_expression_style": "What is typical of the way you express yourself? Do you use humor, comparisons or favorite examples? Do you say things straight or wrap them in cotton? Describe your energy, ideally with an example.",
      "q1_15_situational_replies": "What would you tell a client who is struggling and needs a boost? And one who just pulled something off? Answer in your own words, verbatim is best. That is exactly how your Buddy will speak in those moments.",
      "q1_14_initiated_messages": "A good companion knows how to reach out first. What should your Buddy actively ask its clients on its own? Write or record five to ten questions you would ask them yourself, like 'How did your week go?' or 'What does your cash flow look like?'"
    },
    "v2": {
      "items": {
        "q2_m01_database": "Do you have an email contact list?",
        "q2_m02_socials": "How active are you on social media?",
        "q2_m03_allies": "Do you know people or companies that speak to the same audience and could recommend your Buddy?",
        "q2_m04_practice": "Do you work with clients one on one?",
        "q2_m05_infoproducts": "Do you actively sell online courses or ebooks?",
        "q2_m06_campaign": "Have you ever run a sales campaign, such as a webinar, challenge, funnel, or launch?",
        "q2_m07_payments": "Do you have a Stripe account?",
        "q2_m08_promo": "Have you promoted your Buddy before, or do you already have unfinished materials or pages?",
        "q2_07_authority_numbers": "How many people have you helped over your career? An estimate is fine, and say since when you count. And what results stand behind you that you can present publicly?",
        "q2_02_intent_and_success": "Why are you launching your Buddy now and what should it bring you? Extra income, more free time, a wider reach for your work? How will you know in a year that it worked?",
        "q2_59_buddy_name": "What is your Buddy called? Write the name exactly the way we should write it in the copy.",
        "q2_60_addressing_and_lexicon": "Do you address your clients formally or informally? And what words, catchphrases, or favorite expressions do people hear from you all the time? We will write your sales page and the whole campaign in that same language.",
        "q2_61_voice_and_impression": "How do you come across to people when you work with them? A strict trainer, a caring companion, a smart strategist, or something else entirely? The best way to show us is an example: think of a moment when you truly helped a client and record how that conversation sounded.",
        "q2_62_expression_style": "What is typical of the way you express yourself? Do you use humor, comparisons or favorite examples? Do you say things straight or wrap them in cotton? Describe your energy, ideally with an example.",
        "q2_63_situational_replies": "What would you tell a client who is struggling and needs a boost? And one who just pulled something off? Answer in your own words, verbatim is best. Those exact sentences will show up in your copy.",
        "q2_64_method_or_framework": "Do you have your own process, rules, or terms you use when advising people? Describe your method the way you explain it to the person across from you. Not the definition from your website, your own words.",
        "q2_65_lexicon": "Do you use your own names, abbreviations, or unusual words in your work? For example, the name of a method or program, an acronym, a foreign term, or a name with a specific spelling. List them here, one per line, exactly as they should be written. You do not need to explain them.",
        "q2_66_initiated_messages": "What does your Buddy ask its clients on its own? List a few questions it sends them without being asked. We will use them in the examples of how Buddy works.",
        "q2_31_typical_customer": "Picture the typical customer who will get the most value from your Buddy. Now make that one specific person: how old are they, what do they do, and what situation are they in today? Describe them as if introducing them to a friend.",
        "q2_32_customer_words": "How would that person describe their problem to Buddy on their first visit? Use their words: what would they say, how would they feel, and what would they complain about?",
        "q2_33_customer_goals": "What does your typical customer want? What are their goals, and how would they know they achieved them?",
        "q2_34_customer_obstacles": "Which fears, worries, and doubts stand in their way? Say it in the words they would use.",
        "q2_53_failed_solutions": "How does your customer try to solve their problems today, or how did they try in the past? What did they try that did not work well, and why did it fail?",
        "q2_35_not_for": "Honestly, who is your Buddy not for? Who would you rather send elsewhere?",
        "q2_36_backstory": "Think of a moment when you were exactly where your ideal customer is today. Where were you, what was happening, and what did you feel? Tell us that scene.",
        "q2_37_breakthrough": "Where was the turning point? What one thing you understood or discovered made the old way impossible? And what happened next?",
        "q2_38_old_ways": "What had you tried before that did not work? Name two or three things and explain why they failed.",
        "q2_39_belief_vehicle": "What do people say when you tell them your AI can help with this? What is their first doubt about that path itself? Can you remember someone whose doubt you disproved, and what happened to them afterward?",
        "q2_40_belief_internal": "Why does your customer think it will not work for them even if it works for others? Do you know a story that proves otherwise?",
        "q2_41_belief_external": "What do they believe is holding them back from the outside, beyond their control? Time, money, family, health? What would you tell them?",
        "q2_42_big_idea": "Complete the sentence: If my customer believed one thing, namely that ..., they would have to get my Buddy because ...",
        "q2_43_use_cases": "What exactly will people use your Buddy for? Add use cases one by one: the situation they are in, what Buddy does, and what it gives them. Mark each as a real experience or your current estimate.",
        "q2_44_value_stack": "Now the value inside. Add the most valuable parts of your know-how one by one: a method, database, course, book, or experience. For each, say what it lets someone do and what it would cost to get elsewhere.",
        "q2_45_method_names": "Does your Buddy contain methods with names of their own? One or several. A named method sells better than a description.",
        "q2_21_owner_usage": "Do you use your own Buddy yourself? If yes, describe a specific situation where it truly helped: what problem you solved, what it brought you, and where it saved work. The more specific your example, the stronger the argument for your customers.",
        "q2_04_client_stories": "Tell two or three real client stories: the starting situation, what changed, and the results so far. For each, say whether we may use their name or only share it anonymously.",
        "q2_06_proof": "Testimonials, reviews, and results we may use in marketing. Record or write what you have and add links to where we can find it. Who already uses or has used your Buddy, and what do they say about it? You can also upload screenshots of messages people sent to Buddy or to you about it.",
        "q2_19_sales_photos": "Add more photos for the sales page: moments from events, client work, filming, and any extra portraits. Real photos make the page credible. Include a link to a website or folder with full-resolution files.",
        "q2_54_writing_style_samples": "Upload your own marketing materials you are proud of: emails, sales pages, social posts. They help us match your way of writing.",
        "q2_55_big_promise": "What is the main idea and the main promise that you believe will make people buy your Buddy when we present it?",
        "q2_46_sales_intent": "How do you realistically want to sell Buddy? As a standalone product, bundled with an online course, as a bonus to personal work, or with an educational club? Describe your intent.",
        "q2_47_value_economics": "What does your customer spend today to solve this problem elsewhere? Courses, consultations, products, experiments. What will they gain or save if Buddy works for them? Put a number on it in money or time.",
        "q2_56_price_history": "What is the most and the least expensive thing your customers have bought from you? What type of products and services have you sold most often, and what earned you the most money?",
        "q2_48_price_thinking": "How are you thinking about your Buddy's price? What would you like to charge and why? Share your full reasoning, including doubts. We will calculate the final price in the strategy.",
        "q2_49_guarantee": "Do you want to offer a money-back guarantee for Buddy? If yes, for how long? What are you genuinely prepared to fulfill? Promise only what you can stand behind.",
        "q2_50_deadline_reason": "Is there a real reason to decide by a certain date? Limited capacity, a group, your time?",
        "q2_11_first_audience": "Who do you want to offer your Buddy to first, and how will you reach these people?",
        "q2_13_launch_experience": "What usually works for you in sales? Webinars, campaigns, paid advertising, course launches? What worked best, and what do you remember about it?",
        "q2_23_red_lines": "Which things are truly off limits for you in marketing? Webinars, daily social posts, paid advertising, email marketing? Name only genuine boundaries. If you are even slightly open to something, leave it in play.",
        "q2_14_involvement": "What are you personally willing to do for the launch? Host a live webinar, record short videos, send an email series? How much time can you give it and when do you want the campaign to launch?",
        "q2_28_acquisition": "How will new people find you? Choose what is realistic: paid advertising, reaching your own network and community, actively building social channels, or asking us to recommend a route. What total budget can you put into marketing your Buddy?",
        "q2_57_expected_first_sales": "What is your realistic expectation for the first campaign? How many people do you think will buy your Buddy after its first public introduction?",
        "q2_58_longterm_promo": "How do you imagine promoting your Buddy long term? How will you keep bringing in new customers?",
        "q2_24_brand_face": "Should Buddy be sold under your name and face, as your AI clone that you recommend, or as a standalone brand? Or would you like a recommendation?",
        "q2_52_design_inputs": "How should your Buddy's website feel? Add a link to your website or design work for colors and style, plus any websites you like.",
        "q2_26_constraints": "Is there anything you must not claim about yourself or your results, such as health promises? List the limits your marketing must respect."
      }
    },
    "prefillEmpty": "We are still preparing your background material. You can skip this question and continue, the facts will appear here once verified.",
    "submitDossierPending": "All your answers are saved. The team is finishing your background material and we will complete the submission right after.",
    "resumed": "Welcome back. You are continuing exactly where you left off. Your answers are saved.",
    "prefillIntro": "This is what we found about you in public sources online. For each one just confirm, fix, or mark it as not relevant.",
    "foundOnline": "Found online",
    "saveHint": "Your answers are saved, so you can return anytime.",
    "closedHint": "The questionnaire is closed. Answers can no longer be changed.",
    "closedNext": "Continue to the next step",
    "prefillVoicePrompt": "Record a voice message introducing yourself, telling us what is accurate and what is not, and sharing more about yourself, your business, and your brand. Some details may be outdated, and occasionally they may refer to someone with the same name.",
    "resume": {
      "title": "Welcome back",
      "copy": "Here you can see what you have completed and continue where you left off.",
      "cta": "Continue the questionnaire",
      "answered": "Answered",
      "pending": "Waiting for you"
    },
    "list": {
      "progress": "Answered {done} of {total}",
      "allDone": "All done. Continue to the next step.",
      "answered": "Answered",
      "edit": "Edit",
      "viewAnswer": "View answer",
      "hideAnswer": "Hide answer",
      "savedAnswer": "Saved answer",
      "savedFile": "Saved file",
      "remaining": "To continue to the next step, finish these questions first:",
      "remainingFold": "{count} questions still open before the next step",
      "linkedPrefill": "Prefilled from your answer in the first questionnaire. Feel free to change it."
    },
    "username": {
      "free": "Username looks available, our team will confirm it.",
      "taken": "Username is taken, try another.",
      "invalid": "Use 5 to 32 letters, numbers, or underscores.",
      "checking": "Checking availability..."
    },
    "help": {
      "lexicon": "We transcribe your recordings into text. When we know these words in advance, they are transcribed correctly and your Buddy will say and write them exactly as you do. Your Buddy gets the same list for transcribing your know-how, voice notes and videos.",
      "existingBotUsername": "Your Buddy already lives on Telegram as {username}. The username stays, you can still adjust the Buddy's name.",
      "voiceAndMeditation": "You can pick a standard AI voice for Buddy, or a clone of your own voice built from your recordings. The clone sounds better and more personal, but costs about 20 percent more to run, and it lets Buddy create great meditations narrated in your voice, which adds a little more. You can switch meditations on or off at any time and limit how many one user can get.",
      "googleAccount": "We will share a Google Drive folder with this account. You will upload the courses, recordings, and documents we train Buddy from. You can change the account any time later."
    },
    "groups": {
      "business": {
        "title": "Your business",
        "copy": "Now we are setting up what Buddy needs to know: what you do, who you help and what to stay away from."
      },
      "persona": {
        "title": "Your Buddy's personality",
        "copy": "Now we are shaping how Buddy behaves: how it talks, how it reacts and what it asks on its own. The more of yourself you give it, the more it will sound like you."
      },
      "setup": {
        "title": "Practical setup",
        "copy": "A few practical things remain: name, voice, photo and access to your know-how."
      },
      "story": {
        "title": "Your story and intent",
        "copy": "Marketing sells you, not the technology. We need to hear who you are and why you are doing this."
      },
      "clients": {
        "title": "Your clients for real",
        "copy": "The words of real clients are the strongest copy a campaign can have."
      },
      "proof": {
        "title": "Proof and numbers",
        "copy": "We will only show what you confirm here. No guessing."
      },
      "offer": {
        "title": "Offer and price",
        "copy": "Your current prices tell us what your Buddy should cost and where it fits."
      },
      "launch": {
        "title": "Launch",
        "copy": "Where and how we introduce your Buddy first, matched to what you already have."
      },
      "miniprofile": {
        "title": "Eight quick choices",
        "copy": "Start with eight quick choices so the rest only asks what is relevant to you."
      },
      "about": {
        "title": "You in a nutshell",
        "copy": "First, we will anchor your verifiable results and your goal for Buddy."
      },
      "voice": {
        "title": "Your voice",
        "copy": "Your Buddy is already running, this part is about you. So your whole marketing sounds like you, not like us."
      },
      "customer": {
        "title": "Your Buddy's customer",
        "copy": "We need to hear one real person in their own words."
      },
      "story_v2": {
        "title": "Your story",
        "copy": "The scene, the breakthrough, and what failed before it."
      },
      "beliefs": {
        "title": "Beliefs and the core idea",
        "copy": "Name the doubts your marketing must overcome honestly."
      },
      "value": {
        "title": "Your Buddy and its value",
        "copy": "Concrete uses and the know-how a customer gets inside."
      },
      "pricing": {
        "title": "Sales intent, price, and guarantee",
        "copy": "Anchor the value, your price thinking, and promises you can keep."
      },
      "launch_v2": {
        "title": "Sales and your involvement",
        "copy": "Choose a path to your first customers that fits your real capacity."
      },
      "brand": {
        "title": "Design and brand",
        "copy": "Finally, align the name, visual direction, and claim boundaries."
      }
    },
    "profilePhoto": {
      "linksLabel": "Link to a full-resolution photo",
      "addLink": "Add link",
      "remove": "Remove",
      "file": "File",
      "upload": "Upload your profile photo",
      "uploadHint": "A portrait with your face clearly visible. PNG, JPG or WebP.",
      "uploadError": "The file could not be uploaded right now. Please try again."
    },
    "photos": {
      "linksLabel": "Links to photos (website, Google Drive, full-resolution folder)",
      "addLink": "Add link",
      "remove": "Remove",
      "file": "File",
      "upload": "Upload a photo",
      "uploadHint": "Shots from events, client work, extra portraits. PNG, JPG or WebP.",
      "uploadError": "The file could not be uploaded right now. Please try again.",
      "noPhotosButton": "I have no photos yet",
      "noPhotosNote": "We will build the sales page without photos. As soon as you have some, add them here and we will put them in."
    },
    "proof": {
      "linksLabel": "Links to references (reviews, posts, results pages)",
      "addLink": "Add link",
      "remove": "Remove",
      "file": "File",
      "upload": "Upload a reference screenshot",
      "uploadHint": "Client messages, reviews, results. PNG, JPG or WebP.",
      "uploadError": "The file could not be uploaded right now. Please try again."
    },
    "upload": {
      "converted_photo": "We cannot process this photo format yet (HEIC from an iPhone, TIFF or RAW). Save it as JPEG or PNG and upload it again. On a Mac use Preview and File > Export; on an iPhone switch Settings > Camera > Formats to Most Compatible.",
      "unsupported_type": "We do not accept this file format. Upload the photo as PNG, JPG or WebP.",
      "too_large": "The file is too large. The limit is 60 MB, so shrink the photo or send a link to the full resolution.",
      "quota": "You have run out of upload space. The daily limit clears itself within 24 hours; otherwise message your partner.",
      "storage": "Storage is not responding right now. Try again in a moment, or paste a link to the photo instead.",
      "offline": "You look offline. Reconnect and upload the photo again.",
      "not_an_image": "This file is not a photo inside, even though its name says so. Open it, save it as PNG or JPEG and upload it again.",
      "generic": "The file could not be uploaded right now. Try again, or paste a link to the photo.",
      "progress": "Uploading file {done} of {total}..."
    },
    "testOpenNote": "Test mode: the questionnaire is open and answers are saved. Submitting waits until the step really comes up.",
    "links": {
      "add": "Add link",
      "remove": "Remove"
    },
    "design": {
      "deferButton": "I'll leave it to you",
      "deferNote": "Our team will choose the design to match your brand and field. Anything you add below serves as inspiration.",
      "file": "File",
      "upload": "Upload an image, graphic, or PDF",
      "uploadHint": "PNG, JPG, WebP, or PDF",
      "remove": "Remove"
    },
    "writingSamples": {
      "linksLabel": "Links to your texts: sales pages, articles, posts.",
      "addLink": "Add link",
      "remove": "Remove",
      "file": "File",
      "upload": "Upload a file with your text",
      "uploadHint": "PDF, PNG, JPG, or WebP"
    },
    "staffReturned": "Your partner returned the questionnaire for rework: {reason}"
  },
  "celebration": {
    "nextLead": "Continue with",
    "dismiss": "Hide message",
    "steps": {
      "q1": {
        "title": "The Buddy brief is submitted.",
        "waiting": "We have your answers. The transcripts of your voice notes are still running; we will move you on as soon as they finish.",
        "queued": "We have your answers and they are with us now. We will let you know as soon as the next step opens."
      },
      "q2": {
        "title": "The sales brief is submitted.",
        "waiting": "We have your answers. The transcripts of your voice notes are still running; we will move you on as soon as they finish.",
        "queued": "We have your answers and they are with us now. We will let you know as soon as the next step opens."
      }
    }
  },
  "attachments": {
    "storageNotReady": "File uploads are not enabled yet."
  },
  "voice": {
    "modeLabel": "Answer method",
    "speak": "Speak",
    "write": "Write",
    "textPlaceholder": "Write your answer...",
    "warning35": "About 5 minutes of recording time remain.",
    "warning39": "About 1 minute of recording time remains.",
    "unsupported": "This browser does not support recording. You can write your answer instead.",
    "permissionError": "The microphone could not be opened. Check its browser permission.",
    "uploadError": "The recording could not be saved.",
    "start": "Start recording",
    "requesting": "Connecting the microphone...",
    "liveTranscript": "Keep talking. The transcript appears in the field as you speak.",
    "stopAndSend": "Finish and send",
    "resume": "Resume",
    "pause": "Pause",
    "finish": "Finish",
    "cancel": "Cancel",
    "status": {
      "recording": "Recording",
      "paused": "Recording paused"
    },
    "transcribing": "Transcribing your recording...",
    "transcribeError": "Try again or reply with text.",
    "silenceStopped": "More than 30 seconds of silence, so I stopped the recording.",
    "textFieldLabel": "Answer",
    "failure": {
      "unsupported": "This browser cannot record. You can type your note in the field below.",
      "permission": "The browser did not let us use the microphone. Allow it (the icon next to the page address) and try again.",
      "busy": "Another app or another tab is holding the microphone. Close it and try again.",
      "noDevice": "We found no microphone. Connect one and try again.",
      "micFailed": "The recording could not start. Please try again.",
      "offline": "The internet connection dropped. We are holding your recording, send it again once you are back online.",
      "transcribe": "We could not finish the transcript. We are holding your recording, try sending it again.",
      "sessionRenewed": "Your sign-in was renewed in the meantime, which is why the first try did not go through. We are holding your recording, send it again and it will.",
      "rateLimited": "That is a lot of recordings in a short time. Wait a few seconds and send it again, we are holding it here.",
      "tooLong": "This recording is too long to send in one piece. Please split it into shorter parts.",
      "send": "The note could not be sent. We are holding your recording, please try again.",
      "empty": "We heard no speech in the recording. Please try again.",
      "retrySend": "Send again",
      "retryRecord": "Try again",
      "heldNote": "We keep the recording here in your browser until you send it.",
      "resumeTitle": "You have an unfinished note here",
      "resumeBody": "Last time the recording did not get sent. You can send it now, or discard it.",
      "resumeSend": "Send the recording",
      "resumeDiscard": "Discard",
      "silenceStopped": "More than half a minute of silence, so I stopped the recording and nothing was transcribed.",
      "limitStopped": "The recording hit its maximum length, so I stopped it and I am saving it.",
      "textDraftRestored": "I brought back the text you started last time."
    }
  },
  "staffConsole": {
    "adminReload": "Reload",
    "clientPickerDuplicate": "record {index}",
    "duplicateRecord": {
      "one": "record {index} of {count}",
      "few": "record {index} of {count}",
      "other": "record {index} of {count}"
    },
    "duplicateRecordCreated": "created {date}",
    "eyebrow": "Operations overview",
    "adminTitle": "Manage the entire Launchpad",
    "partnerTitle": "All your clients in one place",
    "description": "Phases, pending work, and the next intervention are visible without switching tools.",
    "callLinks": {
      "title": "Stable call links",
      "hint": "Use the same link for every onboarding or marketing call with this client.",
      "onboarding": "Onboarding call",
      "marketing": "Marketing call"
    },
    "stableCallKind": {
      "onboarding": "the onboarding call",
      "marketing": "the marketing call"
    },
    "role": {
      "admin": "Administrator",
      "partner": "Partner"
    },
    "summary": "Client summary",
    "metricClients": "clients in view",
    "metricFeedback": "items to process",
    "feedbackLabel": {
      "one": "item",
      "few": "items",
      "other": "items"
    },
    "metricCalls": "scheduled calls",
    "matrixKicker": "Daily triage",
    "matrixTitle": "Clients and phases",
    "matrixTitleCount": "Clients and phases ({count})",
    "hideTestTenants": "Hide test clients",
    "hiddenDeepLink": "Client {name} is hidden by the test client filter.",
    "hiddenDeepLinkShow": "Turn off the filter and open them",
    "search": "Search clients",
    "searchPlaceholder": "Search clients",
    "mobileQueue": "Waiting on the team first",
    "mobileQueueSorted": "Sorted by who needs attention",
    "emptyMatrixSearch": "No search result",
    "emptyMatrixFilter": "No client matches the filter",
    "emptyMatrixAll": "No client is in the overview yet",
    "emptyMatrixSearchHint": "Try another name or e-mail. Addresses are searched too.",
    "emptyMatrixFilterHint": "Change the selection to return to the full overview.",
    "emptyMatrixAllHint": "Your first client will show up here.",
    "clearMatrixSearch": "Clear search",
    "clearMatrixFilter": "Clear the selection",
    "partnerFilter": "Partner",
    "partnerFilterAll": "All partners",
    "partnerFilterNone": "No partner",
    "partnerFilterUnnamed": "Unnamed partner",
    "partnerFilterGone": "The chosen partner has no clients now",
    "accountMenu": "Open account menu",
    "client": "Client",
    "currentPhase": "Current phase",
    "age": "Age",
    "nextCall": "Next call",
    "pending": "Open feedback notes",
    "stepProgress": "Progress",
    "legend": {
      "title": "Progress legend",
      "done": "green: done",
      "done_ahead": "green ring: done ahead",
      "next": "blue: on deck",
      "working": "cyan: in progress",
      "blocked": "red: blocked, step in",
      "locked": "empty: locked",
      "current": "white ring: where the client stands now"
    },
    "stepChapter": {
      "buddy": "Buddy",
      "sales": "Sales"
    },
    "stepPosition": {
      "global": "Step {position} of {total}",
      "buddy": "Buddy {position}/{total}",
      "sales": "Sales {position}/{total}",
      "doneAhead": {
        "one": "{count} completed ahead",
        "other": "{count} completed ahead"
      }
    },
    "stepOverview": {
      "title": "Client journey",
      "hint": "The same steps and states the client has in their Launchpad.",
      "clientNext": "The client is currently at {step}.",
      "state": {
        "locked": "They cannot open this step yet.",
        "next": "They can open this step and continue.",
        "working": "They see that the team or system is working on it.",
        "done": "They see this step as complete."
      }
    },
    "none": "Nothing yet",
    "detailKicker": "Working detail",
    "selectClient": "Select a client",
    "selectHint": "Select a client name in the matrix to open their working detail.",
    "clientSection": {
      "overview": {
        "eyebrow": "State and materials",
        "title": "Client overview",
        "lead": "Where the client stands, what the build was told, and what already exists."
      },
      "activity": {
        "eyebrow": "Record",
        "title": "Activity",
        "lead": "The history of their steps and of what we sent them. Nothing changes here.",
      "openNotes": {
        "one": "1 new note, open",
        "few": "{count} new notes, open",
        "other": "{count} new notes, open"
      },
        "auditTitle": "Client history",
        "notificationsTitle": "Client notifications"
      },
      "settings": {
        "eyebrow": "Changes",
        "title": "Settings",
        "lead": "The client's own details, their resources and reversible actions.",
        "resourcesTitle": "Client resources"
      }
    },
    "workspaceUnknown": {
      "title": "Step with no workspace",
      "body": "The console does not know this step. Pick another step in the journey on the left; if it keeps happening, the data is wrong on our side."
    },
    "saved": "The change has been saved.",
    "error": "The action could not be completed. No data was changed.",
    "emptyAnswers": "The client has no saved answers yet.",
    "emptySubmissions": "No build brief yet.",
    "emptyProfile": "The profile has no changes yet.",
    "emptyFeedback": "There are no items in the queue.",
    "emptyMatrix": "No client matches the search.",
    "emptyResources": "The client has no resources yet.",
    "emptyDeliverables": "The client has no deliverables yet.",
    "emptyAudit": "No activity here yet.",
    "clientActivity": {
      "order_links_integrated": "The order links are in the sales page.",
      "app_release_status_changed": "We changed the app release status.",
      "bot_transfer_false_done_repaired": "We repaired a bot transfer that had been recorded as done.",
      "bot_transfer_settings_updated": "The automatic bot transfer setting changed.",
      "bot_transferred_automatically": "The bot changed owner automatically.",
      "global_unlock_link_changed": "The shared call link was renamed.",
      "instance_folder_recorded": "We now know the Buddy's Drive folder.",
      "knowhow_handover_verified": "We verified the client can reach the folder.",
      "license_key_imported": "The license key is ready.",
      "material_regeneration_requested": "The partner ordered the material rebuilt from scratch.",
      "notification_label_fallback": "A material message had no material name.",
      "order_links_confirmed": "The client confirmed the order links.",
      "order_links_integration_requested": "The client sent the order links for processing.",
      "owner_role_done": "The instance moved to the client.",
      "owner_role_failed": "Handing the instance to the client failed.",
      "owner_role_id_refused": "We refused the client's Telegram id.",
      "owner_role_job_queued": "Handing the instance to the client is queued.",
      "owner_role_settings_updated": "The automatic instance handover setting changed.",
      "partner_brief_saved": "The partner saved a briefing note.",
      "sales_edit_merged": "The sales page edit was merged in.",
      "staff_override_approved": "The partner confirmed a step for the client.",
      "sales_only_import": "This step happened outside Launchpad and we recorded it.",
      "training_resume_requested": "The partner asked to resume the training.",
      "ai_avatar_received": "The client's AI avatar arrived.",
      "app_upsell_interest": "The client showed interest in the mobile app.",
      "apple_account_started": "The client started setting up an Apple account.",
      "auth_login": "The client signed in to Launchpad.",
      "beta_feedback_started": "Beta is live: the client sent the first note.",
      "bot_acceptance_reported": "The client confirmed taking over the bot on Telegram.",
      "bot_transfer_ready": "The bot transfer is ready, waiting for the client.",
      "buddy_ready": "Buddy is trained. Beta opened for the client.",
      "call_created": "A new call slot was added.",
      "call_enrolled": "The client booked a call.",
      "client_initialized": "The client account was created.",
      "client_selling": "Handover complete. The client is selling.",
      "client_updated": "Client details changed.",
      "client_confirmation_reverted": "The team returned a client confirmation: {what}.",
      "deliverable_client_approved": "The client approved {what}.",
      "deliverable_created": "A new version of {what} was created.",
      "deliverable_feedback_added": "New note on {what}.",
      "deliverable_updated": "{what} changed.",
      "dfy_build_launched": "We launched the build of {what}.",
      "prompt_rebuild_requested": "The team started regenerating the Buddy system prompt.",
      "prompt_patch_requested": "The team sent feedback to be worked into the Buddy system prompt.",
      "prompt_patch_proposed": "Alex prepared a proposed system prompt change.",
      "prompt_patch_approved": "The team approved the system prompt change.",
      "prompt_patch_rejected": "The team rejected the proposed system prompt change.",
      "prompt_patch_applied": "The system prompt change is written and the feedback is worked in.",
      "prompt_patch_failed": "Writing the system prompt change failed.",
      "feedback_processed": "A note was marked as processed.",
      "impersonation_acting": "The team switched the preview into acting for the client.",
      "impersonation_ended": "The team stopped viewing the app through the client's eyes.",
      "impersonation_looking": "The team put the preview back to looking only.",
      "impersonation_started": "The team viewed the app through the client's eyes.",
      "impersonated_write": "The team made this change for the client.",
      "instance_team_done": "The instance team is ready.",
      "instance_team_requested": "Instance team setup was requested.",
      "invite_accepted": "A tester accepted the invite.",
      "invite_created": "A tester invite was created.",
      "knowhow_folder_shared": "The know-how folder was shared.",
      "knowhow_resources_ready": "Know-how resources are ready for the client.",
      "knowhow_uploaded": "The client closed the know-how upload and sent the materials to training.",
      "magic_link_issued": "A sign-in link went out to the client.",
      "manual_state_forward": "The team manually moved the client's phase forward.",
      "map_apply_completed": "Alex applied changes from the mind map.",
      "map_apply_rejected": "A mind map change could not be applied.",
      "marketing_call_completed": "The Marketing video step is complete.",
      "milestone_set": "Milestone reached: {what}.",
      "onboarding_completed": "The Intro video step is complete.",
      "price_approved": "The client approved the price.",
      "profile_research_completed": "Client profile research is done.",
      "profile_research_failed": "Client profile research failed.",
      "profile_research_requested": "Client profile research was requested.",
      "q2_ready": "The sales questionnaire is closed. Sales work begins.",
      "questionnaire_submitted": "The client submitted a questionnaire: {what}.",
      "r2_orphan_sweep": "A system file cleanup ran.",
      "resource_updated": "Resource updated: {what}.",
      "sales_edit_done": "Alex finished the material edit.",
      "sales_edit_failed": "The material edit via Alex failed.",
      "sales_edit_requested": "Alex received a material edit request.",
      "sales_package_ready": "The sales package is complete.",
      "stable_call_link_redeemed": "The client used the stable link after {what}.",
      "staff_client_viewed": "A partner opened a read-only view of the client's Launchpad.",
      "stripe_import_settings_updated": "Stripe import settings changed.",
      "stripe_invite_confirmed": "The client confirmed the Stripe invite.",
      "training_result_received": "The twin training result arrived.",
      "unlock_code_created": "A call unlock code was created.",
      "answers_imported": "Answers were imported into the questionnaires.",
      "app_wizard_prefilled": "The app wizard is prefilled.",
      "app_wizard_submitted": "The client submitted the app wizard.",
      "bot_transfer_done": "The bot changed hands and now belongs to the client.",
      "bot_transfer_failed": "The bot transfer failed.",
      "bot_transfer_job_queued": "The bot transfer is waiting in the queue.",
      "bot_transfer_recipient_refused": "Telegram refused the transfer over the recipient's account.",
      "bot_transfer_returned_to_client": "The bot transfer went back to the client to fix.",
      "call_cancelled": "A call date was canceled.",
      "call_deleted": "A call date was deleted.",
      "call_enrollment_updated": "The call sign-up changed.",
      "call_series_cancelled": "The call series was canceled.",
      "call_series_created": "A new call series was created.",
      "call_series_extended": "The call series has more dates.",
      "call_updated": "A call date changed.",
      "client_owner_email_changed": "The client's address changed.",
      "client_step_confirmed": "The client confirmed a step.",
      "deliverable_deleted": "A draft material was deleted.",
      "deliverable_published": "We published material {what} to the client.",
      "dev_mail_allowlist_sent": "A development mail went to an allowlisted address.",
      "feedback_dismissed": "The note was closed as not relevant.",
      "feedback_note_deleted": "A team note was deleted.",
      "handover_owner_role_set": "The client owns the instance.",
      "handover_telegram_submitted": "The client sent their Telegram account.",
      "invite_revoked": "An invitation was revoked.",
      "knowhow_opened_from_sharing_email": "The client opened the folder from the sharing e-mail.",
      "manual_state_regression": "The team moved a step back.",
      "milestone_deleted": "Milestone {what} was cleared.",
      "map_apply": "Profile changes are waiting to be worked in.",
      "notification_delivery_tested": "The team tested message delivery.",
      "notification_requeued": "A message goes back into the queue.",
      "partner_material_added": "The partner added material for the client.",
      "partner_material_removed": "The partner removed a material.",
      "partner_message_sent": "The partner sent the client a message.",
      "profile_map_deleted": "The profile map was deleted.",
      "q1_ready": "The Buddy questionnaire is ready.",
      "q2_submitted_waiting": "The sales questionnaire is in and waiting for the team.",
      "questionnaire_submission_reverted": "The team sent the questionnaire back to the client.",
      "resource_deleted": "Record {what} was deleted.",
      "sales_edit_claimed": "The automation picked up the sales page edit.",
      "sales_edit_reclaimed": "The sales page edit was released for another attempt.",
      "salespage_netlify_domain_configured": "The sales page has its domain set.",
      "salespage_netlify_published": "The sales page was published to Netlify.",
      "sessions_revoked": "Active sessions ended.",
      "stable_call_links_ensured": "The stable call links are ready.",
      "staff_created": "Someone joined the team.",
      "staff_deactivated": "A team member was deactivated.",
      "staff_profile_updated": "A team member's profile changed.",
      "staff_reactivated": "A team member is active again.",
      "staff_role_changed": "A team member's role changed.",
      "stripe_connect_url_set": "The client got a Stripe connect link.",
      "stripe_connected": "Stripe is connected.",
      "submission_exported": "The questionnaire was exported to production.",
      "training_run_failed": "The twin's training crashed.",
      "training_run_started": "The twin's training started.",
      "transcript_requeued": "The transcript goes back for processing.",
      "unlock_code_renewed": "The join code was renewed.",
      "unlock_code_revoked": "The join code was revoked.",
      "payments_setup_checklist_updated": "The team updated the payment setup checklist.",
      "payments_setup_completed": "The team finished the payment setup.",
      "payments_setup_reopened": "The team reopened the payment setup.",
      "payments_setup_flag_changed": "The team changed whether the client has the payment setup."
    },
    "clientNotifications": {
      "to": "To",
      "recipientUnknown": "We could not resolve the recipient",
      "older": "Older notifications ({count})",
      "channel": {
        "email": "Email",
        "push": "Push",
        "other": "Other channel"
      }
    },
    "clientActivityOlder": "Older activity ({count})",
    "clientActivityUnknown": "We recorded a change on this client.",
    "emptyCalls": "The client is not enrolled in a call yet.",
    "emptyNotifications": "The client has no notifications yet.",
    "clientSettings": "Client and assignments",
    "assignment": {
      "partnerNone": "Nobody yet",
      "select": "Assign this client to",
      "pick": "Pick a partner",
      "assign": "Assign partner",
      "change": "Change partner",
      "saving": "Saving",
      "hint": "The partner gets an email and the client appears in their console. From then on, messages about this client go to them alone.",
      "failed": "The assignment did not go through. Reload the page and try once more."
    },
    "confirmationUndo": {
      "title": "Client confirmations",
      "hint": "Every confirmation can return to a state where the client can edit or approve it again.",
      "confirmed": "Confirmed by client",
      "button": "Return confirmation",
      "confirm": "Return the confirmation for “{item}” to {client}? The client will be able to edit and confirm it again.",
      "confirmButton": "Yes, return confirmation",
      "kind": {
        "profile": "Profile",
        "apple": "Apple account",
        "q1_submit": "Buddy brief submission",
        "q2_submit": "Sales brief submission",
        "strategy": "Sales strategy",
        "salespage": "Sales page",
        "emails": "Emails",
        "webinar": "Webinar",
        "knowhow_submit": "Know-how sent to training",
        "video_onboarding": "Intro video (step closure)",
        "video_marketing": "Marketing video (step closure)"
      }
    },
    "editClient": "Edit client and assignments",
    "email": "Email",
    "partner": "Partner",
    "owner": "Owner",
    "ownerId": "Owner ID",
    "includesApp": "App included",
    "source": {
      "direct": "Direct purchase",
      "upsell": "Upsell",
      "webinar": "Webinar"
    },
    "start": {
      "new": "New instance",
      "existing": "Existing instance"
    },
    "axes": "Variants",
    "regression": "Move the process back",
    "regressionWarning": "This action changes the progress history. Review the preview and confirm the exact client name.",
    "reasonLong": "Reason, at least 10 characters",
    "typeClientName": "Type the exact client name",
    "confirmRegression": "Confirm rollback",
    "state": {
      "locked": "Locked",
      "next": "Next",
      "working": "In progress",
      "done": "Done"
    },
    "stepStatus": {
      "locked": "Locked",
      "on_deck": "On deck",
      "review": "For review",
      "waiting_apple": "Waiting for Apple",
      "working": "We are working",
      "done": "Done",
      "open": "Open"
    },
    "reason": "Reason for the change",
    "milestones": "Milestones",
    "milestoneUnknown": "Unnamed milestone",
    "milestoneEditor": "Milestone editor",
    "milestoneDeleteReason": "Manual milestone removal confirmed by an administrator.",
    "confirmDelete": "Are you sure you want to delete this item?",
    "confirmMilestoneDelete": "Removing the milestone changes an audited proof. Client:",
    "confirmResourceDelete": "Deleting the resource removes it from the client process. Client:",
    "confirmDeliverableDelete": "Deleting removes this unpublished deliverable. Client:",
    "confirmDeliverablePublish": "Publishing replaces the earlier published version of the same type. Client:",
    "confirmCallDelete": "Deleting removes this call globally. Client in the current detail:",
    "confirmCodeRevoke": "A revoked code can no longer be used. Client in the current detail:",
    "process": "Mark as processed",
    "resourceEditor": "Resource editor",
    "visible": "Visible to the client",
    "save": "Save",
    "delete": "Delete",
    "deliverableEditor": "New deliverable",
    "openDeliverable": "Open deliverable",
    "deliverableUrl": "Deliverable URL",
    "deliverableStatus": "Deliverable status",
    "deliverableState": {
      "draft": "Draft",
      "review": "In review",
      "approved": "Approved"
    },
    "saveDeliverable": "Save deliverable",
    "publish": "Publish to client",
    "title": "Title",
    "create": "Create",
    "noCode": "No code has been issued yet",
    "codeIssued": "Code issued",
    "codeInactive": "Code no longer valid",
    "issueCode": "Issue code",
    "revokeCode": "Revoke code",
    "confirmRevoke": "Are you sure you want to revoke this code?",
    "callKind": "Call type",
    "callKindValue": {
      "onboarding": "Onboarding call",
      "marketing": "Marketing call"
    },
    "callLocale": "Call language",
    "callStartsAt": "Call start",
    "zoomUrl": "Call URL",
    "recordingUrl": "Recording URL",
    "saveCall": "Save call",
    "deleteCall": "Delete call",
    "clientNotEnrolled": "The client is not enrolled in this call.",
    "enrollmentStatus": "Enrollment status",
    "enrollment": {
      "enrolled": "Enrolled",
      "attended": "Attended",
      "watchedRecording": "Watched recording"
    },
    "enrollClient": "Enroll client",
    "saveEnrollment": "Save enrollment status",
    "oneTimeCode": "One-time code:",
    "openZoom": "Open Zoom",
    "retryNotifications": "Send all waiting notifications",
    "retryNotification": "Retry this notification",
    "notificationRetryHint": "We resend only this one message to its original recipient. Nothing else goes out.",
    "notificationDrainHint": "Sends every message currently waiting in the queue. Check how many there are first.",
    "notificationRetryDone": "This notification is scheduled for another delivery attempt. Check the result in the notification overview.",
    "notificationDrainDone": "Waiting notifications were processed. Check the result in the notification overview.",
    "notificationOperations": "Notifications and retries",
    "failedNotification": "Failed notification",
    "noFailedNotifications": "No failed notification",
    "notificationId": "Notification ID",
    "attempts": "Attempts",
    "createClient": "Create client",
    "createCall": "Create call",
    "staffProfile": "Team member profile",
    "attachmentId": "Attachment ID",
    "failedAttachment": "Attachment with a failed transcript",
    "noFailedAttachments": "No attachment to retry",
    "retryTranscript": "Retry this attachment transcript",
    "transcriptRetryHint": "Choose one client and one attachment. Only that attachment's transcript will be processed again.",
    "transcriptRetryDone": "This attachment's transcript will be processed again. Check the result in the client's attachments.",
    "staffId": "Team member ID",
    "photoUrl": "Photo URL",
    "photoQualityHint": "Use a sharp portrait with the full head and space around the face. The round preview below matches the client card.",
    "photoPreviewAlt": "Portrait preview on the client card",
    "photoPreviewCaption": "Check that the round crop does not cut off the forehead, chin, or sides of the face.",
    "calendlyUrl": "Calendly URL",
    "publicEmail": "Public email",
    "clientName": "Client name",
    "clientNameExample": "For example, Novak Studio",
    "ownerEmail": "Owner email",
    "ownerName": "Owner name",
    "ownerNameExample": "For example, Jane Novak",
    "ownerEmailExample": "expert@example.com",
    "ownerEmailChange": {
      "title": "Owner email",
      "hint": "The login link and every notification go to this address. A typo here means the client never signs in.",
      "current": "Current address",
      "newLabel": "New address",
      "repeatLabel": "New address again",
      "button": "Change the address",
      "confirm": "Rewrite the owner email? Client: {client}. New address: {email}.",
      "consequences": "Login links sent so far stop working, so send a new one. Queued notifications go to the new address. A client who is signed in stays signed in.",
      "confirmSave": "Yes, rewrite the address",
      "saving": "Saving the address...",
      "saved": "Done. The address is now {email}.",
      "invalid": "This is not a valid email address.",
      "same": "The client already has this address.",
      "mismatch": "The addresses do not match. Type the same one twice.",
      "error": {
        "generic": "The address could not be changed. Nothing was saved.",
        "email_taken": "Another user already has this address. Use a different one, or free that one up first.",
        "email_unchanged": "The client already has this address, there is nothing to change.",
        "invalid_request": "The address has the wrong shape. Check it and send it again.",
        "not_found": "The client or its owner could not be found. Reload the page.",
        "state_conflict": "Somebody changed the address in the meantime. Reload the client.",
        "idempotency_mismatch": "This request already ran with different content. Reload the client.",
        "forbidden": "You are not allowed to do this.",
        "csrf_invalid": "The security check failed. Reload the page.",
        "origin_invalid": "The security check failed. Reload the page.",
        "impersonation_readonly": "Nothing can be changed while viewing as the client."
      }
    },
    "missingOutput": {
      "adminWhere": "Add the missing output in the Settings section, in the resource editor. The step then unlocks itself.",
      "partnerWhere": "An admin adds this in the Settings section, in the resource editor. There is no button on your side, so tell them what is missing.",
      "openResources": "Open Settings"
    },
    "partnerId": "Partner ID",
    "clientId": "Client ID",
    "sendStep": "Run the selected dossier step",
    "dossierImportHint": "Choose one client. Launchpad runs only the step described below and leaves other clients unchanged.",
    "dossierImportDone": "The selected dossier step is complete. Check the result in this client's profile.",
    "dossierSteps": {
      "reserve": "1. The runner creates a dossier version and verifies its manifest.",
      "upload": "2. The runner uploads verified fact batches.",
      "finalize": "3. The runner checks the count and hash before publishing the dossier."
    },
    "dossierRunnerOnly": "These steps accept signed runner data. Raw JSON is not edited manually in the cockpit.",
    "issueLoginLink": "Issue a new sign-in link",
    "loginLinkIssued": "One-time link for the client:",
    "stripeConnect": {
      "title": "Stripe connect link",
      "hint": "Paste the link Alex generates for you. The client sees it as the Connect Stripe button. There is no timer; replace it only if Stripe rejects it.",
      "current": "Current link:",
      "clear": "Remove",
      "saved": "Saved. The client sees the link in their Stripe step.",
      "afterTariffs": "Once you set up the subscriptions in the Owner Dashboard, send the payment links to Alex via Edits with Alex on the sales page. He adds them to the page and you then publish the new version to the client."
    },
    "stripeImport": {
      "title": "Stripe client import",
      "masterSwitch": "Automatic import",
      "enabled": "on",
      "disabled": "off",
      "enabledHint": "A mapped Stripe purchase creates the client, sends the login link, and searches the public web for verifiable information using the client's name and email.",
      "disabledHint": "Import is off. Purchases are only logged below, no client is created. Safe rehearsal mode.",
      "enableLabel": "Enable automatic import",
      "defaultPartner": "Default partner",
      "selectPartner": "Select the default partner",
      "empireExistingPartner": "Partner for Empire with an existing Buddy",
      "selectEmpireExistingPartner": "Same as the default partner",
      "empireExistingPartnerHint": "A buyer of Empire who names their existing Buddy in the checkout Note field is assigned to this partner.",
      "saveSettings": "Save settings",
      "saved": "Settings saved.",
      "mappings": "Mapped products",
      "emptyMappings": "No products yet. Add the Stripe product that contains the Done For You service.",
      "addMapping": "Add product",
      "productId": "Stripe product",
      "productLabel": "Stripe product",
      "selectProduct": "Select a product by name",
      "selectLanguage": "Select the client's language",
      "includesApp": "includes mobile app",
      "loadProducts": "Load products from Stripe",
      "productsUnavailable": "Stripe products could not be loaded. Check the Stripe connection and try again.",
      "active": "active",
      "inactive": "inactive",
      "deactivate": "Deactivate",
      "activate": "Activate",
      "events": "Stripe events",
      "emptyEvents": "No events yet.",
      "outcome": {
        "imported": "imported",
        "switch_off": "logged only (import off)",
        "no_match": "no product match",
        "already_client": "client already exists",
        "deferred_unpaid": "awaiting payment",
        "error": "error",
        "unknown": "unknown result"
      },
      "jobs": "Profile building",
      "emptyJobs": "No profile is being built yet.",
      "jobStatus": {
        "pending": "queued",
        "running": "running",
        "done": "done",
        "failed": "failed",
        "canceled": "canceled",
        "unknown": "status unknown"
      },
      "selectClient": "Select a client by name",
      "runResearch": "Build client profile",
      "researchQueued": "The profile build is queued.",
      "researchCurated": "The profile already has an accepted manual dossier. Automatic research will preserve it.",
      "failure": {
        "notEnoughFacts": "The supplied name and email did not lead to a reliable profile. Confirm that they belong to the right person, then try again.",
        "temporary": "The connection was interrupted during the profile build. Try starting it again.",
        "unknown": "The profile could not be built from publicly verifiable information found using the name and email. Check the client details and try again."
      },
      "eventIssue": {
        "missingPartner": "The import stopped because no default partner is selected. Select one above and save the change.",
        "metadataFlag": "The product carries a launchpad key in Stripe, but its value is not 1. Fix it on the product in Stripe.",
        "metadataLabel": "The Stripe product is missing launchpad_label, or it runs past 120 characters. Add a short name for what the client is buying.",
        "metadataLanguage": "launchpad_language on the Stripe product has to be cs or en. Fix it and add the purchase through the manual import.",
        "metadataApp": "launchpad_app on the Stripe product has to be 1 or 0. Fix it and add the purchase through the manual import.",
        "metadataSource": "launchpad_source on the Stripe product has to be direct, upsell, or webinar. Fix it and add the purchase through the manual import.",
        "metadataStart": "launchpad_start on the Stripe product has to be new or existing. Fix it and add the purchase through the manual import.",
        "stalePartner": "The client was created, but the default partner in the settings is no longer active. Assign the client by hand and fix the setting.",
        "staleEmpirePartner": "The client was created, but the partner for Empire with an existing Buddy is no longer active. Assign the client by hand and fix the setting.",
        "metadataProductType": "productType on the Stripe product has to be start or empire. Fix it and add the purchase through the manual import.",
        "metadataProductLanguage": "language on the Stripe product has to be cs or en. Fix it and add the purchase through the manual import.",
        "metadataProductApp": "enableMobileApp on the Stripe product has to be true or false. Fix it and add the purchase through the manual import.",
        "metadataDialectsDisagree": "The Stripe product carries both metadata sets and they disagree. Leave one set on the product and add the purchase through the manual import.",
        "missingEmail": "The buyer email is missing in Stripe. Add it to the payment and repeat the import.",
        "noProducts": "The payment has no product. Check the purchase items in Stripe.",
        "profileAlreadyQueued": "The client was created and their profile build is already queued. You can see its status above.",
        "repeatedPurchase": "Launchpad has already processed this purchase. No new client was created.",
        "stripeConnection": "Launchpad could not read the Stripe data. Check the connection and try the import again.",
        "clientCreation": "The client could not be created. Check their email and the default partner.",
        "unknown": "The import could not be completed. Check the purchase details and try again.",
        "staleSalesOnlyPartner": "The client was created, but the partner for sales only is no longer active, so the default partner was assigned. Check the assignment and fix the setting.",
        "metadataPayments": "launchpad_payments on the Stripe product has to be 1 or 0. Fix it and add the purchase through the manual import."
      },
      "configSource": {
        "metadata": "This purchase was configured by the product metadata in Stripe.",
        "mapping": "This purchase was configured by the product mappings in Launchpad."
      },
      "loadFailed": "Failed to load the overview.",
      "manualImport": "Manual client import",
      "manualImportHint": "The research receives only the client's name and email. It uses them to find verifiable information on the public web, so confirm they belong to the right person before starting. The import also works while automatic import is off.",
      "manualName": "Client name",
      "manualEmail": "Client email",
      "manualPartnerDefault": "Use the default one",
      "manualImportButton": "Import client and build profile",
      "manualImportDone": "The client is imported and their profile is being built.",
      "manualImportFailed": "Import failed. Check the email and the default partner.",
      "addMappingNeedsProduct": "Pick the product you want to map.",
      "selectJourney": "Select the client's journey",
      "addMappingNeedsLanguage": "Pick the language this product serves the client in. The whole application and every material follow it.",
      "addMappingNeedsLoad": "Load the products from Stripe first, then pick the one you want to map.",
      "manualImportNeedsJourney": "Pick which half the purchase covered. The full journey starts at the intro video, sales only starts at the marketing video. The client detail is the only place to correct it.",
      "clientLabel": "Client",
      "salesOnlyPartner": "Partner for sales only",
      "selectSalesOnlyPartner": "Same as the default partner",
      "salesOnlyPartnerHint": "Every purchase of a product with launchpad_journey=sales_only is assigned to this partner, also when the buyer names their Buddy in the Note field."
    },
    "phaseName": {
      "home": "Home",
      "onboarding_call": "Intro video",
      "q1": "Preparation questionnaire",
      "knowhow": "Know-how",
      "training": "Buddy training",
      "beta": "Beta testing",
      "marketing_call": "Marketing video",
      "q2": "Sales questionnaire",
      "sales": "Sales materials",
      "stripe": "Stripe connection",
      "handover": "Handover",
      "app": "Mobile app"
    },
    "phaseInfo": {
      "home": "Client home: step summary, progress and next actions. Always available.",
      "onboarding_call": "The client watches the intro video. The next step (questionnaire) opens at the video's configured unlock time.",
      "q1": "The client describes themselves, their clients, method, boundaries, the Buddy name and voice, and uploads a profile photo. The instance is trained from it.",
      "knowhow": "The client confirms Google accounts and fills the shared folder with materials. The team builds the knowledge base from it.",
      "training": "The team builds the instance from the answers and know-how. The client waits, sees the avatar animation, first version within 24 hours.",
      "beta": "The client and a few testers chat with the Buddy and send feedback. The team applies it.",
      "marketing_call": "The video about selling the instance. Unlocks the sales questionnaire at the configured time.",
      "q2": "The client describes their story, clients, proof, prices and audience plus sales-page photos. The sales package is built from it.",
      "sales": "The team prepares the audit, strategy, sales page and e-mails. The client confirms them step by step.",
      "stripe": "The client sets up Stripe, invites your e-mail into the team and you help configure payments.",
      "handover": "The client sends their Telegram ID for the owner role and connects their Owner Dashboard. Done when the client confirms the dashboard opened.",
      "app": "For app packages: Apple account, build and store reviews. Without the app, the add-on offer."
    },
    "myProfile": {
      "language": {
        "title": "Console language",
        "copy": "The choice is saved to your account and applies to the whole console and to the client screens."
      },
      "open": "My profile",
      "kicker": "Your card",
      "title": "Edit your profile",
      "name": "Name",
      "photo": "Profile photo",
      "choosePhoto": "Choose photo",
      "changePhoto": "Change photo",
      "photoSaved": "The current photo is saved, clients see it on your card",
      "noPhotoChosen": "No photo selected yet",
      "photoTooSmall": "The photo is too small, so it was not used. Choose an image at least 384 × 384 px.",
      "photoUnreadable": "We cannot read this file. Save the photo as JPEG, PNG or WEBP and try again.",
      "copyValue": "Copy full value",
      "copiedValue": "Copied. You can now paste it where you need it.",
      "calendly": "Calendly link",
      "email": "E-mail for clients",
      "emailHint": "Clients reach you at this email when they need help with the payments step.",
      "telegram": "Telegram username",
      "telegramId": "Telegram ID (from /myid)",
      "telegramHint": "We add you to every instance team. Get the ID by sending /myid to any Buddy.",
      "save": "Save profile",
      "saving": "Saving...",
      "saved": "Saved. Clients see the new card immediately.",
      "previewLabel": "This is how your card shows to clients in their Launchpad:",
      "telegramIdPlaceholder": "e.g. 123456789",
      "phone": "Phone with country code",
      "phonePlaceholder": "+420 777 123 456",
      "phoneHint": "Your clients will see a Message on Telegram button on your card. If your Telegram username is filled in, the chat opens through it. With the phone alone, the chat opens only if Telegram Privacy lets people find you by your number.",
      "vPhone": "Enter the phone with its country code, for example +420 777 123 456",
      "calendlyPlaceholder": "https://calendly.com/...",
      "vName": "Please fill in a name (at least 2 characters).",
      "vPhoto": "The photo must be an https URL, or upload a file with the button.",
      "vCalendly": "The calendar link must start with https://",
      "vEmail": "The client-facing email is not valid.",
      "vTelegram": "Telegram username: 5 to 32 characters, letters, digits and underscores.",
      "vTelegramId": "Telegram ID is the number from /myid (5 to 15 digits).",
      "google": "Google account for Drive folders",
      "googleHint": "We share your clients' know-how folders with this account. When empty, the client e-mail is used.",
      "vGoogle": "The Google account must be a valid e-mail address."
    },
    "answerEmpty": "No answer",
    "submissionStatus": "Status",
    "submissionState": {
      "draft": "In progress",
      "waiting_for_transcripts": "Waiting for transcripts",
      "ready": "Ready for build",
      "exported": "Handed to build"
    },
    "submissionExportedAt": "To build",
    "submissionBuddy": "Buddy",
    "submissionLanguage": "Market language",
    "submissionLanguageName": {
      "cs": "Czech",
      "en": "English"
    },
    "submissionInstance": "Instance",
    "submissionInstanceMode": {
      "new": "new",
      "existing": "existing"
    },
    "submittedAt": "Submitted",
    "rawData": "Technical data",
    "yes": "Yes",
    "no": "No",
    "crm": {
      "title": "CRM record",
      "none": "The client is not in the CRM yet.",
      "error": "The CRM could not be loaded right now.",
      "errorHint": "The CRM connection did not respond. The client's Launchpad data is unchanged.",
      "company": "Company",
      "phone": "Phone",
      "website": "Website",
      "meeting": "Meeting",
      "meetingYes": "Booked",
      "meetingNo": "None booked"
    },
    "purchaseLicense": {
      "title": "License from the purchase",
      "unconfigured": "The BuddyPro license API is not connected yet, so licenses from purchases are not loaded.",
      "error": "The licenses from the purchase could not be loaded right now.",
      "errorHint": "The license API did not respond. The client's Launchpad data is unchanged.",
      "none": "No license from a purchase exists for the client email yet.",
      "credits": "Credits",
      "creditsCount": {
        "one": "1 credit",
        "few": "{count} credits",
        "other": "{count} credits"
      },
      "creditsUnknown": "Not stated",
      "productType": "Package",
      "productTypeUnknown": "Not stated",
      "bot": "Bot",
      "botNone": "Not on a bot yet",
      "state": "Status",
      "stateActive": "Active",
      "stateDisabled": "Switched off"
    },
    "notify": {
      "title": "Send the client a message",
      "hint": "An e-mail (and push, if they have the app) goes out immediately. Use it to alert the client.",
      "subject": "Subject",
      "message": "Message",
      "send": "Send to client",
      "sending": "Sending...",
      "sent": "Sent."
    },
    "resourceName": {
      "drive_folder": "Google Drive folder",
      "url_doc": "Links document",
      "trial_link": "Buddy trial invite",
      "license": "License",
      "bot_transfer_state": "Telegram bot transfer",
      "app_state": "Mobile app state",
      "stripe_setup": "Stripe setup",
      "q1_question_overrides": "Questionnaire 1 personalization",
      "q2_question_overrides": "Questionnaire 2 personalization",
      "knowhow_google_account": "Know-how Google accounts",
      "handover_telegram": "Client Telegram account",
      "instance_folder": "Buddy instance folder",
      "license_key": "License key",
      "dfy_package": "DFY package",
      "order_links": "Order links",
      "knowhow_handover": "Know-how folder handover",
      "staff_overrides": "Partner overrides",
      "app_interest": "App interest",
      "instance_team_request": "Instance team request",
      "sales_edit_request": "Audio material edit",
      "onboarding_video": "Intro video",
      "marketing_video": "Marketing video",
      "step_confirmations": "Step confirmations",
      "partner_materials": "Partner materials"
    },
    "resourceField": {
      "accepted_at": "Accepted",
      "app_store_review": "App Store review",
      "bot_username": "Bot",
      "build": "App build",
      "client_invited_team": "Client invited the team",
      "confirmed_at": "Confirmed",
      "description": "Description",
      "duration_seconds": "Length in seconds",
      "email": "E-mail",
      "google_account_required": "Google account required",
      "google_play_review": "Google Play review",
      "invite_limit": "Invite count",
      "label": "Name",
      "next_actor": "Next up",
      "note": "Note",
      "requested_at": "Requested",
      "resolved_at": "Resolved",
      "shared_at": "Shared",
      "shared_email": "Shared account",
      "state": "State",
      "status": "State",
      "telegram_username": "Telegram",
      "title": "Title shown to the client",
      "transferred_at": "Transferred",
      "type": "Type",
      "updated_at": "Updated",
      "url": "Link",
      "valid_from": "Valid from",
      "verified_at": "Verified",
      "verified_receiving": "Payments receiving verified"
    },
    "videos": {
      "title": "Videos",
      "none": "No video for this client yet.",
      "kind": {
        "onboarding_video": "Intro video",
        "marketing_video": "Marketing video"
      },
      "watched": "Watched",
      "completed": "Completed",
      "notStarted": "Not started yet",
      "source": {
        "client": "Client's own video",
        "global": "Default video"
      },
      "unconfiguredHistory": "The video is no longer configured; the watch history stays.",
      "defaultsTitle": "Default videos",
      "defaultHint": "Applies to every client without their own video. Set a per client video in the client detail resource editor.",
      "urlLabel": "Video address (mp4 or stream)",
      "titleLabel": "Title shown to the client",
      "durationLabel": "Duration in seconds (required when you set the unlock time)",
      "confirmClearDefault": "Really remove the default video? Clients with their own video keep it.",
      "saved": "Saved.",
      "unlockAtLabel": "Next-step unlock time (seconds from the start)",
      "unlockAtHint": "The video moment when the client's next step opens. Without it the step opens on watch-through.",
      "unlockReady": "Next step unlocked"
    },
    "instance": {
      "title": "BuddyPro instance",
      "detail": "Instance detail (log, agentic and debug mode)",
      "openBot": "Open bot",
      "drive": "Drive folder",
      "trial": "Trial invite",
      "modesHint": "The instance detail on the Hub lets you control the instance (agentic mode), debug it and see the full creation log including the system prompt.",
      "teamTitle": "Instance team membership",
      "teamHint": "First open the bot once and message it (Telegram refuses otherwise). Then click and we add you as a team member with admin permissions.",
      "teamAutoHint": "Your Telegram ID is on file, so we add you to the team as soon as the bot is ready. Use the button below to trigger it right now.",
      "teamNeedIdHint": "Fill in your Telegram ID (from /myid) in My profile and write to the bot once. After that we add you to the team automatically.",
      "teamFailedHint": "Telegram refuses to add anyone who has never written to the bot. Open the bot, send it any message and press Try again.",
      "join": "Add me to the team",
      "joining": "Sending...",
      "teamPending": "Request running, you will be added within minutes.",
      "teamDone": "You are a team member with admin rights.",
      "teamFailed": "Adding you to the team failed.",
      "needTelegram": "Fill in your Telegram ID (from /myid) in My profile first.",
      "manage": "Manage the instance",
      "retry": "Try again"
    },
    "salesEdit": {
      "sending": "Uploading...",
      "queued": "Sent. Transcription and the edit run automatically.",
      "processing": "The edit from your recording is running. The new version appears here on its own.",
      "done": "Edit finished, the new material version is in the list.",
      "failed": "The edit failed:",
      "hint": "Say what to change in the material. We transcribe it and the AI applies the edits as a new version."
    },
    "paneError": "This tab failed to render. The rest of the console keeps working.",
    "instanceMode": "Instance",
    "journeyMode": "Journey",
    "journeyHint": "Sales only means the Buddy was built outside the system. The client walks the six steps of the sales chapter and never sees Buddy setup or the handover.",
    "journey": {
      "full": "Full journey",
      "sales_only": "Sales only"
    },
    "clientGender": "Client gender",
    "gender": {
      "unknown": "Unknown",
      "female": "Female",
      "male": "Male"
    },
    "purchaseMode": "Purchase",
    "appMode": "Mobile app",
    "axis": {
      "instance_new": "New instance",
      "instance_existing": "Existing instance",
      "purchase_direct": "Direct purchase",
      "purchase_upsell": "Upsell",
      "purchase_webinar": "From webinar",
      "app_yes": "Yes",
      "app_no": "No"
    },
    "enum": {
      "not_started": "not started",
      "in_progress": "in progress",
      "done": "done",
      "failed": "failed",
      "new": "new",
      "preparing": "preparing",
      "awaiting_client": "awaiting client",
      "client_confirmed": "client confirmed",
      "transferred": "transferred",
      "none": "no one"
    },
    "answerConfirmed": "The client confirmed the details are correct.",
    "answerChoice": {
      "clone": "Digital twin (speaks as the expert)",
      "knowledge_expert": "Standalone AI expert with its own persona"
    },
    "answerRange": {
      "under_1000": "under 1,000",
      "1000_4999": "1,000 to 4,999",
      "5000_19999": "5,000 to 19,999",
      "20000_plus": "20,000+"
    },
    "metricUnassigned": "without a partner",
    "unassigned": {
      "eyebrow": "Today's job",
      "title": "Clients with no partner",
      "lead": "Pick the partner who takes the client over. Until then the client sees on their dashboard that a partner is being assigned.",
      "empty": "Every client has a partner.",
      "truncated": "Showing the first {shown} of {total} clients with no partner. Assign these and the next ones load.",
      "product": "Product",
      "productManual": "Created by hand",
      "productUnknown": "From a purchase we cannot name",
      "market": "Market",
      "arrived": "In Launchpad since",
      "profileFacts": { "one": "{count} fact in the profile", "few": "{count} facts in the profile", "other": "{count} facts in the profile" },
      "profileEmpty": "No profile yet",
      "openClient": "Open the client profile",
      "assignLabel": "Partner",
      "assignSubmit": "Assign",
      "assigning": "Assigning...",
      "assignDone": "Done, the client has a partner.",
      "errorPartnerUnavailable": "That partner is no longer active. Pick somebody else.",
      "error": "The assignment did not go through. Try again.",
      "noPartners": "The team has no active partner. Add somebody in Administration first."
    },
    "metricStuck": "stuck (14+ days)",
    "staffProfileMember": "Team member",
    "dossierPayload": "Step data (JSON)",
    "team": {
      "title": "Team",
      "hint": "Add a member and decide their role. A partner can become an admin. The last active admin is protected.",
      "email": "E-mail",
      "name": "Name",
      "nameExample": "For example, Thomas Novak",
      "emailExample": "partner@example.com",
      "role": "Role",
      "sendInvite": "Send sign-in link",
      "add": "Add member",
      "exists": "This e-mail is already on the team.",
      "inviteReady": "Sign-in link (visible only to you):",
      "you": "you",
      "inactive": "Inactive",
      "clients": "Clients",
      "lastSeen": "Last seen",
      "never": "never",
      "profileOk": "Profile complete",
      "profileMissing": "Profile missing",
      "deactivate": "Deactivate",
      "reactivate": "Reactivate",
      "sendLink": "Send sign-in link",
      "reassignTo": "Reassign clients",
      "choose": "Choose",
      "assignLater": "Assign later",
      "allFiltered": "Every partner in this list is a test member. Turn off the test filter or add a team member.",
      "showTestMembers": "Show test members too",
      "confirmReassign": "Reassign and deactivate",
      "needHeir": "This partner has clients. Choose who inherits them.",
      "lastAdmin": "The last active admin cannot be deactivated.",
      "lastAdminNote": "Last admin: role and status are locked.",
      "roleBlocked": "The role change could not be applied.",
      "linkSent": "Sign-in link sent.",
      "adminCount": "{count} admins",
      "partnerCount": "{count} partners",
      "search": "Search team",
      "filterRole": "Role",
      "filterActivity": "Account activity",
      "allRoles": "All roles",
      "onlyActive": "Active only",
      "onlyInactive": "Inactive only",
      "allActivity": "Active and inactive",
      "activeHeading": "Active team",
      "inactiveHeading": "Inactive accounts",
      "noResults": "No team member matches this filter.",
      "heirsAllFiltered": "Every possible heir is a test account. Turn off the test client filter, or add a real partner to the team."
    },
    "activity": {
      "empty": "No activity yet.",
      "openClient": "Open client",
      "systemActor": "System operation",
      "noTarget": "No client detail",
      "version": "version {version}",
      "materialCreated": "Material created",
      "materialUpdated": "Material updated",
      "materialPublished": "Material published",
      "materialFailed": "Material build failed",
      "unknown": "Operational change",
      "unknownDetail": "If you do not recognize this change, check the related surface.",
      "detail": {
        "app_release_status_changed": "We recorded where the app stands in review.",
        "bot_transfer_false_done_repaired": "A bot transfer had been recorded as done without happening. The state is back.",
        "bot_transfer_settings_updated": "The automatic bot transfer is now on or off.",
        "bot_transferred_automatically": "The bot changed owner with no hand step. The client's next step opened.",
        "global_unlock_link_changed": "The call link has a new name. The old one stops working.",
        "instance_folder_recorded": "We know the Buddy's Drive folder. The handover can build on it.",
        "knowhow_handover_verified": "Google confirmed the client can see the folder.",
        "license_key_imported": "The key is on the client. They can copy it in the handover step.",
        "material_regeneration_requested": "The material is being made again from scratch on the current briefing.",
        "notification_label_fallback": "A material notification could not name it. Check the kind mapping.",
        "order_links_confirmed": "The client approved the links. They can go into the page.",
        "order_links_integrated": "The sales page leads to the order. The client can take it away.",
        "order_links_integration_requested": "The sales page edit is running. The result publishes itself.",
        "owner_role_done": "The client owns the instance. We no longer configure it.",
        "owner_role_failed": "Setting the owner did not go through. Look at the handover queue.",
        "owner_role_id_refused": "The client's id cannot be used. They were asked to fix it.",
        "owner_role_job_queued": "Waiting for the run that sets the owner.",
        "owner_role_settings_updated": "The automatic instance handover is now on or off.",
        "partner_brief_saved": "The briefing changed. It applies from the next build.",
        "sales_edit_merged": "A new version of the sales page is out.",
        "staff_override_approved": "A partner decided for the client and wrote why.",
        "sales_only_import": "Sales-only import. The step happened outside the system and no mail went out.",
        "training_resume_requested": "The twin's training should start again.",
        "staff_created": "The member is on the team. Check their role and profile.",
        "staff_role_changed": "The new role applies to future Launchpad work.",
        "staff_deactivated": "The account can no longer sign in. Check that every client has a partner.",
        "staff_reactivated": "The account can sign in again.",
        "call_created": "The date is in the call overview.",
        "call_updated": "The call overview now shows the new details.",
        "call_deleted": "The date is no longer in the overview.",
        "unlock_code_created": "The code is ready for the selected call.",
        "unlock_code_revoked": "The code can no longer be used.",
        "resource_updated": "The new value is saved for the client.",
        "partner_message_sent": "The message was sent to the client.",
        "impersonation_acting": "The preview switched into acting for the client.",
        "impersonation_looking": "The preview went back to looking only.",
        "impersonated_write": "A team member made a change for the client.",
        "impersonation_started": "A preview of the client surface was opened.",
        "sessions_revoked": "The selected sessions are no longer valid.",
        "magic_link_issued": "The sign-in link was issued.",
        "profile_research_completed": "The client profile is built and ready for review.",
        "profile_research_failed": "The profile build failed. The reason is available in Stripe import.",
        "deliverable_published": "The client can now see the new material version.",
        "notification_requeued": "Delivery of one notification was retried.",
        "profile_change": "The client profile or its source material changed.",
        "material_change": "A client material or feedback state changed.",
        "call_change": "The change is visible in the calls and reservations overview.",
        "client_progress": "The client's progress is updated in their detail.",
        "client_resource": "A technical client value changed.",
        "automation_result": "Automation completed or retried a specific task.",
        "access_change": "Access or an invitation changed.",
        "system_change": "Launchpad maintenance or a settings change ran.",
        "import_change": "A data import or its settings changed.",
        "transcript_requeued": "The transcript is back in the queue. The finished text appears in the client profile.",
        "staff_profile_updated": "You will find the change in Team and access, in that member's detail.",
        "notification_delivery_tested": "A test message to the address of the administrator who ran it. The result is in the notification queue."
      },
      "type": {
        "app_release_status_changed": "App release status changed",
        "bot_transfer_false_done_repaired": "False bot transfer repaired",
        "bot_transfer_settings_updated": "Bot transfer switch changed",
        "bot_transferred_automatically": "Bot transferred automatically",
        "global_unlock_link_changed": "Shared link renamed",
        "instance_folder_recorded": "Instance folder recorded",
        "knowhow_handover_verified": "Folder access verified",
        "license_key_imported": "License key arrived",
        "material_regeneration_requested": "Material rebuild ordered",
        "notification_label_fallback": "Message with no material name",
        "order_links_confirmed": "Order links confirmed",
        "order_links_integrated": "Order links merged in",
        "order_links_integration_requested": "Order links sent for processing",
        "owner_role_done": "Instance handed over",
        "owner_role_failed": "Instance handover failed",
        "owner_role_id_refused": "Telegram id refused",
        "owner_role_job_queued": "Instance handover queued",
        "owner_role_settings_updated": "Instance handover switch changed",
        "partner_brief_saved": "Briefing note saved",
        "sales_edit_merged": "Page edit merged",
        "staff_override_approved": "Step confirmed for the client",
        "sales_only_import": "Step recorded by the sales-only import",
        "training_resume_requested": "Training resume requested",
        "staff_created": "Team member added",
        "staff_role_changed": "Role changed",
        "staff_deactivated": "Member deactivated",
        "staff_reactivated": "Member reactivated",
        "call_created": "Call created",
        "call_updated": "Call updated",
        "call_deleted": "Call deleted",
        "unlock_code_created": "Unlock code created",
        "unlock_code_revoked": "Unlock code revoked",
        "resource_updated": "Resource updated",
        "partner_message_sent": "Message sent to client",
        "impersonation_acting": "Acting for the client",
        "impersonation_looking": "Looking only",
        "impersonated_write": "Change for the client",
        "impersonation_started": "Opened as client",
        "sessions_revoked": "Sessions revoked",
        "magic_link_issued": "Sign-in link issued",
        "profile_research_completed": "Client profile built",
        "profile_research_failed": "Profile build failed",
        "deliverable_published": "Material published",
        "notification_requeued": "Notification retried",
        "profile_change": "Client profile changed",
        "material_change": "Client material changed",
        "call_change": "Call or reservation changed",
        "client_progress": "Client progress changed",
        "client_resource": "Client value changed",
        "automation_result": "Automation completed",
        "access_change": "Access changed",
        "system_change": "Launchpad operation changed",
        "import_change": "Data import changed",
        "transcript_requeued": "Transcript restarted",
        "staff_profile_updated": "Team member profile edited",
        "notification_delivery_tested": "Message delivery tested"
      }
    },
    "promptPatch": {
      "title": "Work feedback into the prompt",
      "hint": "Check the feedback items above that Alex should work into the Buddy system prompt. Alex proposes a concrete change (before and after) and says for each item whether it belongs in the prompt, in the client's know-how, or is a platform bug. Nothing is written into the prompt without your approval.",
      "selectLabel": "Select to work into the prompt",
      "selectedCount": "Selected items: {count}",
      "noteLabel": "Note for Alex (optional)",
      "notePlaceholder": "For example: mainly keep the answers shorter.",
      "submit": "Work into the prompt",
      "submitting": "Sending…",
      "selectHint": "Check at least one new feedback item first.",
      "openBlocks": "The open request has to finish before another one can be sent.",
      "requestedAt": "Sent {date}, items: {count}",
      "partnerNote": "Your note: {note}",
      "summaryLabel": "Proposal summary",
      "itemsTitle": "Where each item belongs",
      "unknownPodnet": "An item that is no longer in the list",
      "patchTitle": "Prompt changes",
      "before": "Before",
      "after": "After",
      "why": "Why: {why}",
      "noPatch": "The proposal does not change the prompt text. The items belong elsewhere, see the breakdown above.",
      "edit": "Edit the after text",
      "editDone": "Done",
      "edited": "Edited by hand",
      "approve": "Approve",
      "reject": "Reject",
      "rejectNoteLabel": "Why the proposal does not fit (optional)",
      "confirmReject": "Reject it",
      "cancel": "Cancel",
      "deciding": "Saving…",
      "resultNote": "Note: {note}",
      "appliedHint": "Items placed in the prompt are marked as worked in, and the client sees them that way.",
      "categories": {
        "prompt": "Into the prompt",
        "knowhow": "Missing know-how, the client adds it",
        "platform": "Platform bug, ours to fix",
        "irrelevant": "Not relevant"
      },
      "states": {
        "queued": "Waiting, Alex will prepare a proposed prompt change.",
        "proposing": "Alex is preparing a proposed prompt change.",
        "proposed": "The proposal is ready. Review it, edit the after text if needed, then approve or reject.",
        "approved": "Approved. Writing into the prompt.",
        "applying": "Writing into the prompt.",
        "applied": "Worked in. The prompt is updated and deployed.",
        "rejected": "The proposal was rejected. Nothing was written into the prompt.",
        "failed": "Writing into the prompt failed.",
        "unavailable": "The status cannot be loaded right now. Try again in a moment."
      },
      "errors": {
        "already_open": "A request for this client is already running. Wait for it to finish.",
        "invalid_feedback": "One of the selected items is no longer open. Reload the page and select again.",
        "state_conflict": "The request has moved on in the meantime. Reload the page.",
        "generic": "The action failed. Try again in a moment."
      }
    },
    "promptRebuild": {
      "title": "Buddy system prompt",
      "hint": "Regenerates the system prompt and welcome messages from the know-how currently in the instance folder, then runs /update. A run takes tens of minutes and overwrites the current prompt.",
      "launch": "Regenerate prompt",
      "confirmOverwrite": "Regenerate anyway and overwrite the manual edits",
      "cancel": "Cancel",
      "starting": "Starting…",
      "states": {
        "idle": "The prompt has not been regenerated from the Launchpad yet.",
        "queued": "The run is waiting to start.",
        "running": "The prompt is being regenerated. It takes tens of minutes, you can close this page.",
        "done": "The prompt is regenerated and deployed.",
        "failed": "The last run failed.",
        "unavailable": "The run status cannot be loaded right now. Try again in a moment."
      },
      "reasons": {
        "doc_edited_by_human": "Someone edited the prompt by hand. Regenerating will overwrite those edits.",
        "already_running": "A regeneration is already running for this or another client. Wait until it finishes.",
        "not_enough_sources": "The instance folder does not hold enough know-how to build a prompt from yet.",
        "no_instance": "We have no instance for this client to build a prompt from.",
        "no_workspace": "We have no instance for this client to build a prompt from.",
        "unavailable": "It cannot start right now. Try again in a moment, or write in the #dfy-service thread."
      },
      "summary": "Transcripts processed: {transcripts} · prompt length: {chars} characters · open questions: {questions}",
      "promptDoc": "Open the system prompt",
      "onboardingDoc": "Open the welcome messages",
      "finishedAt": "Finished {date}"
    },
    "dfyBuild": {
      "title": "Sales materials (DFY)",
      "hint": "Production starts automatically. Use these buttons only when manual intervention is needed.",
      "notReady": "The client must submit the sales questionnaire first.",
      "launch": "Start the sales-page build",
      "launchGate": "Start the build",
      "launched": "Launched, building",
      "gates": {
        "audit": "Sales strategy proposal",
        "salespage": "Sales page",
        "emails": "Emails",
        "webinar": "Webinar"
      },
      "gateLocked": "This step unlocks once the client confirms the previous document.",
      "gateLaunched": "{gate}: launched",
      "launching": "Launching…",
      "running": "Production is running.",
      "stale": "Production went quiet and may have stopped. You can start it again.",
      "failed": "Production failed.",
      "done": "The deliverable is ready.",
      "retry": "Start again",
      "materialVersion": "version {version}",
      "materialState": {
        "none": "Not made yet",
        "draft": "Draft",
        "review": "In review",
        "approved": "Approved",
        "published": "Published"
      },
      "openDeliverables": "Open deliverables",
      "elapsed": "Running for {minutes} min",
      "lastActivity": "Last activity {minutes} min ago",
      "estimateStrategy": "Usually 10-30 minutes.",
      "estimateOther": "This can take tens of minutes.",
      "etaAt": "Ready at about {time} (estimate from {count} runs)",
      "etaRemaining": "About {minutes} min remaining",
      "steps": {
        "knowledge-pack": "Online Strategist knowledge",
        "audit-brief": "Audit inputs",
        "audit-readback": "Audit: reading inputs",
        "plan-brief": "Strategy brief",
        "sol-draft": "Writing the proposal",
        "gates": "Quality gates",
        "kritika-prepis": "Critique and rewrite",
        "rubric-score": "Quality score",
        "delivery": "Document delivery",
        "summary": "Summary",
        "strategy-contract": "Approved strategy contract",
        "icp": "Ideal customer profile",
        "design-direction": "Design direction",
        "photos": "Client photos",
        "brief": "Copy brief",
        "native-round": "Native language pass",
        "assembly": "Page assembly",
        "screenshots": "Preview screenshots",
        "podpis-designera": "Designer sign-off",
        "soulad-se-strategii": "Strategy consistency check",
        "instance-card": "Buddy card",
        "campaign-shape": "Campaign shape",
        "sending-strategy": "Sending strategy",
        "faze": "Campaign phase: {name}",
        "instance-soul": "The Buddy's soul",
        "self-improvement-3-kola": "Three self-improvement rounds",
        "delivery-doc": "Delivery document",
        "faze-warmup": "Campaign phase: warm-up",
        "faze-reveal": "Campaign phase: reveal",
        "faze-showup": "Campaign phase: show up",
        "faze-replay": "Campaign phase: replay",
        "faze-deadline": "Campaign phase: closing the offer",
        "faze-downsell": "Campaign phase: smaller offer",
        "faze-trial": "Campaign phase: trial",
        "faze-onboarding": "Campaign phase: onboarding",
        "struktura-timing": "Structure and timing",
        "sol-brief": "Copy brief",
        "outline": "Broadcast outline"
      }
    },
    "notes": {
      "composerTitle": "Add your own note on a deliverable",
      "targetLabel": "Pick a deliverable...",
      "placeholder": "What the agent should change in the next version...",
      "addNote": "Save note",
      "sendToAgent": "Rebuild the whole deliverable (new version)",
      "sentToAgent": "Sent to agent",
      "otherTitle": "Other feedback",
      "betaTitle": "Notes on the Buddy",
      "materialsElsewhere": "This is the queue of notes on the Buddy. Notes on materials ({materials}) belong to those materials' steps.",
      "editWithAlex": "Edit with Alex",
      "dismiss": "Not relevant",
      "delete": "Delete note",
      "deleteConfirm": "Delete this note? This cannot be undone. Client:",
      "anchorsOpen": "Open the material with the pointed-at spots",
      "composerToggle": "Add your own note",
      "moreActions": "More actions",
      "openCount": {
        "one": "1 new",
        "few": "{count} new",
        "other": "{count} new"
      },
      "failedShort": "Edit failed",
      "retryOpen": "Open and send again",
      "filterLabel": "Filter notes by state",
      "filter": {
        "all": "All",
        "open": "New",
        "alex": "With Alex",
        "handled": "Worked in"
      },
      "filterEmpty": "No note matches this filter."
    },
    "material": {
      "open": "Open material",
      "panelLabel": "Edits with Alex",
      "composerTitle": "Tell Alex what to change",
      "placeholder": "E.g. Cut the intro in half and add installments to the price...",
      "send": "Send to Alex",
      "hint": "Alex edits the material from your message and the marked notes below. The new version appears here on its own.",
      "working": "Alex is working the notes in. The new version appears here by itself.",
      "updated": "Done. You are looking at the new version {version}.",
      "notesTitle": "Notes",
      "notesHint": "Alex works them in during the edit and marks them handled.",
      "noteState": {
        "new": "New",
        "handled": "Worked in",
        "sent": "Sent to Alex",
        "working": "Alex is working",
        "dismissed": "Not relevant"
      },
      "noteHint": {
        "new": "Waiting for your decision. Select it for Alex or close it.",
        "sent": "The request was accepted and is waiting for processing to start.",
        "working": "Alex is working it into a new version now.",
        "handled": "It is closed and stays here for reference.",
        "dismissed": "Closed as not relevant. It stays here for reference."
      },
      "versions": "Versions",
      "oldVersion": "You are viewing older version {version}, read only.",
      "publishVersion": "Publish v{version} to the client",
      "publishBackToCurrent": "Return to the current version, that is the one published.",
      "backToCurrent": "Back to current",
      "manageVersions": "Manage versions and metadata",
      "latestVersion": "Latest",
      "liveVersion": "Visible to client",
      "updatedAt": "Updated {time}",
      "inlineContent": "The content is stored directly in Launchpad. There is no internal address to edit.",
      "openPublishedPage": "Open published page",
      "saveVersion": "Save version changes",
      "selectHint": "Tick what Alex should work in and send it with the one button below.",
      "selectNote": "Work in this note",
      "noOpenNotes": "No new notes. Record the first one below, or wait for the client.",
      "resolvedTitle": "Worked in ({count})",
      "addTitle": "Add a note",
      "writeNote": "Write a note as text",
      "messageTitle": "Message for Alex",
      "messageToggle": "Add a message for Alex",
      "sendMessageOnly": "Send the message to Alex",
      "sendNeeds": "There is nothing to send yet. Tick at least one note, or write Alex a message.",
      "sendHint": "Alex works the selection into a new version. The page refreshes itself and worked-in notes get marked.",
      "writeShort": "Write as text",
      "messageEdit": "Edit the message for Alex",
      "workingShort": "Alex is working...",
      "anchorHint": "Show the spot in the page (click scrolls, hover highlights)",
      "selectAll": "Select all",
      "selectNone": "Clear selection",
      "sendNotesCount": {
        "one": "Send Alex 1 note",
        "few": "Send Alex {count} notes",
        "other": "Send Alex {count} notes"
      },
      "sendNotesAndMessageCount": {
        "one": "Send Alex 1 note and a message",
        "few": "Send Alex {count} notes and a message",
        "other": "Send Alex {count} notes and a message"
      },
      "versionsCount": {
        "one": "{count} version",
        "few": "{count} versions",
        "other": "{count} versions"
      },
      "showChanges": "What changed",
      "updatedShowChanges": "Show what changed",
      "diffLegend": "Green highlights are new, struck-through text was removed from the previous version.",
      "unpublished": "Unpublished version v{version}.",
      "clientSees": "The client sees v{version}.",
      "clientSeesNothing": "The client sees no version yet.",
      "publish": "Publish to the client",
      "publishError": {
        "edit_base_not_live": "This version came from editing a different version than the one the client sees now. Send the comments again and Alex will work them into the current version."
      },
      "unpublishedChip": "awaiting publish",
      "queued": "Sent to Alex. Processing starts in a moment.",
      "queuedShort": "Sent to Alex",
      "sentAt": "Sent {time}",
      "workingSince": "Alex working since {time}",
      "doneStatus": "Done. Alex worked the notes into version {version}.",
      "stuck": "This is taking longer than usual. You can send the request again.",
      "retry": "Send again",
      "alexQueued": "The comments are sent to Alex and waiting in the queue.",
      "alexWorking": "Alex is working the comments into a new version.",
      "noteExpand": "Show the whole note",
      "noteCollapse": "Shorten"
    },
    "materials": {
      "title": "Materials for the client",
      "hint": "Files and links you add on the client's behalf. The client sees them in the know-how section and Alex uses them for training.",
      "scopeKnowhow": "Know-how",
      "scopeLegacy": "Backfill",
      "upload": "Upload a file",
      "uploading": "Uploading...",
      "addLink": "Add a link",
      "linkUrl": "https://...",
      "linkLabel": "Link name",
      "note": "Note for the client and Alex",
      "empty": "No materials yet.",
      "remove": "Remove",
      "confirmRemove": "Really remove this material of client",
      "fileTypes": "Recordings (audio), photos and PDFs up to 60 MB. Larger and other formats belong in the Drive folder."
    },
    "backfill": {
      "title": "Backfill",
      "hint": "Mark the finished sections and open the one the client is on. These are states under the surface, not steps on the client's own screen: a sales only client never sees Buddy setup, backfilled or not. Profile, Apple account, and feedback keep their own state.",
      "stepsLabel": "Finished sections",
      "step": {
        "onboarding_call": "Intro video",
        "q1": "Buddy preparation questionnaire",
        "knowhow": "Know-how",
        "training": "Training",
        "beta": "Beta testing and feedback",
        "marketing_call": "Marketing video",
        "q2": "Sales questionnaire"
      },
      "entry": "Entry section: {step}",
      "reason": "Backfill reason (required)",
      "submit": "Apply backfill",
      "submitting": "Saving...",
      "nothing": "Nothing to backfill, the client is further along.",
      "done": "State updated."
    },
    "adminImports": {
      "title": "Import history",
      "hint": "One queue for Stripe, dossier and profile research. Where a repeat is safe, the row offers the button.",
      "loadFailed": "The import history could not be loaded right now.",
      "empty": "Nothing has arrived yet. The first purchase or profile will show up here.",
      "emptyFiltered": "No record matches this filter.",
      "clearFilters": "Clear filters",
      "unknownSubject": "No name",
      "working": "Working on it...",
      "actionFailed": "The action did not go through. Please try again.",
      "attempts": "Attempts: {count}",
      "openClient": "Open client",
      "noClient": "No client came out of this row",
      "retry": "Build the profile again",
      "retryWorking": "Queueing a new run...",
      "retryQueued": "A new profile run is queued: {client}. It will show up in this history when it finishes.",
      "retryRunning": "{client} already has a run waiting in the queue, no need to start a second one.",
      "retryFailed": "The repeat could not be started. Please try once more.",
      "filter": {
        "source": "Source",
        "status": "State",
        "all": "All"
      },
      "summary": {
        "total": "Records: {count}",
        "failed": "Failed: {count}",
        "pending": "Running: {count}"
      },
      "source": {
        "stripe": "Stripe",
        "dossier": "Dossier",
        "research": "Profile research"
      },
      "status": {
        "done": "Done",
        "failed": "Failed",
        "pending": "Running",
        "skipped": "Skipped"
      },
      "reason": {
        "noMatch": "The purchase matches no mapped product.",
        "switchOff": "The import was off, so this row is only a record of the purchase.",
        "alreadyClient": "A client with this e-mail is already in Launchpad.",
        "unpaid": "The payment has not cleared yet, waiting for Stripe.",
        "missingPartner": "There is no default partner to assign the client to.",
        "metadataFlag": "The launchpad key on the Stripe product is not 1.",
        "metadataLabel": "The Stripe product is missing launchpad_label.",
        "metadataLanguage": "launchpad_language on the Stripe product is neither cs nor en.",
        "metadataApp": "launchpad_app on the Stripe product is neither 1 nor 0.",
        "metadataSource": "launchpad_source on the Stripe product is not direct, upsell, or webinar.",
        "metadataStart": "launchpad_start on the Stripe product is neither new nor existing.",
        "metadataProductType": "productType on the Stripe product is neither start nor empire.",
        "metadataProductLanguage": "language on the Stripe product is neither cs nor en.",
        "metadataProductApp": "enableMobileApp on the Stripe product is neither true nor false.",
        "metadataDialectsDisagree": "The Stripe product carries both metadata sets and they disagree.",
        "missingEmail": "The purchase carries no customer e-mail.",
        "noProducts": "The order carried no line item.",
        "profileAlreadyQueued": "Profile research was already running for this client, so no new run was queued.",
        "repeatedPurchase": "The same order arrived again.",
        "stripeConnection": "The connection to Stripe failed.",
        "clientCreation": "Creating the client failed.",
        "notEnoughFacts": "Public sources returned too few facts.",
        "temporary": "The connection dropped, the error looks temporary.",
        "dossierImporting": "The import is running and has not closed yet.",
        "dossierStalled": "The import never finished, it has been running over a day.",
        "dossierFailed": "The dossier import did not finish.",
        "dossierSuperseded": "A newer version replaced this one.",
        "researchCanceled": "The run was canceled.",
        "profileAccepted": "An accepted manual profile replaced this research. No new build is needed.",
        "researchAttemptReplaced": "A newer attempt replaced this unfinished dossier.",
        "claimExpired": "The final attempt did not report back within its time limit. Check the automation before starting another run.",
        "contextTooLarge": "The research exceeded the allowed input size.",
        "stalePartner": "The client was created, but the default partner is no longer active. Assign them by hand and fix the setting.",
        "unknown": "The reason could not be read.",
        "metadataPayments": "launchpad_payments on the Stripe product is neither 1 nor 0.",
        "staleSalesOnlyPartner": "The client was created, but the partner for sales only is no longer active. Check the assignment and fix the setting."
      },
      "fix": {
        "addMapping": "Add the product to the Stripe import mappings and the purchase will go through.",
        "enableSwitch": "Turn on the master switch in the Stripe import.",
        "setPartner": "Pick a default partner in the Stripe import.",
        "checkStripe": "Check the Stripe key and try again.",
        "fixMetadata": "Fix the metadata on the Stripe product. Then add this purchase through the manual import in the Stripe import.",
        "stalledImport": "Build the profile again, it creates a new version of the material.",
        "reduceContext": "Reduce the source material and loaded instructions before trying again. Repeating the same input will not resolve this error."
      },
      "configSource": {
        "metadata": "Configured by the Stripe product metadata.",
        "mapping": "Configured by the Launchpad product mappings."
      },
      "created": {
        "kicker": "Done",
        "title": "The client is created",
        "named": "Client {client} is created",
        "owner": "Owner",
        "partner": "Partner",
        "noPartner": "No partner yet",
        "automations": "What started",
        "open": "Open client",
        "another": "Create another",
        "working": "Creating the client...",
        "failed": "The client could not be created. The form kept your input, send it again.",
        "duplicateOwner": "Another client already uses this address. Open that client, or use a different address. Two records on one email drift apart silently: the team works in one, the client sees the other.",
        "detailsUnavailable": "The client exists. Its automation details did not load right now, you will find them in the client detail."
      },
      "automation": {
        "welcome_mail": "Welcome e-mail with the login link",
        "first_step": "Invitation to the first step",
        "profile_research": "Profile research from public sources",
        "call_links": "Stable call links",
        "knowhow_drive": "Know-how folder"
      },
      "automationState": {
        "done": "Done",
        "working": "Running",
        "waiting": "Waiting",
        "failed": "Failed"
      }
    },
    "adminCalls": {
      "title": "Calls",
      "hint": "Schedule one date or a full series and immediately verify what was created.",
      "timezone": {
        "browser": "Time on this device"
      },
      "capacity": "Capacity",
      "dateTime": {
        "choose": "Choose",
        "day": "Day",
        "month": "Month",
        "year": "Year",
        "hour": "Hour",
        "minute": "Minute"
      },
      "repeat": {
        "label": "Recurrence",
        "weekly": "Repeat by week",
        "interval": "Interval in weeks",
        "count": "Number of dates"
      },
      "creating": "Creating dates...",
      "create": "Create dates",
      "preview": {
        "kicker": "Before creation",
        "title": "Date preview",
        "empty": "Choose a date and time. The exact dates will appear here before creation.",
        "seriesNote": "Each date receives its own secure code.",
        "reason": {
          "invalid_date": "That date does not exist. Pick another day or month.",
          "past": "That time has already passed. Pick a time in the future.",
          "invalid_series": "The repetition is out of range. The interval can be 1 to 8 weeks and the count 2 to 16.",
          "missing_url": "Add the call link. Without it the occurrence has nowhere to send clients and cannot be created."
        },
        "useNextHour": "Use the next full hour"
      },
      "confirmation": {
        "kicker": "Done",
        "created": "The call is scheduled",
        "seriesCreated": "The call series is scheduled",
        "codeOnce": "Codes are shown only now. Store them in a safe place."
      },
      "links": {
        "kicker": "Client access",
        "title": "Stable call links",
        "hint": "Find a client, open their link or copy it with one click.",
        "search": "Search name or email",
        "client": "Client",
        "onboarding": "Onboarding call",
        "marketing": "Marketing call",
        "copy": "Copy link",
        "copied": "The full link is copied.",
        "created": "Both stable links were created and are ready to copy.",
        "missing": "The link has not been created yet",
        "empty": "There are no clients yet.",
        "noResults": "No client matches this search.",
        "create": "Create missing links",
        "creating": "Creating links...",
        "error": "The links could not be loaded or changed. Try again.",
        "loadError": "The links could not be loaded. Try again.",
        "saveError": "The missing links could not be created. Nothing changed.",
        "copyError": "The link could not be copied. Select it and copy it manually."
      },
      "overview": {
        "kicker": "Current state",
        "title": "Scheduled calls"
      },
      "tabs": {
        "upcoming": "Upcoming",
        "past": "Past"
      },
      "history": {
        "search": "Search by date or call type",
        "kind": "Call type",
        "allKinds": "All calls",
        "period": "Period",
        "last30": "Last 30 days",
        "last90": "Last 90 days",
        "allTime": "Full history",
        "loadMore": "Load older calls"
      },
      "empty": {
        "upcoming": "There are no upcoming calls.",
        "past": "There are no past calls yet."
      },
      "enrollment": "Enrolled",
      "reservation": "Reserved a place",
      "attended": "Attended",
      "watched": "Watched recording",
      "noShow": "Attendance not confirmed",
      "cancelled": "Canceled",
      "full": "Full",
      "metricsHint": "Reservations count every enrolled client after attendance too. Attendance comes from confirmed presence, code usage from the code history.",
      "code": {
        "label": "Code",
        "missing": "Not issued",
        "scheduled": "Waiting to open",
        "ready": "Issued",
        "expired": "Expired",
        "inactive": "Inactive",
        "used": "Times used",
        "lastUsed": "Last used"
      },
      "series": {
        "label": "Recurrence",
        "weekly": "Series",
        "single": "One time"
      },
      "actions": {
        "open": "Open call",
        "copyLink": "Copy link",
        "linkCopied": "Link copied",
        "extend": "Extend series",
        "cancelOne": "Cancel this date",
        "cancelFuture": "Cancel this and future dates",
        "createCode": "Generate code",
        "revokeCode": "Revoke code",
        "renewCode": "Issue a new code"
      },
      "confirm": {
        "cancelOne": "Cancel the call on {date}? Reserved clients: {count}. Enrollments and history remain stored, and clients will not receive a replacement call automatically.",
        "cancelFuture": "Cancel this date and every later date in the series?"
      },
      "actionDone": "The change is saved and the list is current.",
      "actionWorking": "Applying the change...",
      "feedback": {
        "callCancelled": "The date is canceled. Enrollments and history remain stored.",
        "futureCancelled": "This date and every later date in the series are canceled.",
        "seriesExtended": "New dates were added to the series and are visible in the list.",
        "codeCreated": "The code was created. Its value is visible in the confirmation above.",
        "codeRevoked": "The code was revoked. Previous uses remain in history.",
        "codeRenewed": "The old code no longer works. The new value is visible in the confirmation above."
      },
      "error": {
        "create": "The calls could not be created. Check the details and try again.",
        "load": "The calls could not be loaded.",
        "copy": "The link could not be copied. Open it and copy it manually.",
        "action": "The change could not be saved. Nothing was changed silently."
      },
      "globalUnlock": {
        "kicker": "Client links",
        "title": "Link to the call step",
        "hint": "One link per call kind. It takes the client straight to their step; the step itself opens once they watch the video, the link unlocks nothing. A change takes effect at once and the old link stops working.",
        "onboarding": "Onboarding call",
        "marketing": "Marketing call",
        "slugLabel": "Link password",
        "slugHint": "Two to four lowercase words joined by hyphens, no accents and no digits. For example golden-morning.",
        "save": "Save",
        "saving": "Saving",
        "saved": "Done, the new link is live. The old one leads nowhere from now on.",
        "copy": "Copy link",
        "copied": "The link is on the clipboard.",
        "lastChange": "Last change",
        "history": "Change history",
        "historyEmpty": "Nothing has changed yet.",
        "historyReplaced": "replaced",
        "loading": "Loading links",
        "errorInvalid": "That password cannot be used. Give two to four lowercase words, no digits and no accents.",
        "errorTaken": "That password already belongs to the other call. Pick another one.",
        "errorSave": "Saving failed. Please try again.",
        "errorLoad": "The links could not be loaded.",
        "errorCopy": "Copying failed. You can select the link and copy it by hand.",
        "errorOffline": "The save was not sent. Check your connection and try again.",
        "neverChanged": "The link has not changed since it was created.",
        "saveIdle": "Edit the password in the link first."
      }
    },
    "adminOps": {
      "title": "Live builds",
      "hint": "What is running, what died and what needs a nudge. Every row leads to the client.",
      "openClient": "Open client",
      "eta": "Done around {time}",
      "triggerOff": "The build trigger is not configured here, so a restart would start nothing.",
      "summary": {
        "running": "running",
        "stalled": "silent",
        "failed": "failed",
        "awaiting": "waiting for first report"
      },
      "phase": {
        "running": "Running",
        "stalled": "Silent",
        "failed": "Failed",
        "awaiting_restart": "Restarted",
        "restart_silent": "Silent after restart",
        "done": "Done"
      },
      "runs": {
        "title": "Builds someone has to watch",
        "empty": "Nothing is running and nothing failed.",
        "emptyFiltered": "Nothing is running or failed among the visible records. Test clients are hidden, so this is not the whole picture."
      },
      "recent": {
        "title": "Finished in the last 24 hours",
        "empty": "No build finished in the last day."
      },
      "calls": {
        "title": "Calls around now",
        "hint": "The last three hours and the next twenty four.",
        "empty": "No occurrence in this window.",
        "cancelled": "Canceled",
        "open": "Open link"
      },
      "restart": {
        "start": "Run the build again",
        "confirmTitle": "Restart confirmation",
        "confirmBody": "This starts the build again: {client}, {material}. Finished work stays, a new run begins.",
        "confirm": "Yes, start it",
        "working": "Starting the build…",
        "resultKicker": "Result",
        "launched": "The build is running again.",
        "at": "Started at {time}",
        "nextStep": "The first report arrives within minutes and the row updates itself.",
        "waiting": "Restarted at {time}. Waiting for the first report from the build.",
        "silent": "Nothing came back since the restart. Start it again or open the client.",
        "retryHint": "Reload the overview and decide from the current state.",
        "skipped": {
          "deliverable_exists": "Nothing started. The material already exists, ask for a new version through the client review.",
          "run_active": "Nothing started. Another run of the same build is still active.",
          "command_replayed": "Nothing started. This restart already went through once."
        }
      },
      "blocked": {
        "running": "The build is running. A restart makes sense once it goes silent or fails.",
        "awaiting_restart": "You already restarted it. Give the build a moment to report.",
        "finished": "This build is done.",
        "unknown_gate": "Unknown build type. No restart from here."
      },
      "refusal": {
        "run_moved": "The build moved on, so nothing was started. Look at the new state.",
        "run_active": "The build came back on its own. A restart would duplicate it.",
        "awaiting_restart": "A restart is already under way. Wait for the first report.",
        "finished": "The build is done, a restart makes no sense here.",
        "unknown_gate": "Unknown build type. No restart from here.",
        "not_ready": "The client is not in the sales phase yet, the build has nothing to work from.",
        "prerequisite_missing": "The previous material is not approved yet. Get it confirmed first.",
        "trigger_unavailable": "The build trigger is not configured. The restart has to happen on the machine.",
        "unknown": "The restart did not go through. Reload the overview and act on the current state.",
        "offline": "The restart request was not sent. Check your connection and try again; nothing has changed."
      },
      "error": {
        "load": "The operations overview could not be loaded.",
        "stale": "What you see is the last successful read, not the current state. Load the overview again before you act on it.",
        "retry": "Try loading the overview again with the button in the header."
      }
    },
    "adminZone": {
      "title": "Launchpad administration",
      "lead": "Operations, clients, automations and people. The tools that govern the whole Launchpad, not one client."
    },
    "adminGroup": {
      "operations": {
        "title": "Operations",
        "lead": "Is it running? Live builds, the message queue and transcripts that got stuck."
      },
      "clients": {
        "title": "Clients",
        "lead": "How clients get here: by hand, from Stripe, from an import."
      },
      "automations": {
        "title": "Automations",
        "lead": "What runs by itself. Master switches, queues and default content."
      },
      "people": {
        "title": "People and history",
        "lead": "Who did what. The team, their access and the timeline of changes."
      }
    },
    "openFeedback": "Open client feedback",
    "walk": {
      "title": "Talk and point",
      "explain": "Record a voice note while pointing with the cursor (finger on a phone) at places in the page. It lands in the list above.",
      "start": "Start recording",
      "stop": "Stop and save",
      "cancel": "Cancel",
      "recInstruction": "Point at what you talk about. The mic saves.",
      "sendingNote": "Saving the note...",
      "sentTitle": "Saved",
      "sent": "The note is in the list above. Tick it and send it to Alex once you have your selection.",
      "another": "Record another",
      "error": "Recording failed. Check the microphone and try again.",
      "empty": "No speech was heard in the recording. Try again.",
      "status": {
        "uploading": "Uploading...",
        "transcribing": "Transcribing...",
        "done": "Done."
      }
    },
    "daysCount": {
      "one": "{count} day",
      "few": "{count} days",
      "other": "{count} days"
    },
    "feedbackCount": {
      "one": "{count} note",
      "few": "{count} notes",
      "other": "{count} notes"
    },
    "answerLegacy": "Question from an older questionnaire version",
    "answers": {
      "kicker": "Questionnaire output",
      "title": "Client answers",
      "lead": "{answers} answers, {voice} of them recorded. The transcript is the text; the recording under it is the check on tone.",
      "searchLabel": "Search the answers",
      "searchPlaceholder": "Search the answers",
      "filterLabel": "Answer selection",
      "filterAll": "All",
      "filterVoice": "Recorded only",
      "visible": "Showing {shown} of {total}",
      "tocLabel": "Answer contents",
      "noMatch": "No answer matches this search and filter.",
      "clearFilters": "Clear the search and the filter",
      "unansweredTitle": "Unanswered",
      "unansweredHint": "The client left these questions empty.",
      "legacyChapter": "From an older questionnaire version",
      "voiceTranscribing": "The answer was dictated and the transcript is still running. Play the recording.",
      "voiceNoSpeech": "We did not recognize any speech in the recording. Play it.",
      "voiceFailed": "The recording could not be transcribed. Play it.",
      "followUpLabel": "Recording for a follow-up question",
      "playLabel": "Play the answer recording"
    },
    "appWizard": "App package",
    "appWizardSubmitted": "App package submitted",
    "appWizardProgress": "In progress, {percent}% done",
    "appWizardEmpty": "Client has not started yet",
    "stepProgressAria": "Progress across {count} steps",
    "copy": "Copy",
    "copied": "Copied",
    "callPhase": {
      "onboarding": "Intro video",
      "marketing": "Marketing video",
      "hint": "The step opens for the client by video: the questionnaire unlocks at the configured moment.",
      "link": "Call link",
      "linkMissing": "Link is not ready yet",
      "date": "Date",
      "noDate": "The client has not signed up yet",
      "doneNoDate": "The step closed without a recorded date",
      "attendance": "Attendance",
      "doneNoEnrollment": "The call is closed, no Launchpad sign-up happened"
    },
    "trainingPhase": {
      "reviewStep1": "Open the Buddy and have a conversation with it as if you were the client.",
      "reviewStep2": "Check whether it answers to the point and speaks the client's language.",
      "reviewStep3": "Approve the step. That opens beta testing and the tester invites for the client.",
      "reviewBot": "Try the Buddy",
      "approvalByAdmin": "Review the Buddy and tell the team. The final confirmation that opens beta for the client is done by an admin today.",
      "title": "Buddy training",
      "running": "Alex is training Buddy from the client know-how. It takes two to three working days and the client gets an e-mail.",
      "blocked": "Training is not running. The step is closed but the bot link is missing, so the client waits for nothing.",
      "ready": "The Buddy is trained and waiting for your review. Once you approve it, beta testing opens for the client.",
      "doneNoBot": "Training is closed, but the bot link has not arrived yet.",
      "completionProblem": "The step is marked complete, but no traceable bot link exists. Until the link is added, the step stays blocked.",
      "openBot": "Open bot",
      "locked": "Training starts once the client submits their know-how.",
      "bot": "Bot",
      "systemPrompt": "System prompt",
      "openSystemPrompt": "Open the system prompt",
      "openSystemPromptInDetail": "Show it in the instance detail",
      "approveHint": "Once you have been through the Buddy and are happy with it, approve it. That opens beta testing for the client.",
      "approve": "I checked the Buddy, approve it",
      "approveConfirm": "Approve and open it for the client",
      "approving": "Approving...",
      "approved": "Approved. Beta is open for the client.",
      "approveReason": "The partner checked the Buddy and approved it for the client."
    },
    "trainingRun": {
      "stepOf": "Step {phase} of {total}: {name}",
      "elapsed": "running {duration}",
      "runElapsed": "total {duration}",
      "lastReport": "last report {duration} ago",
      "attempt": "attempt {count}",
      "typical": "usually ~{minutes} min",
      "queued": "The machine has not reported yet. Once it starts reporting progress, every training step shows up here.",
      "timeline": "Training progress",
      "activity": "Recent activity",
      "doneIn": "Training finished in {duration}.",
      "phaseFailed": "The step failed.",
      "staleTitle": "Training went quiet.",
      "staleBody": "The last report came {minutes} min ago. The machine may have crashed or lost its connection.",
      "staleAdvice": "Try resuming the training. If it stays quiet for a few minutes, open the instance detail and see what is going on.",
      "failedTitle": "Training ended with an error.",
      "failedPhase": "Error in step {phase}: {name}.",
      "stopped": "Someone stopped the training on the machine. You can resume it, it picks up where it left off.",
      "waitingTitle": "The machine is waiting for input.",
      "waitingHint": "The input is provided in the instance detail, the link is on the card next to this one.",
      "resume": "Resume training",
      "resuming": "Sending...",
      "resumeConfirm": "Training picks up from the step where it stopped. Nothing is deleted or restarted.",
      "resumeGo": "Yes, resume",
      "resumeBack": "Back",
      "resumeRequested": "Request sent. Waiting for the machine to report, usually within a few minutes.",
      "resumeSilent": "The machine has not answered the last request. Try again or open the instance detail.",
      "refusalRunActive": "Training is running right now, there is nothing to resume.",
      "refusalNotReady": "Training is not in a state where it can be resumed."
    },
    "betaPhase": {
      "title": "Beta testing",
      "transfer": "Bot ownership",
      "transferDone": "Transferred to the client",
      "transferPending": "Transfer in progress",
      "transferNotStarted": "Still ours",
      "transferFailed": "Transfer failed, the bot is still ours",
      "transferReturned": "Transfer failed, returned to the client",
      "transferClientFix": "Waiting for the client to fix it",
      "invites": "Tester invites",
      "inviteLimit": "{count} invites",
      "noInvites": "None yet",
      "completionProblem": "The step is marked complete, but the bot transfer or tester invites are missing. Until they are added, the step stays blocked."
    },
    "publicationPhase": {
      "title": "Sales page publication",
      "hint": "The client publishes the page from their own account. You make sure they have something to publish and that payments reach them.",
      "page": "Sales page",
      "pagePublished": "The client can see and publish it",
      "pagePublishedLocked": "The client can see it, download and publishing unlock with the step",
      "pageReady": "Ready, waiting for you to release it",
      "pageMissing": "Not built yet",
      "stripe": "Receiving payments",
      "stripeDone": "Stripe confirmed, download and publishing are unlocked",
      "stripeBlocking": "Until you confirm Stripe, download and publishing stay locked",
      "lockedHint": "This step is still locked. The client publishes only after it unlocks; you make sure there will be something to publish.",
      "pageReadyLocked": "Ready, but the step is locked, the client does not get it yet",
      "stripeDoneLocked": "Stripe confirmed, download and publishing unlock with the step"
    },
    "handoverPhase": {
      "title": "Handover to the client",
      "hint": "The client takes over the instance. Without their Telegram ID and a confirmed Owner Dashboard the handover cannot be completed.",
      "telegram": "Client Telegram",
      "telegramMissing": "The client has not filled it in yet",
      "myId": "Number from /myid",
      "myIdMissing": "Missing",
      "botOwner": "Bot",
      "botOwnerClient": "Owned by the client",
      "botOwnerUs": "Still ours",
      "dashboard": "Owner Dashboard",
      "dashboardConfirmed": "Client confirmed it opened",
      "dashboardMissing": "Not confirmed by the client yet",
      "ownerRole": "Owner role",
      "ownerRoleSet": "Set on {date}",
      "ownerRoleMissing": "Not set yet",
      "ownerRoleHint": "The role is set automatically as soon as the ID arrives. This button is the emergency manual path for when the automation fails and the role has to be set by hand with /setProOwner:ID#bot. Careful: that command is an ownership transfer and our account loses the instance.",
      "ownerRoleAction": "Confirm the role is set",
      "ownerRoleSending": "Saving...",
      "ownerRoleDone": "Confirmed. The client's step 3 is open and they have been notified.",
      "ownerRoleError": "The confirmation could not be saved. Please try again.",
      "ownerRoleNeedsId": "We need the client's Telegram ID first. Without it there is nothing to set the role by.",
      "ownerRoleJob": {
        "title": "Automation",
        "pending": "Queued",
        "running": "Running",
        "done": "Done",
        "failed": "Failed",
        "attempts": "Attempts",
        "reason": "Reason",
        "quote": "Instance replied",
        "faultClient": "Sent back to the client",
        "faultTeam": "Ours to solve"
      }
    },
    "appPhase": {
      "apple": {
        "title": "First app steps",
        "waiting": "The client has not started the Apple account yet.",
        "submitted": "The Apple account is awaiting review.",
        "active": "The Apple account is active.",
        "confirmed": "The client confirmed the account, and we have the Team ID and the e-mail."
      },
      "questionnaire": {
        "title": "App inputs",
        "waiting": "The client has not started the app questionnaire yet.",
        "progress": "The client has started the inputs:",
        "submitted": "The client submitted all app inputs.",
        "prefill": {
          "waiting": "We are prefilling the materials from the client's answers.",
          "late": "The prefill has been running for over an hour. That one is on us, and there is nothing the client can do about it."
        }
      },
      "release": {
        "title": "App release",
        "waiting": "Release is waiting for the previous steps and store links.",
        "live": "The app is released and store links are available."
      }
    },
    "onDeck": "On deck",
    "onDeckWho": {
      "partner": "Me",
      "client": "Client",
      "alex": "Alex",
      "team": "Team",
      "assigned": "Team: {name}"
    },
    "buildRetry": {
      "action": "Run the build again",
      "sent": "Started, it resumes where it stopped",
      "error": "Could not start it, try again shortly."
    },
    "adminTeam": {
      "hint": "Pick a member and see their role, profile, clients, recent work and access in one place.",
      "selectMember": "Pick a member from the list to open their detail.",
      "loadError": "The member detail could not be loaded.",
      "error": "The action could not be completed. Please try again.",
      "working": "Working on it.",
      "memberSince": "In the team since",
      "roleTitle": "Role and account state",
      "selfNote": "You cannot deactivate your own account. Ask another admin.",
      "heirHint": "This member has clients: {count}. Choose who takes them over. Without that, deactivation is not possible.",
      "clientsTitle": "Clients",
      "clientsEmpty": "No client is assigned to them yet.",
      "openClient": "Open client",
      "activityTitle": "Recent activity",
      "activityEmpty": "No recorded activity yet.",
      "activityNoClient": "no client",
      "accessTitle": "Access",
      "activeSessions": "Active sign-ins",
      "revokeSessions": "Sign out of all devices",
      "profileMissingFields": "Clients cannot see this yet: {fields}. Fill it in right here.",
      "profileInvalid": "A field has the wrong format. Links must start with https, the Telegram ID is digits only.",
      "googleAccount": "Google account",
      "googleAccountHint": "We share client Drive folders with this account. When it stays empty, the public e-mail is used.",
      "telegramUsername": "Telegram username",
      "telegramId": "Telegram ID",
      "telegramHint": "Get the ID in Telegram with /myid. Without it the partner cannot be added to a client instance.",
      "profileField": {
        "photo": "photo",
        "calendly": "calendar link",
        "publicEmail": "public e-mail"
      },
      "done": {
        "roleAdmin": "{name} is an admin now. They see the whole team, the service area and every client.",
        "rolePartner": "{name} is a partner now. They see and manage only their own clients.",
        "deactivated": "The account {name} is deactivated and signed out everywhere. Use Reactivate to switch it back on.",
        "deactivatedWithHeir": "The account {name} is deactivated, {heir} takes over the clients. Check how the work is split there.",
        "reactivated": "The account {name} is active again. Send a sign-in link so they can get back in.",
        "linkSent": "The sign-in link for {name} is on its way to {email}. Check delivery in the notification queue.",
        "sessionsRevoked": "Every sign-in of the account {name} is revoked. They need a new link to get back in.",
        "profileSaved": "The profile of {name} is saved. This is exactly what clients see on the partner card.",
        "memberAdded": "{name} is in the team. Send the sign-in link with the button in the detail.",
        "memberInvited": "{name} is in the team and the sign-in link is on its way to {email}."
      },
      "profileMoved": "Not saved. Somebody else ({editor}) saved this profile in the meantime, so your version would overwrite it. Nothing changed.",
      "profileConflictTitle": "Newer version of the profile",
      "profileConflictBody": "This is the profile as it stands now. Load it into the form and type your changes into it again.",
      "profileTakeNewer": "Load the newer version",
      "profileFieldEmpty": "empty"
    },
    "adminNotifications": {
      "title": "Notification queue",
      "hint": "See what went out, what is waiting and what failed. Every message carries its delivery attempts and the event behind it.",
      "working": "Working on it.",
      "error": "The action could not be completed. Please try again.",
      "loadError": "The queue could not be loaded.",
      "empty": "Nothing is in this state right now.",
      "allFiltered": "Every message in this state belongs to a test client. Turn the filter off to see them.",
      "selectRow": "Pick a message to see its delivery attempts.",
      "drain": "Send the waiting ones",
      "filterLabel": "Filter by status",
      "noClient": "no client",
      "noStatus": "no code",
      "noAttempts": "No delivery attempt yet.",
      "attemptOk": "no error",
      "attemptCount": "attempts: {count}",
      "rowScheduled": "goes out {when}",
      "scheduled": "Scheduled for later: {count}",
      "channel": "Channel",
      "created": "Created",
      "attempts": "Attempts",
      "sendAt": "Send at",
      "sentAt": "Sent",
      "attemptsTitle": "Delivery attempts",
      "eventTitle": "Triggered by",
      "eventMissing": "No event could be traced for this message.",
      "retry": "Try sending again",
      "retryConflict": "This message is no longer in a failed state. Reload the queue.",
      "skippedHint": "The recipient's settings stopped this message. A retry will not send it, the preferences have to change first.",
      "filter": {
        "all": "All",
        "failed": "Failed",
        "queued": "Waiting",
        "sent": "Sent",
        "dev_logged": "Test inbox",
        "skipped": "Skipped"
      },
      "status": {
        "queued": "Waiting",
        "dev_logged": "Test inbox",
        "sent": "Sent",
        "failed": "Failed",
        "skipped": "Skipped"
      },
      "channelName": {
        "email": "E-mail",
        "push": "Push",
        "both": "E-mail and push"
      },
      "done": {
        "retried": "The message is back in the queue. Follow its status in the list.",
        "drained": "Messages processed: {count}. See the result in the list."
      },
      "test": {
        "kicker": "Delivery test",
        "hint": "The test message always goes to your own e-mail. It never reaches a client.",
        "send": "Send a test",
        "delivered": "Test delivered to {recipient}. Check your inbox.",
        "skipped": "Your notification settings stopped the test. Switch the channel on in your preferences and try again.",
        "queued": "The test is waiting in the queue. The next queue run sends it.",
        "failed": "The test failed. The error detail sits with the message in the list.",
        "sink": "The message landed in the development sink and never went out as e-mail. This does not prove delivery; in production you would find it at the provider."
      },
      "attemptWhen": "When",
      "attemptChannel": "Channel",
      "attemptResponse": "Response",
      "attemptResult": "Result",
      "provider": {
        "test_sink": "Test sink",
        "resend": "Resend",
        "cf_email": "Cloudflare e-mail",
        "web_push": "Browser push"
      },
      "recipientLabel": "Recipient",
      "queueScope": "Whole queue",
      "pageNote": "The list holds the first {loaded} messages of {total}. The counters above it count the whole queue.",
      "reasonLabel": "Reason",
      "reason": {
        "inbox_only": "The recipient only wants in-app notices.",
        "channel_off": "The recipient has this channel switched off.",
        "category_off": "The recipient has this kind of message switched off.",
        "no_subscription": "The recipient has no device registered for push.",
        "no_recipient": "The message has no recipient.",
        "unsubscribed": "The recipient unsubscribed."
      },
      "typeName": {
        "action_required": "Something is waiting for the team",
        "admin_delivery_test": "Delivery test",
        "app_prefill_ready": "The app questionnaire is prefilled",
        "app_wizard_submitted": "App wizard submitted",
        "bot_transfer_client_fix": "Bot transfer: the client's turn",
        "bot_transfer_done": "The bot is transferred",
        "bot_transfer_ready": "The bot transfer is ready",
        "bot_transfer_staff_failed": "The bot transfer failed",
        "call_no_show": "Missed call",
        "call_reminder_15m": "Call reminder: 15 minutes ahead",
        "call_reminder_3h": "Call reminder: 3 hours ahead",
        "call_reminder_day": "Call reminder: a day ahead",
        "call_reminder_live": "The call is starting",
        "deliverable_build_failed": "The material build failed",
        "deliverable_client_note": "A note from the client",
        "client_partner_message": "Message from the client to the partner",
        "deliverable_edit_failed": "The material edit failed",
        "deliverable_feedback_resolved": "The note is worked in",
        "deliverable_partner_review": "Material for the partner to review",
        "deliverable_review": "Material for the client to review",
        "dfy_q2_ready": "The sales questionnaire is done",
        "sales_only_import_summary": "Client import finished",
        "gate_approved": "Approved material",
        "handover_owner_role": "Instance ownership",
        "instance_team": "Joining the instance team",
        "knowhow_shared": "Shared know-how folder",
        "order_links_integrated": "Order links are in the page",
        "owner_role_client_fix": "Ownership: the client's turn",
        "owner_role_staff_failed": "Setting ownership failed",
        "partner_assigned": "Partner assigned",
        "partner_assigned_staff": "New client for a partner",
        "partner_message": "A message from the partner",
        "profile_map_applied": "Profile changes are worked in",
        "questionnaire_nudge": "Questionnaire reminder",
        "return_magic_link": "Sign-in link",
        "login_no_account": "Address without an account",
        "section_unlocked": "A step opened",
        "staff_override": "The team stepped into a step",
        "system_test": "System test",
        "team_invite": "Invitation to the client's team",
        "training_failed": "Training failed",
        "training_result": "Training result",
        "training_started": "Training started",
        "transcript_failed": "The transcript failed",
        "welcome_magic_link": "Welcome sign-in link"
      },
      "typeUnknown": "Unknown message type",
      "statusUnknown": "Unknown status",
      "filterClient": "Client",
      "allClients": "All clients",
      "loadMore": "Load older",
      "loadingMore": "Loading older messages"
    },
    "activityLog": {
      "title": "Timeline",
      "hint": "Pick a tool, a kind of event and a period. Every row says what happened, who it concerns and how to get there.",
      "filterTool": "Tool",
      "filterOutcome": "Kind of event",
      "filterPeriod": "Period",
      "filterClient": "Client",
      "allClients": "All clients",
      "empty": "Nothing matches this filter. Try a longer period or another tool.",
      "loadError": "The timeline could not be loaded.",
      "loadMore": "Load older",
      "loadingMore": "Loading older...",
      "end": "End of the list. The oldest entry shown is from {date}.",
      "tool": {
        "all": "All tools",
        "calls": "Calls and unlocking",
        "team": "Team",
        "clients": "Clients and their steps",
        "materials": "Sales materials",
        "profile": "Profile and transcripts",
        "messaging": "Notifications",
        "imports": "Imports",
        "access": "Access",
        "system": "System"
      },
      "outcome": {
        "all": "Everything",
        "error": "Failures",
        "intervention": "Manual fixes",
        "progress": "Normal progress"
      },
      "period": {
        "0": "Full history",
        "1": "Last 24 hours",
        "7": "Last 7 days",
        "30": "Last 30 days"
      }
    },
    "settingsContent": {
      "hint": "Applies to every client without their own video. You see who a change reaches before you make it.",
      "loadError": "The default content overview could not be loaded.",
      "configured": "Configured",
      "notConfigured": "Not configured",
      "updatedAt": "Last changed",
      "durationUnknown": "Not given",
      "durationSeconds": "{count} s",
      "durationMinutes": "{count} min",
      "usage": "Clients without their own video who see it: {default}. Own video: {own}. Watched to the end: {done}.",
      "usageNoDefault": "No default video yet. {own} of {clients} clients have their own, the rest have nothing to play.",
      "saving": "Saving...",
      "savedTitle": "{video} is set: {title}",
      "savedReach": "Clients without their own video who see it: {count}.",
      "savedNext": "The Videos card in the client detail shows how much each of them watched.",
      "clearedTitle": "The default video is removed.",
      "clearedNext": "Clients with their own video keep it. The rest stop being offered a video.",
      "saveError": "The save did not go through.",
      "saveErrorHint": "Your values stayed in the form. Check the video address and try again.",
      "where": {
        "onboarding_video": "The client sees it in the Intro video step. It is the only way through the step: at the unlock time it opens the Buddy questionnaire.",
        "marketing_video": "The client sees it in the Marketing video step. It is the only way through the step: at the unlock time it opens the sales questionnaire."
      },
      "unlockAtInvalid": "The unlock time must sit inside the video and needs the duration filled in.",
      "saveNeeds": "Fill in both the title and the video link, otherwise it cannot be saved."
    },
    "diagnostics": {
      "loadError": "Diagnostics could not be loaded.",
      "transcripts": {
        "title": "Stuck transcripts",
        "hint": "The list starts from the failure: whose file it is, what the transcription service reported and how many attempts ran. Retry from the row itself.",
        "empty": "No transcript is stuck.",
        "emptyHint": "When something gets stuck it shows up here with its reason.",
        "state": {
          "error": "Failed",
          "stalled": "Lease expired"
        },
        "reason": "Reason: {reason}",
        "reasonUnknown": "The service returned no reason. Details are in the operational log.",
        "attempts": "Attempts: {count}",
        "retry": "Run the transcript again",
        "retrying": "Starting...",
        "doneTitle": "The transcript is back in the queue.",
        "doneNext": "The finished text appears in the client profile. If it fails again the row returns here with a new reason.",
        "failedTitle": "The retry did not go through.",
        "failedNext": "Nothing changed. Reload the list, the state may have moved in the meantime.",
        "stalledHint": "The lease expired and the scheduler picks this file up on its own. A manual retry would not help now.",
        "notRetryable": "The file never reached storage, so a transcript has nothing to work from. The client has to upload it again.",
        "offlineTitle": "The restart was not sent",
        "count": "Stuck transcripts: {count}",
        "confirmTitle": "Confirm the repeat",
        "confirmBody": "Run the transcription again: {client}, file {file}. The transcription service gets the file once more.",
        "confirm": "Run it again",
        "emptyFiltered": "Nothing is stuck among the visible transcripts.",
        "emptyFilteredHint": "Test clients are hidden, so this is not the whole picture. Show test clients too before you call this panel clear."
      },
      "scope": {
        "q1_voice": "Recording for the onboarding brief",
        "q2_voice": "Recording for the sales brief",
        "profile_voice": "Recording for the profile",
        "feedback_audio": "Recorded note",
        "app_voice": "Recording for the app",
        "knowhow_material": "Know-how material",
        "legacy_material": "Legacy material",
        "feedback_screenshot": "Note screenshot",
        "proof_screenshot": "Proof screenshot",
        "expert_photo": "Expert photo",
        "ai_avatar": "Avatar",
        "app_asset": "App store graphic"
      }
    },
    "dossierWizard": {
      "title": "Dossier import",
      "hint": "Paste the facts and the wizard checks them before anything reaches the server. The import runs in three steps, exactly like the runner.",
      "currentVersion": "Version {version} is live, {count} facts, finished {date}.",
      "noVersion": "This client has no finished dossier yet.",
      "payloadLabel": "Facts as JSON",
      "payloadHint": "An array of facts, or an object with a facts key. Every fact needs factKey, category and text.",
      "pickFile": "Choose a file",
      "fileUnreadable": "The file could not be read. Pick it again, or paste its contents into the field above.",
      "check": "Check the data",
      "invalid": "Problems found: {count}",
      "invalidNext": "Nothing was sent. Fix the data and run the check again.",
      "valid": "The data is valid. Facts: {count}",
      "plan": "Version {version} will be created. {facts} will be uploaded {batches}, the current version stays in the history.",
      "import": "Upload the dossier",
      "pickClientFirst": "Pick a client first.",
      "batchProgress": "Batch {index} of {total}",
      "doneTitle": "The dossier is in. Version {version}, {count} facts.",
      "doneNext": "The client profile already reads the new version. Review it and adjust individual facts if needed.",
      "failedSafe": "Nothing was overwritten and the current dossier still applies. Fix the data and run the import again, it creates a new version.",
      "issue": {
        "emptyInput": "The field is empty. Paste the facts or choose a file.",
        "notJson": "This is not valid JSON. Check the commas and quotes.",
        "notFactList": "An array of facts, or an object with a facts key.",
        "noFacts": "The list of facts is empty.",
        "notObject": "Item {position} is not an object.",
        "missingFactKey": "Fact {position} has no factKey.",
        "duplicateFactKey": "Fact {position} repeats an earlier factKey: {value}",
        "badCategory": "Fact {position} has an unknown category. Allowed: {categories}",
        "missingText": "Fact {position} has no text.",
        "badConfidence": "Fact {position} has confidence in a form other than a number.",
        "confidenceRange": "Fact {position} has confidence outside the range 0 to 1.",
        "badSupersedes": "Fact {position} has supersedesFactId in a form other than text."
      },
      "category": {
        "identity": "Identity",
        "business": "Business",
        "audience": "Audience",
        "offer": "Offer",
        "voice": "Brand voice",
        "proof": "Proof",
        "other": "Other"
      },
      "step": {
        "reserve": "Reserve the version",
        "upload": "Upload the facts",
        "finalize": "Verify and publish"
      },
      "stepState": {
        "waiting": "Waiting",
        "running": "Running",
        "done": "Done",
        "failed": "Failed"
      },
      "error": {
        "invalidRequest": "The server rejected the data as invalid.",
        "notFound": "The client or the version does not exist.",
        "forbidden": "You are not allowed to run this operation.",
        "stateConflict": "The state changed in the meantime, the import did not run.",
        "idempotency": "The request disagrees with an earlier attempt.",
        "batchMismatch": "The batch does not match the manifest.",
        "incomplete": "The server did not receive every fact.",
        "unknown": "The import failed.",
        "offline": "The data was not sent. Check your connection and run the import again; nothing changed on the server."
      },
      "checkNeedsFacts": "Paste the facts or pick a file. There is nothing to check yet.",
      "planFacts": {
        "one": "{count} fact",
        "few": "{count} facts",
        "other": "{count} facts"
      },
      "planBatches": {
        "one": "in {count} batch",
        "few": "in {count} batches",
        "other": "in {count} batches"
      }
    },
    "testFilter": {
      "summary": "Rows shown: {shown}. Test rows hidden: {hidden}.",
      "showAll": "Show test rows too"
    },
    "testRowBadge": "test",
    "matrixShownTest": {
      "one": "{count} test client among them",
      "few": "{count} test clients among them",
      "other": "{count} test clients among them"
    },
    "mutationOffline": "The request could not be sent. Check your connection and try again.",
    "botTransfer": {
      "title": "Automatic bot transfer",
      "enable": "Run transfers automatically",
      "switchHint": "While the switch is off, client submits queue up and the Mac Mini gets none of them. Turning it on starts working the queue.",
      "saved": "Saved.",
      "saveFailed": "The setting could not be saved. Try again.",
      "loadFailed": "The transfer queue could not be loaded. Try again.",
      "waiting": "In the queue:",
      "empty": "No transfers in the queue.",
      "openClient": "Open client",
      "status": {
        "pending": "Waiting",
        "running": "Running",
        "done": "Done",
        "failed": "Failed"
      }
    },
    "adminPanel": {
      "createClient": {
        "lead": "A client created by hand gets an owner, a partner and the same automations a Stripe purchase starts."
      },
      "stripe": {
        "lead": "The master switch, product mappings, Stripe events and the profile research queue."
      },
      "botTransfer": {
        "lead": "The master switch of the automatic Telegram bot transfer and the transfer queue."
      },
      "ownerRole": {
        "lead": "Setting the instance owner role from the Telegram ID the client submitted in the handover. Master switch and the last 20 runs."
      }
    },
    "clientLocale": "Client language",
    "override": {
      "title": "Client state of this step",
      "hint": "Hand it back to the client for approval, or approve on their behalf after you settled it on a call.",
      "stateApproved": "Confirmed by the client",
      "stateApprovedByStaff": "Approved by the partner on the client's behalf",
      "stateAwaiting": "Waiting for the client",
      "reopenButton": "Return to client",
      "approveButton": "Approve for client",
      "reopenConfirm": "Return “{item}” to {client}? The approval is canceled, the client sees the reason and gets the material back for comments and approval.",
      "approveConfirm": "Approve “{item}” for {client}? Their interface shows it as approved with a note that the partner confirmed it after your call.",
      "confirmReopen": "Yes, return it",
      "confirmApprove": "Yes, approve for the client",
      "reasonLabel": "Reason (the client will see it)",
      "reasonPlaceholder": "E.g. We agreed on the call to adjust the pricing.",
      "reasonRequired": "Write a reason. The action needs one.",
      "reopenedNote": "Returned by the partner: {reason}",
      "approvedNote": "Approved on the client's behalf: {reason}",
      "lockedTitle": "What cannot be returned here",
      "error": {
        "override_locked": "This state is locked and cannot be returned.",
        "override_unavailable": "This step has no client approval that could be returned.",
        "reason_required": "Write a reason, the action needs one.",
        "required_answers_missing": "The client is missing required answers, the questionnaire cannot be submitted now.",
        "q1_training_started": "Training already runs or finished, this step cannot be returned.",
        "q2_deliverable_exists": "Sales materials already exist for this brief, the submission cannot be returned.",
        "q2_build_running": "A build is running right now, wait for it to finish.",
        "state_conflict": "The step is in a different state than the action expects. Reload the client detail.",
        "generic": "The action did not go through. Try again or reload the client detail."
      }
    },
    "botTransferCard": {
      "title": "Automatic bot transfer",
      "state": {
        "pending": "The job is queued; the Mac Mini will pick it up.",
        "running": "The transfer is running.",
        "done": "The transfer went through; the client owns the bot.",
        "failed": "The transfer failed. The bot is still ours."
      },
      "bot": "Bot",
      "recipient": "Recipient",
      "recipientIsBot": "Same name as the bot. The client filled in the bot's name instead of their own.",
      "queued": "Queued",
      "attempts": "Attempts",
      "finished": "Finished",
      "reason": "Reason",
      "faultClient": "The client can fix this.",
      "faultTeam": "This one is ours.",
      "botfather": "BotFather's reply",
      "transcript": "Show the dialog transcript",
      "returned": "Sent back to the client for a fix: {date}. Reason: {reason}",
      "returnedClosed": "It cannot be sent back twice. The ball is with the client: a corrected account starts a fresh transfer.",
      "returnHint": "The client sees the named message and the username form again. Once they send a username, the transfer starts by itself.",
      "returnButton": "Send back for a fix",
      "returnConfirm": "Send the bot transfer back for a fix? Client: {client}",
      "reasonLabel": "Reason for the client",
      "reasonPlaceholder": "For example: the field holds the bot's name, we need your own username.",
      "reasonRequired": "Write a reason; the client will read it.",
      "returning": "Sending back...",
      "confirmReturn": "Yes, send it back",
      "returnDone": "Sent back to the client.",
      "error": {
        "generic": "Sending it back failed. Try again.",
        "no_failed_transfer": "Only a failed transfer can be sent back. Reload the client.",
        "already_returned": "This transfer is already back with the client. It is waiting for their fix.",
        "transfer_completed": "The bot already changed hands; there is nothing to send back.",
        "reason_required": "Write a reason; the client will read it.",
        "idempotency_mismatch": "The same action already ran with a different reason. Reload the client.",
        "invalid_request": "The request could not be processed. Reload the client.",
        "not_found": "The client was not found. Reload the console.",
        "forbidden": "You are not allowed to do this.",
        "csrf_invalid": "Your session expired. Reload the page.",
        "origin_invalid": "Your session expired. Reload the page.",
        "impersonation_readonly": "Impersonation is read-only.",
        "state_conflict": "A manual bot handover is in flight with this client. Finish or cancel that first."
      }
    },
    "ownerRole": {
      "title": "Owner role automatically",
      "enable": "Set the owner role automatically",
      "switchHint": "Off: requests keep queueing, but the runner does not pick them up. Turn this on only after a dry run on the Mini.",
      "saved": "Saved.",
      "saveFailed": "Could not save.",
      "loadFailed": "Could not load the overview.",
      "empty": "No runs yet.",
      "openClient": "Open client",
      "bot": "Bot",
      "reason": "Reason",
      "quote": "Instance replied",
      "attempts": "Attempts",
      "counts": "Queued {pending}, running {running}, done {done}, failed {failed}",
      "status": {
        "pending": "Queued",
        "running": "Running",
        "done": "Done",
        "failed": "Failed"
      }
    },
    "appRelease": {
      "state": {
        "draft": "The client has not sent us the app questionnaire yet.",
        "submitted_for_publishing": "The client sent the materials. Prepare the app for the stores.",
        "in_publishing": "We are pushing the app to the stores right now.",
        "live": "The app is in the stores. The step closed for the client.",
        "rejected": "The store asked for changes. The client has the questionnaire open again.",
        "archived": "We pulled the app from the stores."
      },
      "action": {
        "draft": "Return to the client for edits",
        "submitted_for_publishing": "Mark as submitted for publishing",
        "in_publishing": "We started publishing",
        "live": "The app is in the stores",
        "rejected": "The store asked for changes",
        "archived": "Pull from the stores"
      },
      "error": {
        "release_transition_invalid": "That move is not possible from this state. Reload the client, the state moved in the meantime.",
        "store_links_required": "It cannot go live without the store links. Add a link for every store the client ships to.",
        "app_not_included": "This client did not buy the app, so there is nothing to release.",
        "generic": "The state could not be changed. Please try again."
      },
      "terminal": "This state does not move anywhere else.",
      "linksHint": "Once the app is through to the stores, add the links. Only the stores the client ships to.",
      "iosLabel": "App Store link",
      "androidLabel": "Google Play link",
      "working": "Switching..."
    },
    "phaseAge": "{phase}: {age}",
    "sectionAge": "Time in section",
    "testClassification": {
      "title": "Test account",
      "hint": "Classification determines whether this account counts as a client in team overviews.",
      "currentTest": "This account currently appears among test accounts.",
      "currentReal": "This account currently appears among regular clients.",
      "label": "Account classification",
      "auto": "Automatically from name and email",
      "test": "Test account",
      "real": "Regular client",
      "filterHint": "Turn on test accounts to find this account. Access and history are preserved.",
      "loadError": "Account classification could not be loaded.",
      "reload": "Reload",
      "save": "Save classification",
      "saving": "Saving…",
      "saved": "Classification saved.",
      "saveError": "Classification could not be saved. Please try again."
    },
    "paymentsSetup": {
      "title": "Payment setup",
      "hint": "The team sets up the payments; the client only gives us access to Stripe. Tick each item as it gets done. The step closes for the client when you click Done.",
      "loading": "Loading the payment setup.",
      "notIncluded": "This client did not buy the payment setup. An admin can switch it on in the client settings.",
      "lockedNote": "The client sees this step once the sales page is approved. You can tick items already.",
      "items": {
        "access": {
          "title": "We have access to the client's Stripe",
          "hint": "An invite as Administrator or Developer, or a call where the client connects Stripe through /setupStripe."
        },
        "stripe_connected": {
          "title": "Stripe is connected to the Buddy",
          "hint": "The /setupStripe command in the client's Buddy."
        },
        "tariffs": {
          "title": "Plans from the approved strategy",
          "hint": "Stripe products with the BuddyPro metadata."
        },
        "subscription_url": {
          "title": "Subscription link after the trial",
          "hint": "The /setDefaultSubscriptionUrl command. client_reference_id has to reach the payment."
        },
        "invites": {
          "title": "Invites",
          "hint": "The /generateBuddyProInvite command."
        },
        "order_links": {
          "title": "Order links in the sales page",
          "hint": "Every plan on the sales page leads to its own payment link."
        },
        "test_purchase": {
          "title": "Test purchase paired to a user",
          "hint": "The purchase went through and the Buddy assigned it to the right user."
        }
      },
      "complete": "Done, payments are set up",
      "completeNeedsAll": "Tick every item first.",
      "doneLine": "Done: {name}, {date}.",
      "reopen": "Reopen the step",
      "flagTitle": "Payment setup",
      "flagHint": "Switch on when the client also bought the payment setup. The client gets the Payment setup step right after the sales page. Nothing is sent to anybody.",
      "flagOn": "On: the client has the Payment setup step.",
      "flagOff": "Off: the client has no Payment setup step.",
      "errors": {
        "payments_setup_not_included": "The payment setup is not switched on for this client.",
        "payments_setup_completed": "The step is done. Reopen it first to change it.",
        "payments_checklist_incomplete": "Tick every item first.",
        "payments_step_locked": "The client cannot see the step yet; the sales page is not approved.",
        "unavailable": "The payment setup could not be loaded or saved. Try again."
      }
    }
  },
  "mail": {
    "loginSubject": "Your Launchpad sign-in link",
    "noAccountSubject": "There is no Launchpad account for this address",
    "noAccountIntro": "Someone, most likely you, asked for a sign-in link to BuddyPro Launchpad for this e-mail address. We have no account under it. Try the address your first Launchpad invitation came to. If nobody asked for it, you can safely ignore this e-mail.",
    "noAccountCta": "Try another e-mail",
    "loginIntro": "Click the button and you are in. The link is yours alone, so please do not forward it.",
    "loginIntroStart": "Click the button and you are in. Your Start package is paid for, and this link opens Launchpad, where your Buddy gets built step by step. The link is yours alone, so please do not forward it.",
    "loginIntroEmpire": "Click the button and you are in. Your Empire package is paid for, and this link opens Launchpad, where your Buddy gets built step by step. The link is yours alone, so please do not forward it. Empire also comes with David Riha's direct phone number: {phone}.",
    "loginCta": "Open Launchpad",
    "inviteSubject": "You are invited to BuddyPro Launchpad",
    "inviteIntro": "{name} is inviting you into their Launchpad to help build their Buddy. You will see the steps in progress and the finished materials, and you can comment on them. Accept the invitation and take a look at where things stand.",
    "inviteIntroNoName": "You are invited into a Launchpad to help build a Buddy. You will see the steps in progress and the finished materials, and you can comment on them. Accept the invitation and take a look at where things stand.",
    "inviteCta": "Accept invitation",
    "expires": "The link works for 7 days. After that, ask for a new one on the sign-in page.",
    "sectionSubject": "A new step is open in your Launchpad",
    "sectionIntro": "You finished the last part, so the next step just unlocked. Open it and you will see what it asks for and what it leads to. Nothing moves forward without you, so the sooner you start, the sooner your Buddy is done.",
    "callSubject": "Your call is confirmed",
    "callIntro": "You are on the list. We will remind you on the morning of the call, three hours ahead, and once more right before we start, so the time cannot slip past you. You join with one click straight from Launchpad, with nothing to install.",
    "actionSubject": "{client}: an item is waiting for the team",
    "actionIntro": "The client finished their move, so the next one is ours. Open them in the console and you will see which step it sits on and what it needs. Until somebody picks it up, the client is waiting.",
    "transcriptSubject": "{client}: a recording transcript needs a human",
    "transcriptIntro": "The automatic transcription failed, so we have no text from that recording yet. You will find it on the client in the console: play it back, type the transcript by hand, or run the transcription again. The client does not know and assumes their recording is being worked on.",
    "knowhowSharedSubject": "Your know-how folder is ready",
    "knowhowSharedIntro": "We shared it with {email}, so you can start uploading right away. Put in everything your Buddy should learn from: PDFs, slide decks, call transcripts, links. The more material it has, the sharper its answers get.",
    "knowhowSharedCta": "Open know-how",
    "brandTag": "Launchpad · notification",
    "footer": "BuddyPro Launchpad. You can adjust notifications in Launchpad under My account.",
    "qNudgeSubject": "We cannot move without your questionnaire",
    "qNudgeIntro": "{step} has been waiting on you for a few days. Everything that comes after it is built from your answers, so until they land we are standing still. You do not have to finish it in one sitting, since answers save as you go. If something has you stuck, book a call with your partner and walk through it together.",
    "qNudgeCta": "Open the questionnaire",
    "noShowSubject": "We missed you on the call",
    "noShowIntro": "The call happened and we did not catch you there. Nothing is lost: we will post the recording as soon as it is ready, and if you need to talk through something of your own, book a slot with your partner. Above all, get moving on the next step so your Buddy keeps moving too.",
    "noShowCta": "Continue",
    "dfyQ2ReadyTitle": "{client}: the sales questionnaire is in",
    "salesImportSummaryTitle": "{client}: the import is done, the client is in the console",
    "salesImportSummaryBody": "An import placed this client in your console, so the first steps are done without you and their separate notices were held on purpose. {summary} Open the client and see what is waiting for you.",
    "salesImportSummaryDone": "Done: {items}.",
    "salesImportSummaryNothing": "Nothing of theirs is waiting for review yet.",
    "salesImportSummaryMaterials": {
      "one": "{count} material to review",
      "few": "{count} materials to review",
      "other": "{count} materials to review"
    },
    "salesImportSummaryQuestionnaire": "the sales questionnaire submitted",
    "salesImportSummaryStrategy": "the strategy approved",
    "dfyQ2ReadyBody": "The sales strategy proposal started building on its own, so there is nothing to launch. We will write to you the moment the first version is ready for review. In the meantime you can read what the client actually wrote, so the content holds no surprises.",
    "dfyDeliverableReadyTitle": "{client}: ready for review, {deliverableTitle}",
    "dfyDeliverableReadyBody": "This is the material waiting on you: {deliverableTitle}. Read it through and either publish it to the client or send it back to Alex for another pass. Until you publish it, the client does not see it.",
    "dfyOpenClient": "Open client materials",
    "brandTagPlain": "Launchpad",
    "footerPlain": "BuddyPro Launchpad.",
    "clientNoteTitle": "{client}: new comments from the client, {material}",
    "clientNoteBody": "The client left notes on this material: {material}. Read them and hand them to Alex so the loop keeps moving. The client is waiting on a new version.",
    "clientMessageTitle": "{client} is writing to you from Launchpad",
    "clientMessageBody": "The client sent you a message through the button on their partner card. Just reply to this e-mail and your answer goes straight to the client at {email}.",
    "buildFailedTitle": "{client}: the build stopped, {material}",
    "editFailedTitle": "{client}: the edit did not go through ({material})",
    "orderLinksFailedTitle": "{client}: the order links were not inserted",
    "botTransferDoneSubject": "The bot is yours, invite your testers",
    "botTransferDoneIntro": "The transfer is done, the bot now lives on your Telegram account and nobody else can reach it. The Invite testers step is open in Launchpad: send the link to people your Buddy can actually help, and ask them what its answers are missing. Their notes are the most valuable thing you can get right now.",
    "botTransferDoneCta": "Open beta testing",
    "botTransferFailedTitle": "{client}: the bot transfer failed",
    "botTransferFailedIntro": "The automatic Telegram bot transfer did not go through: {reason}. The client does not know and still sees only that we are working on it, so this will not resolve itself. Open the client in the console, read the transcript, and decide whether to run the transfer again or send the step back to the client for a fix.",
    "partnerAssignedSubject": "Your partner is here: {partner}",
    "partnerAssignedIntro": "{partner} will walk you through the whole process, from the first step to launch. Write any time you need something, or book a call straight away. The contact sits in the right column of your dashboard.",
    "partnerAssignedStaffTitle": "{client}: a new client for you",
    "partnerAssignedStaffBody": "{admin} just handed this client to you, so they are yours from now on. The console has their profile, the product they bought and the step they are on. The client already has an email with your name in it, so they may write to you today.",
    "partnerAssignedStaffAdminFallback": "An administrator",
    "botTransferReason": {
      "recipient_not_started": "the recipient has not messaged the bot on Telegram yet",
      "recipient_not_found": "the recipient's account was not found on Telegram",
      "recipient_bot_limit": "the recipient's account already holds the maximum number of bots and has to free a slot",
      "recipient_invalid_target": "the name given is a bot or a channel, not a personal account",
      "floodwait": "Telegram temporarily rate-limited us (FloodWait)",
      "twofa_too_fresh": "the account's two-step verification is younger than 7 days",
      "gate_mismatch": "BotFather's confirmation message did not match the bot or the recipient",
      "bot_not_found": "the bot was not found in /mybots",
      "session_unavailable": "the Telegram session was unavailable",
      "verification_unavailable": "the confirmation went out, but we could not verify whether the bot really changed hands. Check our account's /mybots by hand before running it again",
      "unknown": "unknown error, details are in the transcript"
    },
    "buildFailedBody": "The build hit an error and produced nothing: {material}. Open the client in the console and run it again, which usually clears it on the second pass. The client knows nothing about the hiccup and is waiting, so the sooner you restart it the better.",
    "dfyDeliverableRevisedTitle": "{client}: new version after comments, {deliverableTitle}",
    "dfyDeliverableRevisedBody": "Alex applied the comments and version {version} is done: {deliverableTitle}. Read it and publish it to the client, or send another round of notes. For now the client still sees the previous version.",
    "gateApprovedTitle": "{client}: approved, the build carries on, {material}",
    "gateApprovedBody": "The client approved version {version} of this material: {material}. The next build step started on its own, so there is nothing for you to do. We will write when its first version comes out.",
    "gateApprovedPush": "Version {version} is approved, the next build step is already running.",
    "trainingReadyTitle": "{client}: the instance is trained",
    "trainingReadyBody": "Instance Creator finished training the Buddy{botSuffix} and the instance is ready. Asking it a few questions takes a minute, and it is the last check before the client sees it. Once you approve it in the console, beta testing opens for the client.",
    "editFailedBody": "The edit did not go through: {material}. The material is unchanged, still on its latest version. Open the client and send the same edit again. Do not start a build, it would throw the finished version away.",
    "orderLinksFailedBody": "Inserting the order links into the sales page did not go through. The page is unchanged on its approved version and the links are still stored. Open the client and send the link insertion again. Do not build a new sales page, it would throw the approved version away.",
    "trainingReadyBotSuffix": " (bot @{bot})",
    "trainingReadyPush": "Check the instance and approve it in the console.",
    "appWizardSubmittedTitle": "{client}: mobile app materials",
    "appWizardSubmittedBody": "The client filled in and submitted everything the app needs: the copy, the icon and the store graphics. Check them in the console against what Apple review will accept, then hand them to publishing. If something is missing, send it back with a note on what to add.",
    "appWizardSubmittedPush": "The app materials are submitted. Check them in the console.",
    "appPrefillReadySubject": "Your app questionnaire is prefilled",
    "appPrefillReadyIntro": "We read your answers, your approved strategy and your sales page, and filled in most of the mobile app questionnaire from them. What is left is to read it through, fix anything that landed wrong, and add your store images. Once you send the questionnaire to us, we prepare the app for release.",
    "appPrefillReadyCta": "Open the app questionnaire",
    "instanceTeamDoneTitle": "{client}: you are on the team of instance @{bot}",
    "instanceTeamDoneBody": "We added you to the team of instance @{bot} with admin rights. You can edit the system prompt, add know-how, and try out how the Buddy answers right away.",
    "instanceTeamDonePush": "The instance is ready for you to manage.",
    "instanceTeamFailedTitle": "{client}: joining the team of @{bot} failed",
    "instanceTeamFailedBody": "We could not add you to the team of instance @{bot}{noteSuffix}. The usual cause is that your Telegram account has never messaged the bot: send it one message and try again from the console. Without team membership you cannot manage the instance.",
    "instanceTeamFailedPush": "Please try again from the console.",
    "instanceTeamNoteSuffix": " ({note})",
    "openClientConsole": "Open the client in the console",
    "callReminder": {
      "day": {
        "cta": "Open Launchpad",
        "intro": "We meet today at {time} on the shared call. One click in Launchpad takes you in, with nothing to install. If the time stopped working for you, move it to another slot there.",
        "subject": "Your call with your partner is today at {time}"
      },
      "h3": {
        "cta": "Open Launchpad",
        "intro": "We meet today at {time}. Bring the questions you want answered so you get the most out of it. If the time stopped working for you, move it to another slot in Launchpad.",
        "subject": "Your call starts in three hours"
      },
      "m15": {
        "cta": "Open Launchpad",
        "intro": "We start at {time}, so it is time to settle in. Open Launchpad and join with one click the moment we go live.",
        "subject": "Starting shortly, at {time}"
      },
      "live": {
        "cta": "Join the call",
        "intro": "We are inside and waiting for you. Join with one click, you have not missed anything important yet.",
        "subject": "The call is running now"
      }
    },
    "staffReopenedSubject": "Sent back for another pass: {material}",
    "staffReopenedBody": "Your partner's note reads: {reason}. The step is open again, so you can fill in what is missing, add comments, and approve it once more. Nothing was lost, every earlier comment is still there.",
    "openLaunchpad": "Open Launchpad",
    "staffApprovedSubject": "Approved after your call: {material}",
    "staffApprovedBody": "Your partner approved the step for you, exactly the way the two of you agreed, so it is off your plate. The note reads: {reason}. There is nothing left to do, the material already moved on.",
    "botTransferFailedQuote": "BotFather replied: \"{message}\"",
    "botTransferFixSubject": "The bot transfer needs a corrected username",
    "botTransferFixIntro": "The transfer could not go through: {detail}. Open the Beta testing step in Launchpad, fix the account name and send it again. We start the transfer ourselves after that and let you know the moment the bot is yours.",
    "botTransferFixCta": "Open beta testing",
    "sectionSubjectNamed": "{step} is now open for you",
    "sectionIntroNamed": "{step} is ready and waiting on you. It carries the brief and what it leads to. Nothing moves forward without you, so the sooner you start, the sooner your Buddy is done.",
    "sectionCta": "Open the step",
    "callCta": "Open Launchpad",
    "deliverableReviewSubject": "{material}: version {version} is ready for you",
    "deliverableReviewIntro": "The new version is in Launchpad. Read it through and either approve it or write straight into the text what you want changed. We read every comment and fold it into the next version.",
    "deliverableResolvedSubject": "{material}: every comment is applied",
    "deliverableResolvedIntro": "The new version carries all your comments, one by one. Read it through and approve the material, or add more notes if something still feels off.",
    "deliverableOpenCta": "Open the material",
    "orderLinksSubject": "Your order links are live in your sales page",
    "orderLinksIntro": "Every button on the page now points at your own order link, one per tier. That unlocks the download and the publish options, so you can put the page out whenever you want. Before you do, click each button once and check that it lands where it should.",
    "orderLinksCta": "Open the sales page",
    "orderLinksPush": "The page is ready to download and publish.",
    "botTransferReadySubject": "Your Telegram bot is ready to take over",
    "botTransferReadyIntro": "The bot is queued for transfer and the next move is yours. BotFather will send you a confirmation in Telegram, and the moment you accept it the bot is yours. Then come back to Launchpad and confirm it here too, which opens the tester step.",
    "botTransferReadyCta": "Open beta testing",
    "trainingStartedTitle": "{client}: Buddy training has started",
    "trainingStartedBody": "The client sent their know-how and Alex started building their Buddy. It takes two to three working days. I will get back to you once it is ready for review.",
    "trainingStartedPush": "Alex is building Buddy. I will let you know when it is ready.",
    "trainingFailedTitle": "{client}: Buddy training stopped",
    "trainingFailedBody": "Building Buddy ended with an error and will not continue on its own. Open the client in the console and agree with the team on what happens next.",
    "trainingFailedPush": "Building Buddy failed and needs a person.",
    "handoverOwnerRoleSubject": "Your owner role is set",
    "handoverOwnerRoleBody": "Your owner role is set, so the bot will now give you a linking code. Finish step 3 in the handover: send /connectWeb to your bot, paste the code into the dashboard and confirm you can see your instance.",
    "ownerRoleFixSubject": "We need a different Telegram ID",
    "ownerRoleFixIntro": "We could not set the owner role: {detail}. You can fix it right in the handover.",
    "ownerRoleFixCta": "Open handover",
    "ownerRoleFailedTitle": "{client}: the owner role was not set",
    "ownerRoleFailedIntro": "The automation did not set the owner role. Reason: {reason}.",
    "ownerRoleFailedQuote": "The instance replied: „{message}“"
  },
  "impersonation": {
    "viewingAs": "Viewing as {client}",
    "role": {
      "partner": "Partner",
      "admin": "Administrator"
    },
    "mode": {
      "look": "Looking only",
      "act": "Can act"
    },
    "switchToAct": "Act for the client too",
    "switchToLook": "Back to looking only",
    "remaining": "{minutes} min left",
    "exit": "Back to console",
    "exiting": "Going back...",
    "modeFailed": "The mode could not be switched. Try once more.",
    "endFailed": "The return to the console did not go through. Please try once more.",
    "consoleLost": "The preview hour ended and the console signed out meanwhile. Please sign in again.",
    "refusal": {
      "looking": "You are in looking-only mode, so nothing is saved.",
      "handover": "The client hands the instance over themselves: the bot and its keys really change owner.",
      "publish": "Publishing to their own site is the client's own move.",
      "payments": "We do not act for the client around payments.",
      "other": "This act stays closed on the client's behalf."
    }
  },
  "steps": {
    "eyebrow": "Start here",
    "title": "What you can do right now",
    "step1Title": "Book your kickoff call",
    "step1Copy": "We'll walk you through the full process and explain what we'll need from you.",
    "step2Title": "Review what we know about you",
    "step2Copy": "Review the profile we created from public sources. Add what's missing and correct anything that doesn't sound like you.",
    "step3Title": "Create your Apple Developer account",
    "step3Copy": "Apple usually activates the account within 48 hours, so start now. Our guide walks you through every step.",
    "step3Guide": "Open the account guide",
    "step4Title": "Invite a teammate",
    "step4Copy": "Want a teammate to take over? Enter their email. They can then work with us and manage the creation of your Buddy.",
    "lead": "This part is on you. Everything else, the bot, the license, the training and the copy, we handle for you."
  },
  "appGuide": {
    "title": "How to create an Apple Developer account",
    "intro": "The future account holder must complete the enrollment. After registration Apple verifies the company, usually within 1 to 2 working days.",
    "step1": "Register on developer.apple.com as an organization so the app ships under your company name. Choose Individual only if you have no company.",
    "step2": "Sign in with an Apple ID that has two-factor authentication enabled. Use your legal name, a physical address without a P.O. box, email, and phone number.",
    "step3": "For a company, prepare a valid D-U-N-S Number, legal entity name, work email on the company domain, functional website, and authority to sign.",
    "step4": "Submit at developer.apple.com/programs/enroll or in the Apple Developer app and watch for email from Apple. Sometimes it checks the details by phone.",
    "step5": "After approval, agree to the license and pay 99 USD per year in local currency. App Store Connect then becomes available.",
    "done": "Confirm application submitted"
  },
  "testbar": {
    "label": "Test mode",
    "prev": "Previous",
    "next": "Next",
    "exit": "Turn off"
  },
  "homeSteps": {
    "beforeCall": "You can do this in the meantime",
    "afterCall": "Other sections available to you",
    "completedHistory": "Completed steps",
    "completedHistoryCount": {
      "one": "{count} completed",
      "few": "{count} completed",
      "other": "{count} completed"
    },
    "call": {
      "title": "Watch the intro video",
      "videoCopy": "Before we start, watch the intro video. You will learn how the collaboration works, and the next step opens at the end.",
      "completedCopy": "The intro is behind you.",
      "nextAlreadyOpen": "Your next step is already open: {step}.",
      "connect": "Join the call",
      "calendar": "Add to calendar",
      "countdownLabel": "Time until the call",
      "nextWeek": "Reserve a spot on the next date",
      "enrolledNext": "Your alternative session is booked."
    },
    "profile": {
      "title": "Help us get to know you better",
      "copy": "We used public sources to prepare your profile and brand as a starting point for creating your Buddy. Some information may be outdated or related to other projects. We therefore need to know what is relevant to your Buddy and what is not.",
      "cta": "View and complete your profile",
      "completedCopy": "The profile is confirmed and your partner builds on it.",
      "open": "View confirmed profile"
    },
    "apple": {
      "title": "Preparing to publish your mobile app",
      "copy": "Take care of this this week. You register as an organization on developer.apple.com and it costs 99 USD a year. Apple then verifies the company, usually within 1 to 2 working days. We walk you through every step and handle everything else for you.",
      "cta": "Open the account guide",
      "short": "Mobile app"
    }
  },
  "invite": {
    "question": "Would you like a colleague to handle the preparation of your Buddy? Enter their email address and invite them here to Launchpad.",
    "accessTitle": "Add a collaborator",
    "accessCopy": "The invited person will see the profile, answers, and shared materials. They can help with preparation, but you keep your access. You can revoke a pending invitation at any time.",
    "accessPending": "They do not have access yet. You can revoke the invitation.",
    "accessAccepted": "They have access to shared materials. Your access stays unchanged.",
    "emailPlaceholder": "colleague@company.com",
    "button": "Invite a colleague",
    "sent": "The invitation has been sent.",
    "emailLabel": "Colleague email",
    "error": "We could not send the invite. Please try again.",
    "pendingTitle": "Sent invitations",
    "statePending": "Waiting for acceptance",
    "stateAccepted": "Accepted",
    "revoke": "Revoke invitation",
    "devLink": "Test environment: no email goes out. Hand this link to your colleague:"
  },
  "notifications": {
    "eyebrow": "Settings",
    "title": "Notifications",
    "pushDeviceTitle": "Push on this device",
    "pushOn": "Notifications are on for this device.",
    "pushOff": "This device does not receive notifications yet.",
    "pushDenied": "The browser has notifications blocked.",
    "pushDeniedHint": "Allow notifications in your browser settings and try again.",
    "pushUnsupported": "This browser does not support push notifications.",
    "pushEnable": "Turn on notifications",
    "pushDisable": "Turn off on this device",
    "pushIosInstall": "On iPhone, first add Launchpad to your home screen (Share, Add to Home Screen). Then turn notifications on here.",
    "pushKindsLegend": "What to send to this device",
    "emailTitle": "Email notifications",
    "emailMaster": "Send email notifications",
    "emailKindsLegend": "Which emails you want to receive",
    "kind": {
      "call": "Calls and appointments",
      "step": "New steps",
      "delivery": "Deliveries and outputs",
      "system": "System messages"
    },
    "criticalNote": "Login links and invites are always delivered and cannot be turned off.",
    "error": "Saving failed. Please try again.",
    "inbox": {
      "open": "Open notification center",
      "eyebrow": "Latest updates",
      "title": "Notifications",
      "unreadCount": "Unread notifications: {count}",
      "unread": "Unread",
      "readAll": "Mark all as read",
      "close": "Close notifications",
      "toastLabel": "New notification",
      "toastClose": "Close this notification",
      "toastOpen": "Open",
      "loading": "Loading notifications...",
      "empty": "Nothing new. Updates will appear here when something moves.",
      "error": "Notifications could not be loaded right now.",
      "errorSeverity": "Error",
      "confirmSending": "Confirming...",
      "confirmError": "We could not confirm this. Please try again.",
      "groupCount": "{count} matching notifications combined",
      "stepUnlocked": "A new step is open",
      "stepUnlockedBody": "You can continue with: {step}.",
      "reviewTitle": "{document} - version {version} ready for review",
      "reviewTitleLegacy": "{document} ready for review",
      "staffReviewTitle": "{client}: {document} - version {version} ready for review",
      "staffReviewTitleLegacy": "{client}: {document} ready for review",
      "reviewBody": "Review the changes and approve the document, or add comments.",
      "clientConfirmedTitle": "{client}: the material is approved",
      "clientConfirmedKindTitle": "{client}: approved, {document}",
      "clientConfirmedBody": "The client approved the material. The next build started automatically.",
      "unknownMaterialTitle": "{client}: an unknown material needs review",
      "unknownMaterialBody": "This notification has no valid material name. Open the client detail and verify the source before publishing anything.",
      "deliverable": {
        "strategy": "Sales strategy proposal",
        "salespage": "Sales page",
        "emails": "Emails",
        "webinar": "Webinar structure",
        "avatar": "Avatar"
      }
    },
    "confirm": {
      "apple": {
        "title": "Do you have your Apple Developer account?",
        "body": "If the account is ready, confirm it here and we will stop reminding you.",
        "primaryAction": "Create account",
        "action": "My account is ready"
      },
      "profile": {
        "title": "Can you confirm your profile?",
        "body": "You uploaded profile changes. Review the result and confirm that it is correct.",
        "primaryAction": "Review profile",
        "action": "The profile is correct"
      }
    },
    "testSubject": "Test notification from Launchpad",
    "testIntro": "This is a test message and it asks nothing of you. If it landed, email and push delivery both work. If the same message never reaches somebody else, start with their notification settings in Launchpad.",
    "testCta": "Open Launchpad"
  },
  "phase": {
    "label": "Step",
    "progress": "Step {current} of {total}"
  },
  "appleReminder": {
    "question": "Create your Apple Developer account as soon as you can. Apple usually activates it within 48 hours, and we cannot publish the app without it.",
    "yes": "Confirm account creation",
    "later": "Remind me later",
    "guide": "Setup guide",
    "fillQuestion": "Great, the account is yours. Once Apple approves it we will need your app info. Feel free to fill it in now.",
    "fillAction": "Fill in the app info",
    "fillSummary": "Great, your account is ready",
    "waitingDot": "Waiting for your input"
  },
  "account": {
    "eyebrow": "Account",
    "title": "Your account",
    "link": "My account",
    "emailLabel": "Signed-in email",
    "language": {
      "title": "App language",
      "copy": "The change is saved to your account and applies to every client screen.",
      "saved": "Language changed. You can continue where you left off.",
      "error": "We couldn't save the language. Try again."
    }
  },
  "countdown": {
    "day1": "day",
    "day2": "days",
    "day5": "days",
    "hours": "hrs",
    "minutes": "min",
    "seconds": "sec"
  },
  "stripe": {
    "eyebrow": "Step 15",
    "title": "Connect Stripe and receive payments",
    "copy": "Customers will pay the Buddy subscription through Stripe directly to you, and we take the payment links for your sales page from it. The step is technical but short, and we will guide you through it.",
    "inviteEyebrow": "Payment setup",
    "inviteTitle": "Connect your Stripe to your Buddy",
    "waiting": "Waiting for you",
    "preparing": "Preparing",
    "done": "Connected",
    "doneCopy": "Payments are connected and verified. Customer subscriptions go directly to you.",
    "statusEyebrow": "Payment status",
    "statusTitle": "Where we are",
    "statusWaiting": "Waiting for your Stripe account to be connected.",
    "statusPreparingLink": "Your Stripe connect link is being generated automatically. We will let you know once it is ready.",
    "statusReceiving": "Verified: payments arrive in your account.",
    "partnerCall": "Book an extra call with your launch partner",
    "connectButton": "Connect Stripe",
    "retryButton": "Try connecting again",
    "connectNote": "The BuddyPro link has no time limit. If Stripe shows an error, return here and start the same connection again.",
    "stepConnect": "Click Connect Stripe and walk through the connection. You sign in to your Stripe account or create one there.",
    "waitingForLink": "Your connection link is being generated automatically. Once it is here, one click connects your Stripe to your Buddy. We will let you know."
  },
  "payments": {
    "eyebrow": "Payment setup",
    "copy": "We set up the payments for your Buddy: we connect your Stripe to your Buddy, create the plans from the approved strategy and add the order links to your sales page. All we need from you is access to Stripe.",
    "statusEyebrow": "Payment status",
    "statusTitle": "Where we are",
    "status": {
      "locked": "This step opens once your sales page is approved.",
      "next": "We are waiting for access to your Stripe account. As soon as we have it, we start the setup.",
      "working": "We have access and are setting up your payments. Once everything is verified, you will see it here.",
      "done": "Payments are set up and verified with a test purchase. Customer subscriptions go straight to your Stripe."
    },
    "pill": {
      "locked": "Not open yet",
      "next": "Waiting for you",
      "working": "We are on it",
      "done": "Done"
    },
    "accessEyebrow": "What we need from you",
    "accessTitle": "Access to your Stripe account",
    "accessInvite": "Invite us to your Stripe as an Administrator or Developer. In Stripe open Settings, then Team and security, click Invite and enter {email}.",
    "accessInviteNoEmail": "Invite us to your Stripe as an Administrator or Developer. In Stripe open Settings, then Team and security, and click Invite. Your launch partner gives you the address to invite.",
    "accessCall": "Or book a short call with your launch partner and we connect your Stripe to your Buddy together during the call.",
    "bookCall": "Book a call with your partner",
    "workEyebrow": "What we set up",
    "workTitle": "Payments from connection to first purchase",
    "work": {
      "1": "We connect your Stripe account to your Buddy.",
      "2": "We create the plans from your approved sales strategy.",
      "3": "We set the subscription link that follows the free trial.",
      "4": "We prepare the invites and add the order links to your sales page.",
      "5": "We verify everything with a test purchase."
    }
  },
  "errors": {
    "crashTitle": "Something went wrong",
    "crashBody": "Please reload the page. Your data is safe.",
    "reload": "Reload"
  },
  "reader": {
    "panelPin": "Pin to the side",
    "panelFloat": "Float as a window",
    "panelHide": "Hide panel",
    "printPdf": "Save as PDF",
    "chapters": "Chapters",
    "printingPdf": "Preparing PDF..."
  },
  "appWizard": {
    "title": "Mobile app wizard",
    "navLabel": "Wizard steps",
    "progressLabel": "{done} of {total} steps complete:",
    "save": {
      "saving": "Saving...",
      "saved": "Saved",
      "error": "Save failed"
    },
    "loadError": {
      "salespageApprovalRequired": "The app questionnaire cannot open yet because the sales page has not been approved.",
      "generic": "The app questionnaire could not be loaded.",
      "retry": "Load again",
      "partnerCall": "Book an extra call with your launch partner",
      "partnerFallback": "Book an extra call with your launch partner"
    },
    "steps": {
      "overview": "Welcome",
      "basics": "App basics",
      "branding": "App appearance",
      "apple_developer": "Apple Developer account",
      "apple_copy": "App Store texts",
      "google_copy": "Google Play texts",
      "screenshots": "Store graphics",
      "subscriptions": "Subscriptions & pricing",
      "legal": "Legal info",
      "review": "Review & submit"
    },
    "stepState": {
      "todo": "To do",
      "in_progress": "In progress",
      "done": "Done"
    },
    "overview": {
      "title": "Your app on the App Store and Google Play",
      "copy": "Here you prepare everything the stores need to publish your app. Every step saves itself, leave and come back anytime.",
      "stores": "Pick the stores, language and app name",
      "brand": "Set the colors and icon so the app looks like your brand",
      "graphics": "Add the store texts and images",
      "pricing": "Define subscriptions and pricing",
      "parallel": "No need to wait for the Apple account approval. Fill everything in here meanwhile.",
      "start": "Start",
      "continue": "Continue"
    },
    "basics": {
      "title": "App basics",
      "copy": "Name, languages and the markets where your app will be available.",
      "storesLabel": "App stores",
      "storesHint": "Pick where the app should be published. You can change this anytime before submitting.",
      "storesRule": "At least one store must stay selected.",
      "nameLabel": "App name",
      "nameHint": "The name customers see under the icon and in both stores. Max 30 characters.",
      "primaryLanguageLabel": "Primary language",
      "primaryLanguageHint": "The language your app runs in and your store listing leads with.",
      "primaryLanguagePlaceholder": "Select a language",
      "moreLanguagesLabel": "Additional languages",
      "moreLanguagesHint": "Optional. Each extra language means extra texts to fill in, only add ones you will really maintain.",
      "currencyLabel": "Pricing currency",
      "currencyHint": "The currency you will see when setting subscription prices.",
      "currencyPlaceholder": "Select a currency",
      "categoryLabel": "Category",
      "categoryHint": "Where people find you in the stores. For mentoring and courses, Education is usually the best fit.",
      "categoryPlaceholder": "Select a category",
      "countriesLabel": "Countries where the app is available",
      "countriesHint": "Pick the markets where the app can be downloaded. Feel free to select everything, it costs nothing.",
      "regionAll": "Select all",
      "regionNone": "Clear selection"
    },
    "regions": {
      "europe": "Europe",
      "americas": "Americas",
      "asiaPacific": "Asia & Pacific",
      "middleEastAfrica": "Middle East & Africa"
    },
    "categories": {
      "books": "Books",
      "business": "Business",
      "education": "Education",
      "entertainment": "Entertainment",
      "finance": "Finance",
      "food_drink": "Food & Drink",
      "graphics_design": "Graphics & Design",
      "health_fitness": "Health & Fitness",
      "lifestyle": "Lifestyle",
      "medical": "Medical",
      "music": "Music",
      "navigation": "Navigation",
      "news": "News",
      "photo_video": "Photo & Video",
      "productivity": "Productivity",
      "reference": "Reference",
      "shopping": "Shopping",
      "social_networking": "Social Networking",
      "sports": "Sports",
      "travel": "Travel",
      "utilities": "Utilities",
      "weather": "Weather"
    },
    "branding": {
      "title": "Look & feel",
      "copy": "Your colors and icon. The previews below update live.",
      "colorsLabel": "Brand colors",
      "colorsHint": "Click a swatch to pick a color, or paste a hex code from your brand manual.",
      "color": {
        "primary": "Primary color",
        "secondary": "Secondary color",
        "accent": "Accent color",
        "background": "Background color"
      },
      "colorHint": {
        "primary": "Buttons, links and highlighted elements.",
        "secondary": "Gradients and supporting elements.",
        "accent": "Small details and notifications.",
        "background": "The background of the app screens."
      },
      "iconLabel": "App icon",
      "iconHint": "Square 1024 x 1024 px, PNG without transparency. Do not round the corners, the stores do that for you.",
      "previewLabel": "Live preview",
      "previewHint": "Real screens from your app, rendered live in your colors.",
      "previewAppName": "Your app",
      "previewSignupTitle": "Create account",
      "previewLoginSub": "Sign in to your account",
      "previewSignupSub": "Join in a minute",
      "previewLoginCta": "Sign in",
      "previewSignupCta": "Sign up",
      "previewLink": "Forgot password?",
      "previewOnline": "Online",
      "previewChatBot": "Hi! I am your guide. What can I help you with today?",
      "previewChatUser": "I want to move forward.",
      "previewChatBot2": "Great. Let us start with a quick question...",
      "previewCaption": {
        "login": "Login",
        "signup": "Sign up",
        "chat": "Chat"
      }
    },
    "appleDev": {
      "title": "Apple Developer account",
      "copy": "Without your own Apple developer account we cannot publish the app. After you register, Apple verifies the company, usually within 1 to 2 working days, so this comes first.",
      "confirmed": "Account confirmed. Once Apple approves the enrollment there is nothing else to do here.",
      "teamIdLabel": "Team ID",
      "teamIdHint": "Found after signing in at developer.apple.com under Membership. Fine to add later.",
      "emailLabel": "App Store Connect email",
      "emailHint": "The email you sign in to your Apple account with. It helps us invite the build.",
      "teamIdPlaceholder": "e.g. A1BC23DEF4",
      "emailPlaceholder": "name@company.com"
    },
    "appleCopy": {
      "title": "App Store texts",
      "copy": "The texts people see on your app page. Feel free to dictate the longer ones, the mic sits next to the field.",
      "subtitleLabel": "Subtitle",
      "subtitleHint": "A short line under the name. Max 30 characters.",
      "descriptionLabel": "App description",
      "descriptionHint": "The main store page text. Describe what the app does and who it helps. Up to 4000 characters.",
      "keywordsLabel": "Keywords",
      "keywordsHint": "Comma-separated words people find the app by. Max 100 characters.",
      "promoLabel": "Promotional text",
      "promoHint": "Optional. Shows above the description and can change without a new app version. Max 170 characters."
    },
    "copy": {
      "needLanguages": "First pick the primary language in App basics so we know which languages to collect texts in.",
      "goBasics": "Open App basics"
    },
    "googleCopy": {
      "title": "Google Play texts",
      "copy": "Short texts for the app page on Google Play.",
      "shortLabel": "Short description",
      "shortHint": "One line that sells. Max 80 characters.",
      "descriptionShared": "The long description is taken from the App Store texts step, only the short sentence is needed here.",
      "descriptionLabel": "App description",
      "descriptionHint": "The main Google Play page text. Up to 4000 characters."
    },
    "screenshots": {
      "title": "Store graphics",
      "copy": "The screenshots and graphics the stores require. Exact sizes are next to every slot.",
      "helpNote": "No screenshots at hand? Leave it empty and talk to your partner, we will prepare them with you.",
      "shotLabel": "Screenshot",
      "group": {
        "appleIphone": "iPhone screenshots",
        "appleIpad": "iPad screenshots",
        "googleFeature": "Google Play feature graphic",
        "googlePhone": "Google Play phone screenshots"
      },
      "groupHint": {
        "appleIphone": "4 screenshots, 1290 x 2796 px. The largest size is enough, Apple derives the smaller ones.",
        "appleIpad": "4 screenshots, 2048 x 2732 px. The same content as iPhone, on a wider canvas.",
        "googleFeature": "1 image, 1024 x 500 px. A wide banner at the top of your store page, keep text and logos away from the edges.",
        "googlePhone": "4 screenshots, 1080 x 1920 px. The iPhone visuals converted to a 9:16 ratio work well."
      }
    },
    "subscriptions": {
      "title": "Subscriptions & pricing",
      "copy": "The plans people buy in your app. One is enough, you can add up to six.",
      "empty": "No plan yet. Add the first one.",
      "tierLabel": "Plan",
      "removeTier": "Remove",
      "draftNote": "Draft plan. It saves once you pick a price.",
      "priceLabel": "Price",
      "pricePlaceholder": "Select a price",
      "priceHint": "Prices follow the Apple price chart. Stores convert them to each customer's currency.",
      "periodLabel": "Billing period",
      "trialLabel": "Free trial",
      "trialNone": "No free trial",
      "trialDays": "days",
      "nameLabel": "Plan name",
      "nameHint": "E.g. Monthly or Yearly. Max 30 characters.",
      "descLabel": "Plan description",
      "descHint": "Optional line for the plan. Max 45 characters.",
      "addTier": "Add plan"
    },
    "periods": {
      "weekly": "Weekly",
      "monthly": "Monthly",
      "two_months": "Every 2 months",
      "three_months": "Quarterly",
      "six_months": "Every 6 months",
      "yearly": "Yearly"
    },
    "legal": {
      "title": "Legal info",
      "copy": "The details the stores are required to show with your app.",
      "legalEntityNameLabel": "Registered company name",
      "legalEntityNameHint": "The official name exactly as registered. It appears as the seller in both stores.",
      "legalEntityAddressLabel": "Registered address",
      "legalEntityAddressHint": "The full registered address: street, city, postal code, and country.",
      "businessPhoneLabel": "Phone",
      "businessPhoneHint": "Required contact under the EU Digital Services Act. It is shown next to the app in the EU.",
      "supportEmailLabel": "Support email",
      "supportEmailHint": "Where your app users write for help.",
      "supportUrlLabel": "Support URL",
      "supportUrlHint": "Optional. A page with help or contact.",
      "marketingUrlLabel": "Marketing URL",
      "marketingUrlHint": "Optional. The page presenting your app.",
      "privacyPolicyUrlLabel": "Privacy policy",
      "privacyPolicyUrlHint": "Required by both stores. It must be publicly reachable on your website.",
      "termsOfServiceUrlLabel": "Terms of service",
      "termsOfServiceUrlHint": "Required for apps with a subscription."
    },
    "review": {
      "title": "Review & submit",
      "copy": "Check what is done. Once everything is green, send us the package with one button.",
      "submittedCopy": "The package is submitted. You can browse it here anytime.",
      "finishStep": "Finish",
      "incomplete": "Something is still missing. Complete the steps above and the button unlocks.",
      "submit": "Submit to the BuddyPro team",
      "submitting": "Submitting...",
      "submittedNote": "We handed the package to the team. We will keep you posted on the next steps."
    },
    "assets": {
      "errorUnknown": "This file type does not belong here.",
      "errorType": "Wrong file format. Upload a PNG, or JPG where allowed.",
      "errorSize": "The file is too large.",
      "errorDimensions": "The image does not match the exact size. Check the size next to the slot and upload again.",
      "errorTransparent": "The icon must not have a transparent background. Export it without transparency and upload again.",
      "errorUpload": "Upload failed. Please try again.",
      "uploading": "Uploading...",
      "choose": "Choose file",
      "replace": "Replace",
      "remove": "Remove"
    }
  },
  "dfyEta": {
    "step": "Step {current} of {total} · {label}",
    "remainingRange": "Usually {from}-{to} min left",
    "readyAt": "Ready at about {time}",
    "sample": "Estimate from {count} finished builds. It sharpens after every step.",
    "learning": "The estimate is still learning. Production continues.",
    "finishing": "Finishing up",
    "durationSeconds": "{seconds} s",
    "durationMinutes": "{minutes} min",
    "durationHours": "{hours} h",
    "durationHoursMinutes": "{hours} h {minutes} min",
    "doneOf": "{done} of {total} steps done",
    "onStep": "on this step {duration}",
    "usually": "usually ~{duration}",
    "runningFor": "running {duration}",
    "runningTotal": "Running for {duration}",
    "learningFirst": "The estimate is still learning, this is the very first build of this material.",
    "learningRun": "The estimate is still learning, this is only build number {number} of this material.",
    "stages": {
      "prep": "Preparation",
      "generate": "Writing",
      "critique": "Critique and rewrite",
      "qa": "Checks",
      "assembly": "Assembly",
      "delivery": "Delivery"
    },
    "stageStepsOne": "1 step",
    "stageStepsFew": "{count} steps",
    "stageStepsMany": "{count} steps",
    "skipped": "this step was skipped"
  },
  "automationTiming": {
    "typical": "Usually ~{minutes} min (from {count} runs)"
  },
  "partnerOS": {
    "navigation": {
      "label": "Partner OS primary navigation",
      "today": "Today",
      "clients": "Clients",
      "detail": "Detail",
      "admin": "Administration",
      "detailLocked": "Detail opens once a client is selected. Click to pick one in Clients."
    },
    "trainingRun": {
      "phase": {
        "1": "Expert research",
        "2": "Content discovery",
        "3": "Telegram bot",
        "4": "License",
        "5": "Google Drive",
        "6": "Knowledge base",
        "7": "System prompt",
        "8": "Voice and behavior tuning",
        "9": "Finalize"
      }
    },
    "today": {
      "kicker": "Partner OS",
      "title": "Today's work",
      "intro": "One place for the work that needs your decision today.",
      "openClients": "Open clients",
      "refresh": "Refresh",
      "error": "Today's queue could not be loaded.",
      "refreshFailed": "The queue could not be refreshed. Showing the state from {time}.",
      "open": "Open",
      "joinCall": "Join",
      "emptyTitle": "Today's queue is clear",
      "emptyBody": "No review, wait, or risk needs your attention right now.",
      "stream": {
        "mine": "My action",
        "calls": "Today's calls",
        "automation": "Production running",
        "waiting": "Waiting for client",
        "risks": "Blocked and at risk",
        "team": "Team's turn"
      },
      "summary": "{count} things to handle",
      "hiddenTest": "{count} test tenants hidden",
      "alsoPhases": "and {count} more phases",
      "etaSoon": "done any moment",
      "etaMinutes": "done in {count} min",
      "etaAt": "done around {time}",
      "newerBuilding": "A newer version is being built, wait for it",
      "shownTest": {
        "one": "{count} test client among them",
        "few": "{count} test clients among them",
        "other": "{count} test clients among them"
      }
    },
    "rail": {
      "label": "Client journey"
    },
    "clientHero": {
      "kicker": "Next best action",
      "localKicker": "Selected step status",
      "review": "Review and publish the prepared material",
      "failed": "Resolve the automation failure",
      "stepBlocked": "Unblock the step, a required output is missing",
      "automation": "Automation is working",
      "service": "Complete the service setup",
      "stripeLink": "Add the client's Stripe Connect link",
      "addStripeLink": "Add Stripe link",
      "waiting": "Waiting for the client",
      "waitingOnboarding": "The client has not booked the onboarding call yet",
      "waitingOnboardingNext": "The link is ready below. Send it again if the client does not respond.",
      "waitingMarketing": "The client has not booked the marketing call yet",
      "waitingMarketingNext": "The link is ready below. Send it again if the client does not respond.",
      "complete": "Everything is complete",
      "open": "Open step",
      "here": "Selected step",
      "local": {
        "partner_action": "The selected step needs your decision",
        "automation": "Alex is working on the selected step",
        "waiting_client": "The selected step is waiting for the client",
        "blocked": "The selected step is blocked",
        "locked": "The selected step is locked",
        "complete": "The selected step is complete"
      },
      "elsewhereLead": "Elsewhere for this client",
      "elsewhereState": {
        "partner_action": "waiting for your decision",
        "automation": "Alex is working",
        "waiting_client": "waiting on the client",
        "blockedTeam": "the team is finishing the output",
        "blockedAlex": "the automation failed"
      },
      "production": {
        "ready": "The team needs to prepare the material",
        "draft": "The team needs to finish the draft",
        "missing": "Waiting for: {prerequisite}",
        "approval": "Waiting for approval and release: {prerequisite}",
        "working": "Waiting for production: {prerequisite}",
        "failed": "Blocked by failed production: {prerequisite}",
        "body": "The next action belongs to the team. The client cannot move this material forward yet.",
        "open": "Open prerequisite material"
      }
    },
    "clientContext": {
      "kicker": "Context",
      "partner": "Partner",
      "partnerNone": "nobody yet",
      "partnerAssign": "Assign",
      "partnerChange": "Change",
      "title": "Client",
      "email": "Email",
      "nextCall": "Next call",
      "write": "Write",
      "open": "Open as client",
      "opening": "Opening...",
      "openHint": "For one hour this browser switches into the client's role. The bar at the top brings you back.",
      "openFailed": "Opening as the client did not work just now.",
      "openNotYours": "This client is not yours, so you cannot open them.",
      "openForbidden": "You are not allowed to open a client this way.",
      "openConflict": "The preview could not be started. Try once more.",
      "openOffline": "The connection to the server failed. Check your connection and try again.",
      "bot": "Buddy",
      "instance": "Instance",
      "instanceOpen": "Open in the hub",
      "drive": "Know-how",
      "driveOpen": "Drive folder",
      "profile": "Who the client is",
      "profileFacts": "{count} facts in the profile",
      "profileEmpty": "Profile is still empty"
    },
    "workState": {
      "partner_action": "Your action",
      "automation": "Running automatically",
      "waiting_client": "Waiting for client",
      "blocked": "Blocked",
      "complete": "Complete",
      "locked": "Locked",
      "done_ahead": "Done ahead"
    },
    "workspace": {
      "kicker": "Phase workspace",
      "reviewCard": "Review card",
      "visibleToClient": "The client sees this version",
      "clientSeesVersion": "The client still sees version {version}",
      "notVisibleToClient": "The client cannot see this material yet",
      "newerVersionBuilding": "A newer version is being built. Wait for it, this one is already being rewritten.",
      "buildFailed": "Production failed.",
      "openReview": "Open review room",
      "feedback": "Client feedback",
      "feedbackTeam": "Team feedback",
      "feedbackMixed": "Feedback",
      "noOpenFeedback": "No open feedback.",
      "voiceNote": "Voice feedback",
      "waitingForBuild": "This material is being produced.",
      "noMaterial": "No material is ready for this phase yet.",
      "aheadOfUnlock": "Done ahead: this output was finished before its step unlocked. Check the client was meant to get it."
    },
    "states": {
      "matrixLoadingTitle": "Loading clients",
      "matrixLoadingBody": "Building the current portfolio state.",
      "detailLoadingTitle": "Loading the client cockpit",
      "detailLoadingBody": "Checking steps, materials, and recent activity.",
      "matrixEmptyTitle": "No client matches the filter",
      "errorTitle": "The current state could not be loaded",
      "errorBody": "Try loading it again. Stored data was not changed.",
      "conflictTitle": "The data changed",
      "conflictBody": "Load the latest state and repeat the decision using the current version.",
      "offlineTitle": "The request could not be sent",
      "offlineBody": "This looks like a lost connection. Check the network and repeat the action. Nothing was saved."
    },
    "queue": {
      "materialReview": "Review and publish: {material}",
      "materialFeedback": "{material}: open comments ({count})",
      "waitingOnClient": "The client is waiting in {phase}",
      "clientBlocked": "The client has been waiting in {phase} beyond the allowed time",
      "stepBlocked": "Step {phase} is blocked, a required output is missing",
      "stripeConnect": "Add the client's Stripe connect link",
      "callLink": "Prepare the stable link for {phase}",
      "profileResearch": "Profile research",
      "automationRunning": "{subject}: the build is running",
      "automationStale": "{subject}: the build has gone quiet",
      "automationFailed": "{subject}: the build ended with an error",
      "researchFailed": "Profile research ended with an error",
      "researchStale": "Profile research has gone quiet",
      "researchRunning": "Profile research is running",
      "betaFeedback": "Beta feedback waits for your decision ({count})",
      "videoMissing": "Client is missing the video: {phase}",
      "appPrefillLate": "Prefill is stuck: {phase}",
      "production": {
        "ready": "{phase}: the team needs to prepare the material",
        "draft": "{phase}: the team needs to finish the draft",
        "missing": "{phase}: waiting for {prerequisite}",
        "approval": "{phase}: waiting for approval and release of {prerequisite}",
        "working": "{phase}: waiting for production of {prerequisite}",
        "failed": "{phase}: blocked by failed production of {prerequisite}"
      }
    },
    "material": {
      "strategy": "Sales strategy",
      "plan": "Sales strategy",
      "salespage": "Sales page",
      "emails": "Emails",
      "webinar": "Webinar",
      "avatar": "AI avatar"
    },
    "phase": {
      "home": "Setup",
      "onboarding_call": "Intro video",
      "q1": "Buddy questionnaire",
      "knowhow": "Know-how",
      "training": "Training",
      "beta": "Beta",
      "marketing_call": "Marketing video",
      "q2": "Sales questionnaire",
      "sales": "Sales materials",
      "stripe": "Stripe",
      "handover": "Handover",
      "app": "Mobile app"
    }
  },
  "rail": {
    "mobileTitle": "Your journey",
    "chapters": {
      "buddy": "Building your Buddy",
      "sales": "Preparing the sale"
    },
    "labels": {
      "onboarding_call": "Intro video",
      "profile": "Your profile",
      "apple": "First app steps",
      "q1": "Buddy brief",
      "knowhow": "Upload know-how",
      "training": "Buddy training",
      "beta": "Try your Buddy",
      "feedback": "Send feedback",
      "marketing_call": "Marketing video",
      "q2": "Sales questionnaire",
      "strategy": "Sales strategy",
      "salespage": "Sales page",
      "payments": "Payment setup",
      "app_questionnaire": "App questionnaire",
      "emails": "Email marketing",
      "webinar": "Webinar structure",
      "stripe": "Connect Stripe",
      "handover": "Handover",
      "salespage_publish": "Publish sales page",
      "app_release": "Release app"
    },
    "steps": {
      "onboarding_call": "Watch the intro video",
      "profile": "Tell us more about who you are and what you do",
      "apple": "Create your Apple Developer account",
      "q1": "Buddy brief",
      "knowhow": "Upload know-how",
      "training": "Buddy training",
      "beta": "Try your Buddy",
      "feedback": "Send feedback",
      "marketing_call": "Marketing video",
      "q2": "Sales questionnaire",
      "strategy": "Sales strategy",
      "salespage": "Sales page",
      "payments": "Payment setup",
      "app_questionnaire": "App questionnaire",
      "emails": "Sales emails",
      "webinar": "Webinar",
      "stripe": "Connect Stripe",
      "handover": "Buddy handover",
      "salespage_publish": "Publish sales page",
      "app_release": "Release the app"
    },
    "completion": {
      "onboarding_call": "Done when you watch the intro video to the unlock moment.",
      "profile": "Done after you review the profile and confirm it with the button below.",
      "apple": "Done after you confirm that your Apple Developer account is set up.",
      "q1": "Done after you submit the questionnaire and all answers are saved.",
      "knowhow": "Done after you submit the prepared know-how for training.",
      "training": "Done after the team verifies training and opens the test version.",
      "beta": "Done the first time you copy the tester link.",
      "feedback": "Done once we hand the instance over to you.",
      "marketing_call": "Done when you watch the sales video to the unlock moment.",
      "q2": "Done after you submit the sales questionnaire and all answers are saved.",
      "strategy": "Done after you approve the sales strategy.",
      "salespage": "Done after you approve the page, add your order links, and either download or publish it.",
      "payments": "Done when the team has set up your payments and verified them with a test purchase.",
      "emails": "Done after the team publishes the finished emails.",
      "webinar": "Done after the team publishes the finished webinar structure.",
      "stripe": "Done after the system verifies that you can receive payments.",
      "app_questionnaire": "Done after you submit all mobile app details.",
      "salespage_publish": "Done after the sales page is published.",
      "handover": "Done when you send us your Telegram ID and confirm your Owner Dashboard opened.",
      "app_release": "Done after links to the app are available in both stores."
    },
    "unlock": {
      "onboarding_call": "Opens after you sign in to Launchpad.",
      "profile": "Opens once you play the intro video. You review it next.",
      "apple": "Opens at the start of app preparation. You create the account.",
      "q1": "Opens once you play the intro video and confirm your profile. You answer next.",
      "knowhow": "Opens after the Buddy questionnaire. You and the team add the sources.",
      "training": "Opens after know-how is submitted. The team prepares the next step.",
      "beta": "Opens after training. You try your Buddy next.",
      "feedback": "Opens after handover and your first test. You add the feedback.",
      "marketing_call": "Opens after beta testing.",
      "q2": "Opens once you play the marketing video. You answer next.",
      "stepLockedLead": "This step opens once the one before it is done. Nothing is broken, you are simply not there yet.",
      "strategy": "Opens after the sales questionnaire. The team prepares the proposal.",
      "salespage": "Opens after strategy approval. The team prepares the page.",
      "payments": "Opens once your sales page is approved. The team sets up the payments.",
      "app_questionnaire": "Opens once the sales page is approved. You add the details.",
      "emails": "Opens after strategy approval. The team prepares the emails.",
      "webinar": "Opens after strategy approval. The team prepares the structure.",
      "stripe": "Opens during sales preparation. You finish the connection.",
      "handover": "Opens once all sales materials are approved. You then finish both handover steps yourself.",
      "salespage_publish": "Opens after page approval and the order links. You choose how to publish.",
      "app_release": "Opens after the app is submitted to stores. The team confirms the result."
    },
    "unlockPreparing": {
      "knowhow": "The team is preparing your know-how folder and the link document. Once they are ready the step opens and you add your sources."
    },
    "lockedPreview": {
      "onboarding_call": {
        "1": "The intro video that walks you through the whole journey",
        "2": "A player that unlocks the step once you have watched it",
        "3": "A direct handover to your profile right after the video",
        "owner": "You",
        "when": "Right after your first sign in"
      },
      "profile": {
        "1": "A map of what we found about you in public sources",
        "2": "A microphone to add and correct things in your own words",
        "3": "The profile confirmation the whole Buddy is built on",
        "owner": "You and the BuddyPro team",
        "when": "After the intro video"
      },
      "apple": {
        "1": "A guide to opening your Apple developer account",
        "2": "What to prepare and what to avoid during registration",
        "3": "The account confirmation the app preparation follows",
        "owner": "You",
        "when": "At the start of the app preparation"
      },
      "q1": {
        "1": "Questions about how Buddy should speak and who it answers",
        "2": "Dictate your answers instead of typing them",
        "3": "Continuous saving, so you can split it over several sittings",
        "owner": "You",
        "when": "After the intro video and the profile confirmation"
      },
      "knowhow": {
        "1": "A Google Drive folder for your own materials",
        "2": "A document for links to videos, podcasts and articles",
        "3": "Sending the materials off to Buddy's training",
        "owner": "The BuddyPro team prepares the folder, you fill it",
        "when": "After you submit the Buddy questionnaire"
      },
      "training": {
        "1": "Word that Buddy is learning from your materials right now",
        "2": "When to expect it: 2 to 3 working days",
        "3": "An email the moment Buddy is ready",
        "owner": "The BuddyPro team",
        "when": "After you send the know-how"
      },
      "beta": {
        "1": "The link to your own Buddy, ready to chat",
        "2": "The Telegram bot moving to your own account",
        "3": "Tester invitations and the inbox for your notes",
        "owner": "You, with the transfer finished by the BuddyPro team",
        "when": "After the training is finished"
      },
      "feedback": {
        "1": "A form for notes on Buddy's answers",
        "2": "A way to mark whether a note is yours or a tester's",
        "3": "An overview of the notes you have already sent",
        "owner": "You",
        "when": "After the bot handover and the first testing"
      },
      "marketing_call": {
        "1": "The marketing video on how Buddy gets sold",
        "2": "A player that unlocks the step once you have watched it",
        "3": "A direct handover to the sales questionnaire",
        "owner": "You",
        "when": "After the beta testing"
      },
      "q2": {
        "1": "Questions about your offer, prices and customers",
        "2": "Dictated answers and uploaded materials",
        "3": "Continuous saving, so you can split it over several sittings",
        "owner": "You",
        "when": "After the marketing video"
      },
      "strategy": {
        "1": "Campaign proposal and core sales arguments",
        "2": "Recommended prices, plans and the reasoning behind them",
        "3": "Comments and final approval in one place",
        "owner": "Your launch partner",
        "when": "After you submit the sales questionnaire"
      },
      "salespage": {
        "1": "A real first view of the finished sales page",
        "2": "Content, design and mobile layout review",
        "3": "Comments and approval directly over the page",
        "owner": "Your launch partner and delivery team",
        "when": "After the sales strategy is approved"
      },
      "payments": {
        "1": "Your Stripe connected to your Buddy",
        "2": "Plans and the subscription link from the approved strategy",
        "3": "Order links in your sales page and a test purchase",
        "owner": "Your launch partner and the team",
        "when": "After your sales page is approved"
      },
      "emails": {
        "1": "The complete email sequence in sending order",
        "2": "Subject lines, email bodies and calls to action",
        "3": "Copy each email or the full sequence",
        "owner": "Your launch partner and copy team",
        "when": "After the sales strategy is approved"
      },
      "webinar": {
        "1": "Outline and order of each section",
        "2": "Core ideas and transitions between sections",
        "3": "Sales close and the next call to action",
        "owner": "Your launch partner and content team",
        "when": "After the sales strategy is approved"
      },
      "stripe": {
        "1": "The link that connects your Stripe account",
        "2": "A check that payments really reach you",
        "3": "Your partner's contact when something gets stuck",
        "owner": "You and your launch partner",
        "when": "During the sales preparation"
      },
      "app_questionnaire": {
        "1": "App details for the App Store and Google Play",
        "2": "Uploads for the icon, screenshots and descriptions",
        "3": "Sending the materials off to the app release",
        "owner": "You",
        "when": "After the Apple account is confirmed"
      },
      "salespage_publish": {
        "1": "A download of the finished sales page",
        "2": "Publishing the page in a couple of clicks",
        "3": "Instructions for pointing your own subdomain at it",
        "owner": "You",
        "when": "After the page is approved and the order links are in"
      },
      "handover": {
        "1": "The owner role of the whole instance moving to you",
        "2": "The Owner Dashboard and its access details",
        "3": "Your license key and the instance connection",
        "owner": "You and your launch partner",
        "when": "After every sales material is approved"
      },
      "app_release": {
        "1": "The app's status in the App Store and Google Play",
        "2": "Links to your app once it is out",
        "3": "What to do when a store sends comments back",
        "owner": "The BuddyPro team",
        "when": "After the app is submitted to the stores"
      }
    },
    "notInJourney": "This step is not part of your journey. You have missed nothing and there is nothing to unlock.",
    "lockedNext": {
      "lead": "On your plate right now:",
      "action": "Go to that step"
    },
    "status": {
      "locked": "Locked",
      "blocked": "Blocked",
      "on_deck": "Up next",
      "review": "For review",
      "waiting_apple": "Waiting for Apple",
      "working": "In progress",
      "done": "Done",
      "open": "Open",
      "testing": "Testing",
      "feedback": "Collecting feedback",
      "client": "Your turn",
      "done_ahead": "Done ahead"
    },
    "substeps": {
      "done": "{done} of {total} done"
    },
    "groupBuddy": "Building your Buddy",
    "groupSales": "Preparing the sale",
    "groupSalesLocked": "Opens once your Buddy is trained",
    "groupApp": "Mobile app",
    "appStepApple": "Apple Developer account",
    "appStepWizard": "App questionnaire",
    "appStepPublish": "Store release",
    "appProgress": "{done} of {total} steps"
  },
  "staffOverride": {
    "kindLabel": {
      "profile": "profile",
      "apple": "Apple account",
      "q1_submit": "Buddy brief",
      "q2_submit": "sales brief",
      "knowhow_submit": "know-how sent to training",
      "video_onboarding": "intro video",
      "video_marketing": "marketing video",
      "strategy": "sales strategy",
      "salespage": "sales page",
      "emails": "sales e-mails",
      "webinar": "webinar"
    },
    "locked": {
      "bot_transfer": "The Telegram bot transfer cannot be returned: the bot changed hands inside Telegram and our system cannot take it back.",
      "publication": "The sales page publication cannot be returned: the site runs on the client's own account.",
      "stripe": "The payment connection cannot be returned: it is the client's Stripe account and real money.",
      "handover_close": "A finished handover does not revert: it is a closed business step. Only the open gates before it can return.",
      "app_release": "A released app cannot be returned: it is live in the App Store."
    },
    "nothing": {
      "training": "There is nothing to hand back here: the trained Buddy is approved by the partner, not by the client.",
      "beta": "There is nothing to hand back here: in beta testing the client confirms nothing, they try the Buddy and send notes.",
      "feedback": "There is nothing to hand back here: feedback stays open and the client confirms nothing on this step."
    },
    "noReopen": {
      "video": "A video step has no client approval to return. The client closes it by watching; you can still approve it on their behalf."
      ,"q1TrainingStarted": "The Buddy brief cannot be returned: training has started or finished. Agree the correction with an admin, this step is not the way back.",
      "q2MaterialExists": "The sales brief cannot be returned: the first material was already built from it. Changes belong in the notes on that material or in the briefing for Alex.",
      "q2BuildRunning": "The sales brief cannot be returned while a build is running. Try again once the build finishes."
    }
  },
  "partnerBriefs": {
    "title": "Briefing for generation",
    "hint": "Whatever you write here is binding input for Alex when the sales materials are built. The client never sees these notes.",
    "loadFailed": "The briefing could not be loaded right now.",
    "save": "Save",
    "emptyNote": "Nothing here yet",
    "savedNote": "Saved.",
    "saveFailed": "The note could not be saved. Please try again.",
    "unsaved": "Unsaved changes",
    "lastSaved": "Last edit: {name}, {date}.",
    "scope": {
      "global": "General note about the client",
      "strategy": "Note for the sales strategy",
      "salespage": "Note for the sales page",
      "emails": "Note for the e-mail marketing",
      "webinar": "Note for the webinar outline"
    },
    "scopeHint": {
      "global": "Applies to all four materials: strategy, sales page, e-mails and webinar.",
      "strategy": "Used only when the sales strategy proposal is built.",
      "salespage": "Used only when the sales page is built.",
      "emails": "Used only when the e-mail campaign is built.",
      "webinar": "Used only when the webinar outline is built."
    },
    "placeholder": {
      "global": "What you know beyond the questionnaire: extra facts, your own read, notes or a call transcript Alex has never seen.",
      "strategy": "What the strategy has to watch out for: price, position, the big idea, what to avoid.",
      "salespage": "What the page has to do: proof, objections, tone, what the client refuses.",
      "emails": "How the client writes to their list, what they already sent, what to keep.",
      "webinar": "How the client wants to broadcast, what has to be said, what to leave out."
    },
    "regenerate": {
      "title": "Rebuild from scratch",
      "hint": "For a material that is wrong as a whole and cannot be fixed by comments. Alex builds it again from nothing, using the briefing above and your reason.",
      "button": "Rebuild from scratch",
      "notYet": "The material does not exist yet. The briefing above is used the first time it is generated.",
      "confirm": "Rebuild from scratch: {material} ({client})?",
      "confirmButton": "Yes, rebuild it",
      "reasonLabel": "Why it has to be different",
      "reasonPlaceholder": "Write what is wrong and how it should look. The text goes to Alex as the assignment.",
      "reasonRequired": "Please write a reason. A few words are enough.",
      "runningTitle": "Rebuild in progress",
      "runningBody": "Alex is building a new version from scratch. You will hear from us when it is ready.",
      "blockedBuild": "A build is running on this material. Wait for it to finish.",
      "blockedEdit": "A comment rewrite is running on this material. Wait for it to finish.",
      "consequenceFresh": "Alex starts with an empty desk. A new version appears, not an edit of the current one.",
      "consequencePublished": "The client keeps seeing the published version. They see the new one once you publish it.",
      "consequenceApproved": "The approval of the current version still stands for that version. The client approves the new one again.",
      "consequenceNotes": "Open comments on the current version close ({count}). They stay in the material history.",
      "error": {
        "generic": "The rebuild could not be started right now. Please try again.",
        "nothing_to_regenerate": "Nothing to rebuild: the material does not exist yet.",
        "build_running": "A build is running on this material. Wait for it to finish.",
        "edit_in_progress": "A comment rewrite is running on this material. Wait for it to finish.",
        "regeneration_in_progress": "A rebuild is already running.",
        "prerequisite_missing": "The material this one is built on has to be approved first.",
        "reason_required": "Please write a reason, a few words is enough.",
        "state_conflict": "This material cannot be rebuilt right now. Check the state of the step.",
        "storage_unavailable": "The build line is unavailable right now. Please try again shortly.",
        "forbidden": "You do not have the rights for this action."
      }
    }
  }
}
